<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[
    {
    "num_cand": "U2FsdGVkX18+U4SxX4KtqJy4f/hA4lNvjbwNITdHGsU=",
    "cpf": "U2FsdGVkX1+5/5UDtDAFdAzvYMFvVdyW8sz0IEbwZsA="
}, {
    "num_cand": "U2FsdGVkX19ESc/Z68xH+brg1aQ5NiVkBaSaB1s8E2Y=",
    "cpf": "U2FsdGVkX1/RFyZEzSfcFu+bNZ1TPSrZR24xnv+4ovg="
}, {
    "num_cand": "U2FsdGVkX18DuH4GTkmD0orXvZQ7gncdAv8rx4bb7IU=",
    "cpf": "U2FsdGVkX1+du+/UiwyyyZrKTjYq7zBgzHe1U/Pvv5A="
}, {
    "num_cand": "U2FsdGVkX18ZJa1bPtGRPkthXoieXt4FLEh8hRjMkuI=",
    "cpf": "U2FsdGVkX1++MzTbmypd93u01sNhaCqYWqSb2CcBDgg="
}, {
    "num_cand": "U2FsdGVkX1+9Uqf0GxZmnjZQy+wuemoFuQwNf1+PuaA=",
    "cpf": "U2FsdGVkX19JglYt+251TigWCxx4ccmggFsq+nW/Vq4="
}, {
    "num_cand": "U2FsdGVkX186LhBStzdUHPf3SP4fVXnvb0jckr2SvXY=",
    "cpf": "U2FsdGVkX1+Bv+WIQo3Ggi/Q+tvt4SGPD6SMIoTczKM="
}, {
    "num_cand": "U2FsdGVkX1/ufe23U9j0D3fAj8L9jX6/29PQSrMaObk=",
    "cpf": "U2FsdGVkX19pFpIxLF3gaz1m1QP8qM2v5sVEybtfm0Q="
}, {
    "num_cand": "U2FsdGVkX1/1Dm1H8nZmPPDWai1FnmOGBWlPvDxFq50=",
    "cpf": "U2FsdGVkX18bWKxB9szzz1Ks/pVw5CqV3/c3Lt8Z0Ck="
}, {
    "num_cand": "U2FsdGVkX18Fn/l2jkOLm7xe3nVJWM2SOuMqkXu6/xs=",
    "cpf": "U2FsdGVkX1/Rqfo6SBCyMxiISDHZ43QByw2ySa9zUwE="
}, {
    "num_cand": "U2FsdGVkX19fLrOawePm4wDhw0SAeADtEsePLSzLZGE=",
    "cpf": "U2FsdGVkX1/VtLrcg+YOHmDWyQQULfL6IMuwdrhAYa4="
}, {
    "num_cand": "U2FsdGVkX1/4EFM+X3dy93TRFbJsF6nTr1/f2fk6HPE=",
    "cpf": "U2FsdGVkX18w6vrTW2SRDHCQPj/0dY5AXORBDZ344vs="
}, {
    "num_cand": "U2FsdGVkX18EPNBYHKExd2PtZYHavrpuzcMrkPr6z2U=",
    "cpf": "U2FsdGVkX19aWoEdP4J5Tw8hTCzffvg4s4khOU1q9m0="
}, {
    "num_cand": "U2FsdGVkX18h5YH2kWBz4TRmL2X80na35YK62i1DBos=",
    "cpf": "U2FsdGVkX18PUQPUufbO3j2XHFhJiWTJGH/dxX5dlsw="
}, {
    "num_cand": "U2FsdGVkX19fPjQhQgN5E4jy7gGpj9oy55gNJvMaBZA=",
    "cpf": "U2FsdGVkX19dWxl90rW4+sFS755nZ0uThqsWZTExAdw="
}, {
    "num_cand": "U2FsdGVkX1/6UlUZV38Pzk2Iph3UHVM57QY0RVHsdcs=",
    "cpf": "U2FsdGVkX18k3U3gm+Sq+GKXHqv7A5JxBCA6nlwAAQ8="
}, {
    "num_cand": "U2FsdGVkX1/xgSZa6XEWBFrD9RUUNFAXT1fCpaN3/A4=",
    "cpf": "U2FsdGVkX1/2tPoWjMfcQ3BjxSsJ7oYmxoS+qmJwvt8="
}, {
    "num_cand": "U2FsdGVkX18tJAsQcFO7V0/NtlvnlgP9FEK/viJsyls=",
    "cpf": "U2FsdGVkX1++vsQ/5lfoIizqGBUuNUysCcRX9XzjCkA="
}, {
    "num_cand": "U2FsdGVkX1+63JI4d8ejabh9mhzx2y69ShMofoXoLNs=",
    "cpf": "U2FsdGVkX18ptZI8vuZMcLD6nWUTZwFMWh0Gpu2/fIs="
}, {
    "num_cand": "U2FsdGVkX1/iyTXlvgBkreM7o4bGque7QMkzD/X+3ME=",
    "cpf": "U2FsdGVkX18moOPzUfPVgmbB8b+mHL9TqpVxJ+9n4CM="
}, {
    "num_cand": "U2FsdGVkX1/vd1f+LVFqzN6hv9qiUxJM2GH4KiFIEZs=",
    "cpf": "U2FsdGVkX19xeKbZ0e2Eydfp4N3SB5dKDRE/PFM5/SA="
}, {
    "num_cand": "U2FsdGVkX18yP/+6f1SChO/yA29HZgPs+lUsFzaijjk=",
    "cpf": "U2FsdGVkX1/jhP6OWVFxUiZ+Rz8uK9pLOX72MwgU0Uw="
}, {
    "num_cand": "U2FsdGVkX19D0/B9vUB/1gv5NS9imvNWWjAl/AircsM=",
    "cpf": "U2FsdGVkX18leelN4I4MW7el+A/GKrfjgy0rhBQ3gJ8="
}, {
    "num_cand": "U2FsdGVkX190Dii6NuAP7O6x9957w2Lt4+kJ+7WOZKw=",
    "cpf": "U2FsdGVkX19nuI5xQ/6JWGhxT3Y6P3aw9W7+NZYlSh8="
}, {
    "num_cand": "U2FsdGVkX19qWgipuEUs7QKZ+WhkFnFJU2blE6bbvQY=",
    "cpf": "U2FsdGVkX19iq4b3j7HRSTwdVbYDlO+B6NKLy14/Z58="
}, {
    "num_cand": "U2FsdGVkX19tfjLcsdcj2az8aRdIfsUiuGpWOB2jXVk=",
    "cpf": "U2FsdGVkX18YfohQt8SQumFIpxkZumHzlxJiwxwTIEg="
}, {
    "num_cand": "U2FsdGVkX18nt0Z/u7eVg1CmfLGqVoKquEstvb+Rc78=",
    "cpf": "U2FsdGVkX1+H+GlYFISW6CZtX1NLym2BQAbK3k5URrs="
}, {
    "num_cand": "U2FsdGVkX19DU7Z/RuAaTTdmS4YDrdy6s0P5k6mnQHk=",
    "cpf": "U2FsdGVkX1/3TdJBi5HE5pnTDms6URWKp+52aEXxjT0="
}, {
    "num_cand": "U2FsdGVkX18OPaKLmZSO4+uwYP55KVEFDn6XdsQDHQk=",
    "cpf": "U2FsdGVkX1/rNpB19OIOfRVCWWYZ1hrTP8HJGH5DP68="
}, {
    "num_cand": "U2FsdGVkX1+7P5s10bbZM9mxkgoK/lSkiMge3qdX9nM=",
    "cpf": "U2FsdGVkX19p2mU5KjeTs4UqBY65zMxeFZmTc5BATRE="
}, {
    "num_cand": "U2FsdGVkX18bHpRrU0mnyozIN405pL9GfigIHpuSlYI=",
    "cpf": "U2FsdGVkX1/Aee0bC4QHDVYPQ/jGkNYpfCkv0wGNKL4="
}, {
    "num_cand": "U2FsdGVkX1+vFMXDm4KUMNmSjHNY72oISbOOeve0twY=",
    "cpf": "U2FsdGVkX1/VAvGnBq2LOnlC5i8Hx9gQduRa4AJ+i/c="
}, {
    "num_cand": "U2FsdGVkX1/4nHQYecYwH6W5a6KOsfufqZOOwmat6s0=",
    "cpf": "U2FsdGVkX199AXrqZ4vamahPdHsLc7m84DcTDVJ2rfI="
}, {
    "num_cand": "U2FsdGVkX1+4EO725Irdg9wcBb9G2C5vw9slHN2vpgg=",
    "cpf": "U2FsdGVkX19O92b09fdYE+9dYy5lobF4KsZXzjfAjkY="
}, {
    "num_cand": "U2FsdGVkX18/G01pCuywSIGv3JUoIyOhizXTz5OSm9U=",
    "cpf": "U2FsdGVkX18ozrkwFcck0ryNx85J/D6UCUEud1T0/yw="
}, {
    "num_cand": "U2FsdGVkX1+MFZjsiAa4ieV/nKLd5Uxw41fp0xU7k4E=",
    "cpf": "U2FsdGVkX1/aRV5jx3oaISGJ8a3mhocQdi4rH5vtymM="
}, {
    "num_cand": "U2FsdGVkX1+HFoTEs7x8QStzfEGKMzzbDF1vmkSSfnM=",
    "cpf": "U2FsdGVkX18+nAPk8LKXkb32BThT6nKec4XF7Jq9sgo="
}, {
    "num_cand": "U2FsdGVkX1+F2kYfw0VZ+LfYyzOpERo9NVXA8VGaPM0=",
    "cpf": "U2FsdGVkX1/NdYHyp/RqZLiW/K4xGka11wm2vFwWZaU="
}, {
    "num_cand": "U2FsdGVkX1/1Ti94zxa4J8T8aW95JjqnGeYnrbYrxIk=",
    "cpf": "U2FsdGVkX1+L94Pi0GJj4LrMBjeDPg49y2zQxKehISw="
}, {
    "num_cand": "U2FsdGVkX1/0NNmZDkU/KkesdzLiesMFbq3H6uOp9QE=",
    "cpf": "U2FsdGVkX18YMXZ894+79wKAniMDvmQET7pncP+Dykc="
}, {
    "num_cand": "U2FsdGVkX1+OQQwQmt+AT9laA0PIJfAqD0L5kViiiak=",
    "cpf": "U2FsdGVkX1+6OmgHtckNvIW+zdKBuCGxzIWfYst5IYI="
}, {
    "num_cand": "U2FsdGVkX18xZ7vqC0KFZ7EH1N0Xl0e2G35uFxPpnAg=",
    "cpf": "U2FsdGVkX1/bN+OOwKxmasiMq9S5OQJM0GBqjDFb9Gk="
}, {
    "num_cand": "U2FsdGVkX1/cQ3kIeD0d0XuF951Al+g2XxfxW70NPyI=",
    "cpf": "U2FsdGVkX1/A5K29Qi6GPYXSoTrjftOvcHBofN+vevg="
}, {
    "num_cand": "U2FsdGVkX191cV9xM2V5vL7GcIcUpDvTZi2O/92trt4=",
    "cpf": "U2FsdGVkX1+kune+nFHqgliM+ivC8+guuQQgrBVt8cU="
}, {
    "num_cand": "U2FsdGVkX19/KVQF7X5Y6VluqxxLb6mmOnN8K+hkFRA=",
    "cpf": "U2FsdGVkX18TiLQPoP9bZwEhl/iJHvPA7y/n8Eh9YsM="
}, {
    "num_cand": "U2FsdGVkX1+YI+3DbWObH8VAcsjwtRfdnWaC/GK5owM=",
    "cpf": "U2FsdGVkX1+yAZ3IQQueRiOgM87DMOcNaA4jQf3XV68="
}, {
    "num_cand": "U2FsdGVkX19hDL8wdkLpexWSdzmvkmtmOmEy+a/rT84=",
    "cpf": "U2FsdGVkX1/VzuUMOYCjUaUWz3KOSefk2EYYk2IAV98="
}, {
    "num_cand": "U2FsdGVkX19Hwdwv+yomwZ6O7YeWpQbh7OLZZacXO+Q=",
    "cpf": "U2FsdGVkX1/d6lpuPHgHA1DLmAo8aqhK3ZmCWg7Qu/U="
}, {
    "num_cand": "U2FsdGVkX1/7qdZyhRlwxg2JEUfZ586YcqMXFnso28U=",
    "cpf": "U2FsdGVkX1++962DoJdRqCoPtZ/VJNVcFOV6HdNKI4w="
}, {
    "num_cand": "U2FsdGVkX19WZnRaGC/ulS2kX+6xI2kEm71+YDV57i8=",
    "cpf": "U2FsdGVkX18ABvPI/i/qRqmFcVj4M681jnERJlge8dw="
}, {
    "num_cand": "U2FsdGVkX183Oz5EmaV1xiX0tnWKCb4PuJbryGfQP7E=",
    "cpf": "U2FsdGVkX1+A+6XsfIzT4AIfOL30La0tjRptiUlLpI0="
}, {
    "num_cand": "U2FsdGVkX1+9owYlZy97AtvNsnCgX6J303PHwoH5yEk=",
    "cpf": "U2FsdGVkX1+owi+chmSdA3CMYWPDTOr6bTm4wBxnujM="
}, {
    "num_cand": "U2FsdGVkX19N8DbLqE8U7vTkW1/pFL9KgFYU4tcdwa0=",
    "cpf": "U2FsdGVkX1++a70ZklBX875ddQwIkW+LP85v2faf4+o="
}, {
    "num_cand": "U2FsdGVkX1/hXz5jDfSCw67giPxjWrRsbIttfEYGUr0=",
    "cpf": "U2FsdGVkX1+m6EhTXO1LbkeZRPWR8DZK5JmGrC3Jg5o="
}, {
    "num_cand": "U2FsdGVkX1/qIUJjRm8i26mmj5oUNiSjYRJuP3c2Aw8=",
    "cpf": "U2FsdGVkX1/Zizsgj3JlCWePZAPmguzLU6Le38CuYuM="
}, {
    "num_cand": "U2FsdGVkX1815aUPg074RpDKbfi3AnMolOCSKj+HyEk=",
    "cpf": "U2FsdGVkX1/QtyeHGvoAzTsovScIlw0nlzEBK1ue8gU="
}, {
    "num_cand": "U2FsdGVkX1+5dna4lK4Idc5lbM4QdGnSIhmToBswpew=",
    "cpf": "U2FsdGVkX18EMHanmgQF065sW6V1ZMPZkk6G0JJWZOg="
}, {
    "num_cand": "U2FsdGVkX1/JED9q9oHw3iTI0T2oziJ7sN7AeAMTQ/c=",
    "cpf": "U2FsdGVkX1/5IDkVwwtLccvxzq7ZWdFX1W5UHNv5K20="
}, {
    "num_cand": "U2FsdGVkX1+aqYQEr7uHC35y6vkQOsHZhM64yf5nC4g=",
    "cpf": "U2FsdGVkX18Mf5NeQ/sblOw72OJcPqbemdPvpjJbN+o="
}, {
    "num_cand": "U2FsdGVkX18ZZSMbWogB0s6IRTZA8+d5ISYBACDYGc0=",
    "cpf": "U2FsdGVkX18Q1kvaG6U+nRAjE0aEfjtl5AF8zPmfJYQ="
}, {
    "num_cand": "U2FsdGVkX1/9di94PS2HJSFC1qBxuQzKXc3m+Wxtbo0=",
    "cpf": "U2FsdGVkX18MRIVCxF9zmy9whRFrOkXYJu5/we+Ctj4="
}, {
    "num_cand": "U2FsdGVkX1/TqNLDNEJPtlhUqK8ocRhYxjF6G33WhX0=",
    "cpf": "U2FsdGVkX1/CuF6mfqh8fuIlEiyUBlyXHY3vWKoG6y4="
}, {
    "num_cand": "U2FsdGVkX1+hTDN3hrcgmIrgSFjj2aUeqp/KN81gCBU=",
    "cpf": "U2FsdGVkX18p4BfH0QUByne4msHUwlEPWvgd1iGJdYA="
}, {
    "num_cand": "U2FsdGVkX19lrF7eQFkhyCWMShpLhWbccLsq96EE6f8=",
    "cpf": "U2FsdGVkX183LgaI88jzrFN86nLE1jIqzyaodS3xPng="
}, {
    "num_cand": "U2FsdGVkX18X9lW3ULGtMs7jmX3PyFbaf+gax7Tveww=",
    "cpf": "U2FsdGVkX1/M/ovzSWlKQyT41kIW1ORTqTtuCo4HTbo="
}, {
    "num_cand": "U2FsdGVkX18hdIypnAGj6afXTy+n3oJUo2scr1+Ze5o=",
    "cpf": "U2FsdGVkX1+YbwR48390OOYUAV/9wzLki3VmvHWvFa0="
}, {
    "num_cand": "U2FsdGVkX18XwmhKJtnEotieAiQrhSq5u9LP6t2YZ3s=",
    "cpf": "U2FsdGVkX1/2pF5CYWq5BYh1rcUZsSDP/bPdoiYDfLM="
}, {
    "num_cand": "U2FsdGVkX1/vhz1o7863uHzVKCbXgBJgQUUGvU93jAs=",
    "cpf": "U2FsdGVkX1/3e5VJnKUvedCKiqXicH9BF4kTD0WC4eo="
}, {
    "num_cand": "U2FsdGVkX1+zD8/fZC8vUu8q4MG2d00ybPFX8CqRcjU=",
    "cpf": "U2FsdGVkX1+H/7i8+YKcvmt5nEXAA/68sMHRTGcrEho="
}, {
    "num_cand": "U2FsdGVkX19flGFDRbzOUc8Ucp2WKFzef/Sc0MgDE1U=",
    "cpf": "U2FsdGVkX18dRFscYW2sMi9G9Yi9Gg5gS2DnYVlO8s0="
}, {
    "num_cand": "U2FsdGVkX19lbO+TEFjh1uO66bgfvTRn7mCyIhL/S3Q=",
    "cpf": "U2FsdGVkX19XKglFEVZdnsan3VY29PsbYw/aCYNFX/g="
}, {
    "num_cand": "U2FsdGVkX19Oqi30Jkosc9/UFsm2T2QW8F47BKR90OE=",
    "cpf": "U2FsdGVkX19lnNFsWR9e9x+oeWDEjXSQSHGMkQhSQQE="
}, {
    "num_cand": "U2FsdGVkX1/NnjCSOKJWLt98Oepqf1ElM74KgziXN08=",
    "cpf": "U2FsdGVkX1+cJnVoXLSUyhsARlpwF8jQ+8K1KBrCTFo="
}, {
    "num_cand": "U2FsdGVkX1+DrpHK/2GT5gEcvuZpAjKfSnD6Mht9BVA=",
    "cpf": "U2FsdGVkX1/4kIDIQdnStpgSgFWvaIGw6FCvEt0/N78="
}, {
    "num_cand": "U2FsdGVkX1+l3QHVMHkDsgOdxJdsoeHImavsgwq31PU=",
    "cpf": "U2FsdGVkX19QIiEGquIFRNeuQ9nwO6fcJJeP3keMPSo="
}, {
    "num_cand": "U2FsdGVkX1/b2LTjIZ7RaaZ3JnKh9yzi+SnADU5QZ3Y=",
    "cpf": "U2FsdGVkX19QpwAv4PGcHfSCv1Qp4I3Xfc11uRZjRLs="
}, {
    "num_cand": "U2FsdGVkX1/GXXeioEuh/OL5yGaTfLNBa/WD+bWpfms=",
    "cpf": "U2FsdGVkX18RyuKtssmEgssFmFn5R6tBvcIlG0bBAxA="
}, {
    "num_cand": "U2FsdGVkX1/UL0e56lUG35gfVyXrr7b5paR1PhQQxB0=",
    "cpf": "U2FsdGVkX19CeDB/7cawG1IGUl414eLtDGMPikgyxTo="
}, {
    "num_cand": "U2FsdGVkX18FH/tM1dwXLBqJLDnFKJYPHuRS414CjIk=",
    "cpf": "U2FsdGVkX1+YvKyxNm9XMk9LJa9MkX1Tvm8M7LAAoAQ="
}, {
    "num_cand": "U2FsdGVkX18u807ljcOL2z4/d1wGBiiKaKz9wCpWxYM=",
    "cpf": "U2FsdGVkX1+hBsmWedsT5Dv6wiNp4V4D12VgtF7dz6E="
}, {
    "num_cand": "U2FsdGVkX1/6OjjBo3Vrs3nxuDNyPJ1Aimjw+5gHcYI=",
    "cpf": "U2FsdGVkX1/ilaboNvsbx/VhGTX7N/h8daXZgeKhmGc="
}, {
    "num_cand": "U2FsdGVkX19MfGgTeEPbyoqAb2xZrnVfHOgwOHchmDE=",
    "cpf": "U2FsdGVkX18o6MHXTzODjVu6GQ5+oR/oCUbS5/ERMDc="
}, {
    "num_cand": "U2FsdGVkX1875F8eGHdUkWUBVjiLos7GHyrPNh5xwt4=",
    "cpf": "U2FsdGVkX1/zdygSLObK2Tfl0jkgqaYYmVg/aIllSHg="
}, {
    "num_cand": "U2FsdGVkX1+iNVZXB+6R35H0aXAFU+6nRtivf0k17yo=",
    "cpf": "U2FsdGVkX18rvVIWXHqp4KFhvBt8/CgjZR0xfu5TH1Q="
}, {
    "num_cand": "U2FsdGVkX18GwhAhv5LkH9pJZzY6olCV51xuQwSsEi8=",
    "cpf": "U2FsdGVkX19LIbVBF/lxKlKf5I9eTY96joqxIPEkk4I="
}, {
    "num_cand": "U2FsdGVkX1/o3l0ZJzUHSuDE2NgpcdnGRQ3J5m82KYc=",
    "cpf": "U2FsdGVkX1/CBjmKLakgJY0a/qmmPOyT8q8ZkDOH870="
}, {
    "num_cand": "U2FsdGVkX18LP82eaTBECqy/NXRoN3X1SC96KtEzC/Y=",
    "cpf": "U2FsdGVkX1/O/7lOnBqWokdHKdgbKkqBCtoyO3oj008="
}, {
    "num_cand": "U2FsdGVkX1+R/YnM7BdvNFOYrrcfne0WGEaJ1OWY1/Q=",
    "cpf": "U2FsdGVkX1++MlkE2RSY1/WjHbYIvzcvCoA2PFq/nL8="
}, {
    "num_cand": "U2FsdGVkX1+AHcIFI77gE8NZ6yRpvr9RZ9EPJ678n38=",
    "cpf": "U2FsdGVkX185hzaUoXsMcPLQkSqvFzkJAD0d2fhybqc="
}, {
    "num_cand": "U2FsdGVkX1/YK7X8fhYeyUmK8pTxOyC5X9KN6WEmz6c=",
    "cpf": "U2FsdGVkX188Pv0L+TjBTYIZXgAdIPIpKZgb9zpfAPQ="
}, {
    "num_cand": "U2FsdGVkX1+IntLJZLy9AnAiMf6V4wWgb5OPsHtIM6U=",
    "cpf": "U2FsdGVkX18C9FSzdhZdN0GABRRxKVCSHQnsq8G7MHc="
}, {
    "num_cand": "U2FsdGVkX18bZhPLXUJ04YyI8fNTLlIlYz9bA7dkPRU=",
    "cpf": "U2FsdGVkX19PilLTOuJGzt6bj5ozWbIly7qwwkresvw="
}, {
    "num_cand": "U2FsdGVkX199YI2OjnOAIt9LxdXssVS6WI4/wFPxOs8=",
    "cpf": "U2FsdGVkX18maMgswxZou61w33YJZE20U+fpblwb0hY="
}, {
    "num_cand": "U2FsdGVkX1/k3gYFJC7pbjfdM3YMjr4lQTTlLa+91o4=",
    "cpf": "U2FsdGVkX1+MhEURL4LfjODg1PqsIwgXMpGt4X58gjI="
}, {
    "num_cand": "U2FsdGVkX19QSXtMXvKMvIhG1WnCrlQ3mMPwfgspz2M=",
    "cpf": "U2FsdGVkX1/tbvRlPhFUMfmyKf4pR5XFUWtUwqhjEsU="
}, {
    "num_cand": "U2FsdGVkX18SKRmEZm2lgEKSLeVo6APDORZL2fXHR/I=",
    "cpf": "U2FsdGVkX193cnbgMWwqrLw+ODolExmeX1tfQgS8ldI="
}, {
    "num_cand": "U2FsdGVkX1/fh71QZwRbxNi5Qf2uX3gSHCbuf4X9u9k=",
    "cpf": "U2FsdGVkX1+WxCwDYcEZ/aNZKEAV4QhgsUMUu/1z7bs="
}, {
    "num_cand": "U2FsdGVkX1/tdlzfHzuRyvRuVp6Fa32IKQmlu8CiNPo=",
    "cpf": "U2FsdGVkX19XfD2x/FUkYYIBPU9+SPxt1rZz51ZfM3s="
}, {
    "num_cand": "U2FsdGVkX1+EgnZqXA5/F+4nWsMP38LdlXHfskYSo8k=",
    "cpf": "U2FsdGVkX18D9qCi3RrvZWDN7+w411OoBIihZqqJfSM="
}, {
    "num_cand": "U2FsdGVkX19KRcXw2BEnbApK0nA9+qLYiN/gu2h6w1o=",
    "cpf": "U2FsdGVkX19MdW0/iVnZA93NYM06FiyOyIQXo50dl+o="
}, {
    "num_cand": "U2FsdGVkX19zhK5r+ub7SUToO5iv+WvTqyhxtrcV5tQ=",
    "cpf": "U2FsdGVkX18KZrIAu3xy34gKP73FIzh5q7lvrQLAxkA="
}, {
    "num_cand": "U2FsdGVkX197bKC2/xH95sj3H6wS8vioQa/9cgfwce4=",
    "cpf": "U2FsdGVkX1+z8N61B95QRqQboM2tI7u1PqyEyljoWfc="
}, {
    "num_cand": "U2FsdGVkX1/JQaeb6SMJLg0VGvmclUu47/KPc9EtP3o=",
    "cpf": "U2FsdGVkX1+EEbkyFIXfSRhfT3rdGOQ/H3pGq1vGEw0="
}, {
    "num_cand": "U2FsdGVkX19lJ7tXczQwQS0n5cIpg1W28bLN1WDa1vs=",
    "cpf": "U2FsdGVkX1+scrhstA6a0gMg0bOlI1jJzQQxb/52BPg="
}, {
    "num_cand": "U2FsdGVkX186cmfqQ3sNgvton+tXSkDS86f2UP/Mh/w=",
    "cpf": "U2FsdGVkX19OgdygFUiU5uW6CFsJ+t6MBs7VfTpLDlQ="
}, {
    "num_cand": "U2FsdGVkX1/eERxDdHMR4L598umhtpfu9PeMLInxd98=",
    "cpf": "U2FsdGVkX19cvDOfa+kyMWbJ4jWsyb05x8HTrwbyC7g="
}, {
    "num_cand": "U2FsdGVkX1+Crni2HGfiCrM1Mq43IOkZcwseMpvvT+Q=",
    "cpf": "U2FsdGVkX1+bpsVZFJhwzGLOVsmMRaV+jlIk3aIYKyY="
}, {
    "num_cand": "U2FsdGVkX19sdQLcfELHXzAzSQrFrBIguz3KiaEEyNk=",
    "cpf": "U2FsdGVkX18LM43Y1HxZurEPkKpqBgOHg8xS3NC5WvE="
}, {
    "num_cand": "U2FsdGVkX18NyuKWbSG1//YcGgHy3lO5r5R675Xpdz0=",
    "cpf": "U2FsdGVkX1/kY1D8SNHfki2M/E6PN2j1/fsEn3OJHIk="
}, {
    "num_cand": "U2FsdGVkX18Sb+Q6zlajS3obErU39Jikkh8ehw/OpYg=",
    "cpf": "U2FsdGVkX1/+Ed7Z8ic629w/KhG3z97ek4NSqrJxN3o="
}, {
    "num_cand": "U2FsdGVkX1/8lh5c6OItIyqRxcIIO/RLR3Tt5eld2Yo=",
    "cpf": "U2FsdGVkX19AILrgnaOoW+1P2+7/mbeHRorllvxgljg="
}, {
    "num_cand": "U2FsdGVkX18XElEZFSkREDmSfm5HKWm8VtnIVztfKDo=",
    "cpf": "U2FsdGVkX1/uHEWXAA/F7vm0gXAim7GfGH8CXG9p22s="
}, {
    "num_cand": "U2FsdGVkX1+VOF4sdc72V0gCXlWQFGXh3lmW2cqZ8TE=",
    "cpf": "U2FsdGVkX19yi3qJbV9JmQFN7h6iZABR7Gi+RI/XW74="
}, {
    "num_cand": "U2FsdGVkX19tslIQnl5F5Zj1uPuR5JhOlO785aaMSGg=",
    "cpf": "U2FsdGVkX1+k/HRahzIE2AE1HktDipfSGZkkP81hmEc="
}, {
    "num_cand": "U2FsdGVkX1953uCpGzBruOnIaMlJ0lc6MWtOmGzwyKI=",
    "cpf": "U2FsdGVkX1/z2P35FQsC4KQae3RhR2zmo8Hpei/5Iwo="
}, {
    "num_cand": "U2FsdGVkX1+TH36A/u2GKYXZOpRwNeDvbUH31q+vU/E=",
    "cpf": "U2FsdGVkX19564zNul2iXYWjuEyaiuqHfg/hdwdA0h8="
}, {
    "num_cand": "U2FsdGVkX1/H/v7GDDI/y3O9G58twMcIVRFjbbR6H9o=",
    "cpf": "U2FsdGVkX19Iq1+AI9f1AyYIqzbERaqE+iMH83ES4YY="
}, {
    "num_cand": "U2FsdGVkX18NjoX2/IsylHEEecIIsz+/GWA3eZGIWIY=",
    "cpf": "U2FsdGVkX1/Dawii93kMt1OM5/Wkvv3uX4AMwEJLIzo="
}, {
    "num_cand": "U2FsdGVkX19iQ3gN0Sn7t1v7CRX8jccOWGxXavtp12Y=",
    "cpf": "U2FsdGVkX1/5XguwNlj8ioReeEyyT4QtLnOaO39gYcI="
}, {
    "num_cand": "U2FsdGVkX19i84PCe1tnhuqGeHvIFEwoeTihUEBaHxE=",
    "cpf": "U2FsdGVkX18zoswzKIGt9UNAfUulWRaDyBNxMW8Q1io="
}, {
    "num_cand": "U2FsdGVkX187SxGlZYuwmMbqxFmD46dJEOKGINo4vqI=",
    "cpf": "U2FsdGVkX1/JCxXhJPbxco2mJZD9Hxf7vduuMArs1qs="
}, {
    "num_cand": "U2FsdGVkX18F7WLss585zSp3MlWVw/aHSs1j0teGcmI=",
    "cpf": "U2FsdGVkX1/JuKW6wftQ6wlOLJg3KteiVev3ySmLz4k="
}, {
    "num_cand": "U2FsdGVkX19oMZ7fO8OtTcf6yUD+iqo4q7Nq/sq7DxA=",
    "cpf": "U2FsdGVkX1+WRD0uijaOLpIUJZ6IK56bRNwozWhnoPE="
}, {
    "num_cand": "U2FsdGVkX18z1RlBYjE7M2vJQahG5dRjIxwQWzvasRE=",
    "cpf": "U2FsdGVkX18Dq/7PtynJz4Sl8EnkFkMuwaffzxusSy4="
}, {
    "num_cand": "U2FsdGVkX1+I6wRraeMk9XOkKPdDRHEpkiMLA695oSc=",
    "cpf": "U2FsdGVkX1+aTQSVAHVwokGpFTlYIcdX235xtbQcoJw="
}, {
    "num_cand": "U2FsdGVkX19OMMbI2wvI5LC8N1n4DdyS8DRbth+xftU=",
    "cpf": "U2FsdGVkX18cBE6fJcyNgI+XyUTKD5pMY77rycFIxJE="
}, {
    "num_cand": "U2FsdGVkX1+cmLnmLnA99/xRYLLZUncIgmKuAaCsFj4=",
    "cpf": "U2FsdGVkX19msOaCzFm7oS6IAE4OlGetRJ12E8pNBFc="
}, {
    "num_cand": "U2FsdGVkX187VBUcgHnaMYq8QLTtSB744Vk6b9H2Ojk=",
    "cpf": "U2FsdGVkX189yjyYASQGVndUVYso8ett8R+M5j7EttI="
}, {
    "num_cand": "U2FsdGVkX197m9ITkkJYaRuszE/EnSJzXNCopi+z3Ww=",
    "cpf": "U2FsdGVkX1+7EMCSCT8GoBS0HThiYyI42I4QVPPH52I="
}, {
    "num_cand": "U2FsdGVkX1/MHTR9lTxX/bGM6zWjxH4R2by9+NPtshY=",
    "cpf": "U2FsdGVkX1+VyAKT61Hl7fn64KEEgvP6CXnWcIMEZdQ="
}, {
    "num_cand": "U2FsdGVkX1/kzXtd21FWX4b4DRw+RL48wnZrBUBsMw8=",
    "cpf": "U2FsdGVkX1+3FXADocrEh5o3gQfja98pEUMLV/y2WzE="
}, {
    "num_cand": "U2FsdGVkX1/0b/hN2j3OnWT8BcOtaRaEGLM625Qix4Y=",
    "cpf": "U2FsdGVkX196uAvwxTC8ySwhrCZI6OW9yaS5J1fomAY="
}, {
    "num_cand": "U2FsdGVkX1+gRqWrwhd8gY2W1om3izxyqwxaJQIeMiw=",
    "cpf": "U2FsdGVkX19EA0Nj/4RrdIPgZT0qkRJFFnszvTg6D3o="
}, {
    "num_cand": "U2FsdGVkX198lWbhVJyOc8tKqqZqEC0YqmqIn52iGkU=",
    "cpf": "U2FsdGVkX1/bD+SHG58UZDOWuHaR59h6o+uxLLKkrDI="
}, {
    "num_cand": "U2FsdGVkX1/ZbAtEg/NGpcLXnt21ipc6GAOp407fszE=",
    "cpf": "U2FsdGVkX1+yJshBcoawB20lZEKwlcD0hIJk+PNesAk="
}, {
    "num_cand": "U2FsdGVkX1/SartNj5gMlzruL4a9CHF7X3a7VlAYSyw=",
    "cpf": "U2FsdGVkX19PNRVj9STiUE3fWuRI4AHtTgh626yuJqs="
}, {
    "num_cand": "U2FsdGVkX1+kda23CHtruFVHJ9aFmULvv9UbPwFUYyg=",
    "cpf": "U2FsdGVkX1+WQngvxlCpdm0GIgn6eyjg1rA3lLwKa5w="
}, {
    "num_cand": "U2FsdGVkX1+IyeRsAPlO91E/FN8bVzxasqHDUAEeeHk=",
    "cpf": "U2FsdGVkX1/cYwOcFhNLfwB/ZmtXS2g4r+LQwOTR7Ik="
}, {
    "num_cand": "U2FsdGVkX18h6QKmvEgl5xLOZTYZI50HlwNAfcgzxLY=",
    "cpf": "U2FsdGVkX19g1R3/VGHcMfumtRtrJJRhcHIlU92rtw4="
}, {
    "num_cand": "U2FsdGVkX1/mx8np+0nWy6Mw6ezuTztEr49MHOCWeOc=",
    "cpf": "U2FsdGVkX19WtEb+/mnDvwxIXpKGREiRGHtXlmoUr58="
}, {
    "num_cand": "U2FsdGVkX1/2or7Tjd92/z1Cvu6hx2YsS0s1A++w+zU=",
    "cpf": "U2FsdGVkX18OdDmvs3iE4H//nu5+pkB+XRoxa497Uto="
}, {
    "num_cand": "U2FsdGVkX19MrKsDxzYfK232NHIYAIZU14fKuFRIXCY=",
    "cpf": "U2FsdGVkX18uRHjt1nUAcZSjc4c4WrGdDJw7QLqLWpY="
}, {
    "num_cand": "U2FsdGVkX1+NHF03Myq6gFPpNU41pfQJrgb1Tq6e1T8=",
    "cpf": "U2FsdGVkX1/U/FIRaTav4z365noX4+xKBQCofljkCXs="
}, {
    "num_cand": "U2FsdGVkX18TNTUWwh+1+S9wdTMGzCIn1cYH6vc/aFE=",
    "cpf": "U2FsdGVkX18KvPYnKLMIsJa8WRs3sKgNXVzEDkk2kOc="
}, {
    "num_cand": "U2FsdGVkX18WRp9mhCSAznKFcRGMSjZQIXbGa3k68n4=",
    "cpf": "U2FsdGVkX1/6bW9jl7cLKRJvYV5srWzMncrlkSRW6Xs="
}, {
    "num_cand": "U2FsdGVkX183+BTpyzNR6X/70lwN+GmX4fBEtMYeDa0=",
    "cpf": "U2FsdGVkX1+Ed21VBIwM9TVexpll7ZBS4VY8TQxi0TU="
}, {
    "num_cand": "U2FsdGVkX1+z0lhNRIJuNZyb4JPu+YwL1Ewv3sFpiTI=",
    "cpf": "U2FsdGVkX1+M1IFKwLVvcSkwpEF5cqhliLeuD/XfVxI="
}, {
    "num_cand": "U2FsdGVkX19G8vYgCHb3cikcp+gRzgUvS05MBw8jUvE=",
    "cpf": "U2FsdGVkX1+LSfph/zVNgtWvPSVsbJb+zJSx3CiEXdg="
}, {
    "num_cand": "U2FsdGVkX19UilEtUCqsOE14mnM9VHK3BGJlqVY3TIE=",
    "cpf": "U2FsdGVkX1/pu5glehSgWl2OJtAbhvm2Z5HIGQ5H/jw="
}, {
    "num_cand": "U2FsdGVkX1+ypAGE2HN7l9Zx9oSHe2UD0Ow4kQ9n73c=",
    "cpf": "U2FsdGVkX1+CFCyTWaBqVUp3X8TTkfFcYZ2cvUTGZMk="
}, {
    "num_cand": "U2FsdGVkX19yry+zBLSM5IfYu1V68ohCjmrIHISTYvU=",
    "cpf": "U2FsdGVkX1+ZUwnxLRSVZPCLwlQF3SIgm5A/rJhiE14="
}, {
    "num_cand": "U2FsdGVkX18M/H/D5w6vWg/L5Kq2LfpX2dI6+bbEBwk=",
    "cpf": "U2FsdGVkX19A3DWemtlMAhDo9KGTEs7U8EDI89XYpEk="
}, {
    "num_cand": "U2FsdGVkX1+tUAFqE34IZWLuznTG0qzdVVNdk94KfWY=",
    "cpf": "U2FsdGVkX1/mKuFDgfSbEV5VIGakGrG3Q5bF6E7cEM0="
}, {
    "num_cand": "U2FsdGVkX19zFWx+irOO08yRGI5zWYK0vBfKth9Bz5U=",
    "cpf": "U2FsdGVkX18WWuS2uvvkhawP1bwHaWBHA9GUH8MClN8="
}, {
    "num_cand": "U2FsdGVkX1+4KsUHdRPpIvRYalPDmcPNu33ujfnK2vM=",
    "cpf": "U2FsdGVkX1+zAqj5SBIW4S/go8kJTDM/Uye+heY63uU="
}, {
    "num_cand": "U2FsdGVkX1/He9Tg6Q2VaQFtSsFfez/6MENMjdlPRLI=",
    "cpf": "U2FsdGVkX186eovqTMQE2YGIuu1Hyj06oNX96VWtpDo="
}, {
    "num_cand": "U2FsdGVkX1/ivb7zqiNKqrazFusuiCdZP2FzGgKINDI=",
    "cpf": "U2FsdGVkX1/6YG9daDiKMgFz08Fm8lOdukOkr6lX9JY="
}, {
    "num_cand": "U2FsdGVkX1/4OuioOCM3tbk0Y6MMLgMhZpVXxZvgqSs=",
    "cpf": "U2FsdGVkX1+BnzJjv706LruUKhaglUYVM5UMywc/UCU="
}, {
    "num_cand": "U2FsdGVkX1+w/dc7xidiuvT2eTv4ICVxvvjCv/dkRa8=",
    "cpf": "U2FsdGVkX19/BXuihQU3V3StUAK+WBY+AIEqf+Hze4s="
}, {
    "num_cand": "U2FsdGVkX1/9QpmQ84qtYXIO1Ux74xx12kEee+v9cpE=",
    "cpf": "U2FsdGVkX1/zZ+VL0rDJamRmLdVW3SS2Y5EIezYg1ps="
}, {
    "num_cand": "U2FsdGVkX19VOWRkVHAIRh/Ht8NeqPKqfIHZ+RtFFiY=",
    "cpf": "U2FsdGVkX1/+zYHSx1obWOLmbwov/FX2JEuAAIBQO88="
}, {
    "num_cand": "U2FsdGVkX183haVz9l79AB8nH6ptoSLXEiFjmLeOkKs=",
    "cpf": "U2FsdGVkX1++wXjKTE4feaRmRhU+I7cLKwq0/CKbCDc="
}, {
    "num_cand": "U2FsdGVkX1+Fsvsn5EvwxGKgquUEMwWeOaQ8smfeYhI=",
    "cpf": "U2FsdGVkX1+9jbZAHgGDg0H6y0NoXqUyq5HkCVPDCU4="
}, {
    "num_cand": "U2FsdGVkX1+6UpajLYQ4WdtleTS2W1sgJrp5Hw+G8DQ=",
    "cpf": "U2FsdGVkX1/e+M4k7dvsfWMWzJVDx91iquaWNKicj3Q="
}, {
    "num_cand": "U2FsdGVkX18pGz16cRBWChVg36mG7SdDCAb7EYQYsso=",
    "cpf": "U2FsdGVkX1/toaBUOlUCIlFZHOR5QZKwWif3h3+DQxc="
}, {
    "num_cand": "U2FsdGVkX1/SYR2ub+F+KCN9CvXZsI3qDXksgjKGHS0=",
    "cpf": "U2FsdGVkX18OdH5WpyxHeEWFqARip9qC25OqMsLkFsg="
}, {
    "num_cand": "U2FsdGVkX1+S3mXVOGggb4Knmy6GbHOQIwivgYXC8ZI=",
    "cpf": "U2FsdGVkX18NqczNIXHi14k9NjYo9+2P0CQKV/RLl9U="
}, {
    "num_cand": "U2FsdGVkX1+ksHDhCYk1BWy1yKQwicxN2EsUfbD3yHs=",
    "cpf": "U2FsdGVkX1/+1ldpUjOzRxx3IWtG2bXlP1fLTdSGHDo="
}, {
    "num_cand": "U2FsdGVkX19zRk38y1vsZ5HfNcJmw31L/dtO9nOKWFY=",
    "cpf": "U2FsdGVkX19Pav34XHBR6GywxFMy6tbgEOEkqigV//U="
}, {
    "num_cand": "U2FsdGVkX1/kEKedJx21uBG7/VoxyTWqj9n5lpruw9s=",
    "cpf": "U2FsdGVkX1/Kj5tdn6Y7yF4yD4IhJDHWctLe9cO1qF4="
}, {
    "num_cand": "U2FsdGVkX1/WgvFvVjAmZVmgaLfxm4HXPnT63jwOIco=",
    "cpf": "U2FsdGVkX1+RGg80JLYZj6oRQjDiMuOPjpVhmHjOhZM="
}, {
    "num_cand": "U2FsdGVkX19/hIKvkZ20BbXdRVEGsV+lG0szjlghsd8=",
    "cpf": "U2FsdGVkX1+DITOXqAQ+2OHBhvBoYkXoKYesOIELB/k="
}, {
    "num_cand": "U2FsdGVkX1+yWkk0VJrOtbhrKN70LEk2qfvdMH77c+4=",
    "cpf": "U2FsdGVkX18SCNmvwD0umg4AKz8H+P8dUfN19gFG2gE="
}, {
    "num_cand": "U2FsdGVkX1/GLm/j6tKLCFNjJM+VrYvrEj57t3l63u4=",
    "cpf": "U2FsdGVkX1/eYTks2JXcaIpDj3eOMlHexclyVs7Doc0="
}, {
    "num_cand": "U2FsdGVkX1+k+w6LycbMitQ8MtJWJwMVdRZ+CXlZAnQ=",
    "cpf": "U2FsdGVkX18MyZNBzvIRZ9t0BWCytxQCvqt1v5+ubLA="
}, {
    "num_cand": "U2FsdGVkX1/MR8rv6TuE0RwANle7IR/q2YT4OeXOInw=",
    "cpf": "U2FsdGVkX1/vSAYVX8bUOJ3oUN0DW0i6g5yLRPunVhQ="
}, {
    "num_cand": "U2FsdGVkX19vUetZkCWIs9qWR+zY5Dn8wv7U1BwTG04=",
    "cpf": "U2FsdGVkX18MQmttJA25zd0l4N3YYIIMO7TCPiMpAxc="
}, {
    "num_cand": "U2FsdGVkX1+IQXfY7ovOanu+y2WgQfxRL9vZPrOP3Yw=",
    "cpf": "U2FsdGVkX19lSRolKHCcmeYp2QiXHRQojmUKcFreZms="
}, {
    "num_cand": "U2FsdGVkX1/6XvLqAfjfqi3a+X9NtmDq7VGcjzciEuA=",
    "cpf": "U2FsdGVkX1/JhgvW2V1geZGgyeWwiexnNI1O/VpJT0c="
}, {
    "num_cand": "U2FsdGVkX19oqi82U1Av4eVtqDCd90c3Bi278MLkchg=",
    "cpf": "U2FsdGVkX1+56WeanA0Q2TyY17iJzx3/ftIYKNuITZ0="
}, {
    "num_cand": "U2FsdGVkX18i3YkQq6pkttVyMc3OEkO3JdswGW/xyzA=",
    "cpf": "U2FsdGVkX196VjkbMmpRJ+KUnzpXZMIX6P5PodlAxSw="
}, {
    "num_cand": "U2FsdGVkX1/pWWBspXZb3u5Na3PhlWJ7cY7rT8YIWRA=",
    "cpf": "U2FsdGVkX1/Clq8krJULbOYXPglbpe9Hp6mRf0g9xs8="
}, {
    "num_cand": "U2FsdGVkX1/NLPL31EVy6oMjOjcPVWftdIjJJkvJ/LQ=",
    "cpf": "U2FsdGVkX18y8LPtu4k0q29q/RF2LibHVtRXNzJR+90="
}, {
    "num_cand": "U2FsdGVkX1/2DpPQdw8OE8KAfNl9lgzZVpuNpvo2PWw=",
    "cpf": "U2FsdGVkX1+efhfg90vAjSy3FIgtW0cJrnU9aYoC6Rw="
}, {
    "num_cand": "U2FsdGVkX1+ppbr8UH4FoKVcKkHprEsNY/ZG5lNxz+I=",
    "cpf": "U2FsdGVkX1+73Aym6okKAQN0M2dng9et4mUbXRCBLsw="
}, {
    "num_cand": "U2FsdGVkX1/eWHXyoCNS5RWaaHo/LZ3h4c4I1UkMDHk=",
    "cpf": "U2FsdGVkX1+y4OjrPzi79PlmgTP3nsUle1D1YoF3M7w="
}, {
    "num_cand": "U2FsdGVkX181hCdBYkwlz9WMtNp+/HiXtHf72/sbjpw=",
    "cpf": "U2FsdGVkX1/X6iRy34TlFnFproPyGKbZ0jhVNlRkWXg="
}, {
    "num_cand": "U2FsdGVkX19Prq4uU8acutBl7KS485yBmNQTRaRkSCg=",
    "cpf": "U2FsdGVkX1/N88Ia6mR/0R/ZZ5b2xRenqo4MZl5/lY0="
}, {
    "num_cand": "U2FsdGVkX1+aUdmzDu5F0ZnSkEoK3HElHS7XlfxoYkQ=",
    "cpf": "U2FsdGVkX19Za2B7ZPeZAuZaIMNl/gbh8Vv4XtPWHDw="
}, {
    "num_cand": "U2FsdGVkX1/kJsvcZjPnAGpY+qPF4CxcLdHipEwKCn8=",
    "cpf": "U2FsdGVkX18NkJ7g88+LPW9FGfNSUkU681IbfuSxTZQ="
}, {
    "num_cand": "U2FsdGVkX18WafuU1/sMho6vkR16WiHqdhlxcHTBTag=",
    "cpf": "U2FsdGVkX18D325xORHjbnPgJzKsNJMLjHAmAiI6zPE="
}, {
    "num_cand": "U2FsdGVkX19LJUGwuT9h9OBQRBeJoEu6QCdLEt1mRIQ=",
    "cpf": "U2FsdGVkX1+eZ5b8yEx63LDcIm5vKegm/ZU7Q14IZLw="
}, {
    "num_cand": "U2FsdGVkX19cogQR3iUZah8iSr05pAGXQmpun23+l9Q=",
    "cpf": "U2FsdGVkX1/0DXoz4iRKUCXIbR6FzO3YA7BEu1SuVJM="
}, {
    "num_cand": "U2FsdGVkX186EdhR6nehPH6kIEiO4su9z3jgtxfKi9A=",
    "cpf": "U2FsdGVkX18ntyT3+vWdWM5mL7D/4G74i0h+6kFT9l4="
}, {
    "num_cand": "U2FsdGVkX1+vMW7lw6HUnZ0fAVPpdc4FSyE1aOihQm4=",
    "cpf": "U2FsdGVkX1/+a0ZU1lPhJWIF/hFLE4jtGX6GDsrkyCI="
}, {
    "num_cand": "U2FsdGVkX19vdTMmzEsfFXAycT4sZ2R/DnTsRRtGnNI=",
    "cpf": "U2FsdGVkX1984AspIz0ZqOh5imrafjjNqoCA7FqOwZ0="
}, {
    "num_cand": "U2FsdGVkX1/oiylDpcLi3q40/zfdF3NznkIAJ2wV8+A=",
    "cpf": "U2FsdGVkX1/wF614Mhym79XB65GMUYcmpNy7rKLmN+w="
}, {
    "num_cand": "U2FsdGVkX1+RL+j0yM9Pl1x+JJrVRmTOMehyUx02g4A=",
    "cpf": "U2FsdGVkX1/w1GQKgn0qCHTM+nhT62Oi+xnH0JIzh6g="
}, {
    "num_cand": "U2FsdGVkX19PLz41WaONDSYEHJH5VRNv1QP1ntoSxjw=",
    "cpf": "U2FsdGVkX18cUWAa/L50bFHirBB/9BLB8sBThzmcenw="
}, {
    "num_cand": "U2FsdGVkX1+J0v6MLl6EzeVwBGf49tfdmmJpU9EtO2M=",
    "cpf": "U2FsdGVkX19crSzKTFHXfVfEB/S3FlyXo9qa5WkIevw="
}, {
    "num_cand": "U2FsdGVkX1/8eOZuJsjtJpSWWZ24J78i2+LgaxYrtW8=",
    "cpf": "U2FsdGVkX1/69gL+oXkmVm6ccl/Y+nDPL45VGc2ckGw="
}, {
    "num_cand": "U2FsdGVkX18eVESCcia0zpzX0sKv0eEq9vapeumD8VE=",
    "cpf": "U2FsdGVkX1/N91Q21BVw8dTeL3huz3UecG+LnvAeuk4="
}, {
    "num_cand": "U2FsdGVkX1+SKiaUEUWgLW+qh8TFOxinyCza2VQatIo=",
    "cpf": "U2FsdGVkX197fLZVu9Ab+w/F4UFKd6MXlkxPABH9g44="
}, {
    "num_cand": "U2FsdGVkX19anjtqTKhU2UOY9RugsVxZGka9OmbOwfc=",
    "cpf": "U2FsdGVkX18fM34kJeecQH1eOOL+yA+wbEz9wr/Q2Aw="
}, {
    "num_cand": "U2FsdGVkX193CkWdlFqzrMmpJMcoRAEI7406P0Z+oJg=",
    "cpf": "U2FsdGVkX18nwdbR1NDhEdBUwAKu02Es2WwWwIdOOr8="
}, {
    "num_cand": "U2FsdGVkX18gOOb4mcNwiD+Fyjb5ES7KaO9Pxgj+yZ4=",
    "cpf": "U2FsdGVkX1+AO/Jb9lT/vSEGTqkP8zexWuoIIJY0/+g="
}, {
    "num_cand": "U2FsdGVkX19gv+YvQA0ckEqHA2y7CI6BK8wZOOus3J4=",
    "cpf": "U2FsdGVkX19GeO2rs8jDO2uySCwKeBuE1rCLKbLlCFg="
}, {
    "num_cand": "U2FsdGVkX18F0JxItiU81yv04b0GAVJ04s24vgWnTXk=",
    "cpf": "U2FsdGVkX18QH1mbkElrKhlO6OPf3UGMFJzzOLpIxnM="
}, {
    "num_cand": "U2FsdGVkX18n11k2c8Mn7jWm2uoCSZTkxryWeHUClXM=",
    "cpf": "U2FsdGVkX18iO6D7hGq5vAitPYza8b1GQCtWBggV/hE="
}, {
    "num_cand": "U2FsdGVkX1/fBBw6Pn+4sCdJghl9hcnAs8qaSLbXDw0=",
    "cpf": "U2FsdGVkX18YGNKmtPCdwlEs3+1Ys4TTVpRFMdTtjoE="
}, {
    "num_cand": "U2FsdGVkX18sX1oclHaiYz4GYMy2EC4vMTqjtoP64rg=",
    "cpf": "U2FsdGVkX18n2P0NIPEyX0wV8+ZZ4Ci+m5Vw4jauu9M="
}, {
    "num_cand": "U2FsdGVkX19woVJFf6303ciOxBA8mXMwDVfcreFScmc=",
    "cpf": "U2FsdGVkX1/cFVVpAAsENvatPna+ubTbLQh9vrE3TI0="
}, {
    "num_cand": "U2FsdGVkX1/U5OC9EMW6WmeMQ3hsf5ORyHiD/91EhJ0=",
    "cpf": "U2FsdGVkX1/C5W9fq001f3MS+W6YDVPm+BSLUxqYE+A="
}, {
    "num_cand": "U2FsdGVkX19pl8jEeefTcBnkSg1GulTUurjCmhe/+3s=",
    "cpf": "U2FsdGVkX1/NHqBwpIMp+EoFStgiFnxCRYDmtYjwC3Q="
}, {
    "num_cand": "U2FsdGVkX1/f/gxEenxB7p8+0Yl6H7wIbDImNSg8MVY=",
    "cpf": "U2FsdGVkX18SxNobnVLUb8hQiFcnbmJNMfvMilHsTEI="
}, {
    "num_cand": "U2FsdGVkX1+MkfT1tgIRuk+Vvr5znTx3UIVkmoG8hEY=",
    "cpf": "U2FsdGVkX1/sjbid0ILGreo2v1hPFyMUiV07Tum94a0="
}, {
    "num_cand": "U2FsdGVkX1/zNNKQYPNgziR4gnOFGGec9EiQpTNza+Q=",
    "cpf": "U2FsdGVkX1/lL1szxpi4mfvf/35sh83IEb2XDhWGhhQ="
}, {
    "num_cand": "U2FsdGVkX19Q6jspXDdWUQGYS55GXPdMW5zSUJKfgwA=",
    "cpf": "U2FsdGVkX18TZ/F9RHDKmYVTd5Lp5uXrouWJGST8Sf8="
}, {
    "num_cand": "U2FsdGVkX19o80c7w1NcGeZ/NMVCxbs11HlG5D4vuQs=",
    "cpf": "U2FsdGVkX199CSYDwPk2nADzK6gx9F+QRhQAQeATABU="
}, {
    "num_cand": "U2FsdGVkX18sKnDbsoJwljqd9gtXxDTIddWOUyqhpuE=",
    "cpf": "U2FsdGVkX1/7Fr01VhOH5Mk1z1uQH6J+n+jdTcUvfyA="
}, {
    "num_cand": "U2FsdGVkX1/xHDw0q2gRomLEcP4Jyi6U/y60b4jb6EM=",
    "cpf": "U2FsdGVkX19oO3fC16aJy5boiPjsDNm0qdIDprfQvWw="
}, {
    "num_cand": "U2FsdGVkX1+Sd7elgG0yTo37xxKFezY4/2v/2G7Ac18=",
    "cpf": "U2FsdGVkX19sLD4jqF34cONnjPtyzw2k4uOg0DSMXSo="
}, {
    "num_cand": "U2FsdGVkX1/P9XEtY1FjKB39fMZaIyQxF9z1z3w4wmg=",
    "cpf": "U2FsdGVkX1+L1+TsgriV6sF25AwG5nHblCMCwpCZDcM="
}, {
    "num_cand": "U2FsdGVkX18hh/h+iIxa2sVu5auGtxnfB8sDU5Q8648=",
    "cpf": "U2FsdGVkX1+6OzGGObXHT+DsdBUZwfbII3+JksKwftU="
}, {
    "num_cand": "U2FsdGVkX19eUyfni5KmhF3/Z7x7AWpIlu4UnB1FEkc=",
    "cpf": "U2FsdGVkX1+rMa6O2L52XXMjHTJUi1MhJJlc7aZ67II="
}, {
    "num_cand": "U2FsdGVkX1+1/6ZEYDoI4dRKmtrMrHfPWwjqR2DLp08=",
    "cpf": "U2FsdGVkX18K2/GDjrLPVoBwYfVgIkICY87djhMErnQ="
}, {
    "num_cand": "U2FsdGVkX1/Fnu0+uMGxuvz8tOBa5uLpjzbCAewmpvU=",
    "cpf": "U2FsdGVkX19dK6KGMgnt1uDOOzuxApvr5lTyA6779vU="
}, {
    "num_cand": "U2FsdGVkX1/jCnjkClasaetgXvOqsr3hbFvtphWkiD0=",
    "cpf": "U2FsdGVkX19K1oI5zi0y+TpUbkrA2YJkSYXI53GNSHQ="
}, {
    "num_cand": "U2FsdGVkX18xM6sFJuP49j0LkcJtgXB/4j4NCIhRoFY=",
    "cpf": "U2FsdGVkX18kOOOQaJR4fv3kbqbbuWSq4oridLqKaQQ="
}, {
    "num_cand": "U2FsdGVkX1+Mh33BKy2e7nvV+AsD0Yn5VkglgGf9+m8=",
    "cpf": "U2FsdGVkX188jUNiWGiJBGeYjfcaSEwEHMHAf5g1xcw="
}, {
    "num_cand": "U2FsdGVkX19eii2lu45Pr0NoVrLSAXGJnUrCr20SenE=",
    "cpf": "U2FsdGVkX1+tvQrsI7zHrb/hKsDKe6v3LlEw+RcSEUI="
}, {
    "num_cand": "U2FsdGVkX18KaxB1+EH6n4HcqrVCfCy/nK9HVeJ/7VA=",
    "cpf": "U2FsdGVkX19y3wDqAhz9HJ0Sv3VBaoAVJYGG+3M+eqk="
}, {
    "num_cand": "U2FsdGVkX1/3ArhdJFiJtUqPzybKw/H1Ln1mZ7Nj1k4=",
    "cpf": "U2FsdGVkX18SkMi+f5WS/xN77Bey6d6l5k/CcxtzrVQ="
}, {
    "num_cand": "U2FsdGVkX19/jJ2r/bDEh15/LOUsp6Mx5WOtmrTGMwI=",
    "cpf": "U2FsdGVkX19ncI1Xy7u1I4+xzKAA0RpzzLiYA/6tynE="
}, {
    "num_cand": "U2FsdGVkX1+vks/cI8lYWrQYe0zNOrp+RLHKZqGUmAQ=",
    "cpf": "U2FsdGVkX1++aq8cEhY/ScMPfzGgCBeQn9T4Nfs6Gls="
}, {
    "num_cand": "U2FsdGVkX188D8eQJ/F2CZMRtuECtdh7KFUf4eGixoo=",
    "cpf": "U2FsdGVkX18J/OC3yqVLkbwfhvvNvYQpQkeBmx7qdl4="
}, {
    "num_cand": "U2FsdGVkX1/rzPFiggoO4pDiJvOWDeurtLYZlnqG4Wo=",
    "cpf": "U2FsdGVkX1+J3qI712mpzhBv9zco8rGDS8LcYRHkq9U="
}, {
    "num_cand": "U2FsdGVkX1+cZAmVlqWkk37C1kWN9n4gf21sqmNaVcg=",
    "cpf": "U2FsdGVkX1+rSCPUVlmw2uw+PEqjiDiWYBtulVDaEp4="
}, {
    "num_cand": "U2FsdGVkX19zvpoxJOzjtMen4fLvBxSCyawf+MaFgtk=",
    "cpf": "U2FsdGVkX1+Fc1S+xgEds9lQo/Dum2XlvEQr3OFsmqk="
}, {
    "num_cand": "U2FsdGVkX1+2jMB1kZmJMCr1Q/mTC67kFTkpXUXMz8g=",
    "cpf": "U2FsdGVkX1+ie0oGiyaU+l4kC16r+NBfI1Ed5Zg1r+o="
}, {
    "num_cand": "U2FsdGVkX1/Zaar+E3TG4Df2ITNgMhiXetG9Q4cOhS4=",
    "cpf": "U2FsdGVkX19l+9MQ2//2TKbMCb5iSrCPafg01xH2MqU="
}, {
    "num_cand": "U2FsdGVkX19brPpU/ouo0w8eC5XtJ4ZHEe6QMJfFjNA=",
    "cpf": "U2FsdGVkX18wZmiQKZo0z7AQ+8wSIhV4MnCFrYw9LLk="
}, {
    "num_cand": "U2FsdGVkX19bKCChXqiByL0zxXM9e5dlbLS6IWC8zqg=",
    "cpf": "U2FsdGVkX1+vSDc5uEfv3uwYOXd2BomXXGFiTYFW+NM="
}, {
    "num_cand": "U2FsdGVkX195P17yOCzvtt2YrDDwG6w+nrfDepOIVEE=",
    "cpf": "U2FsdGVkX1/6oTTIXAJCJJCDzlCXraBT1Mboie3BrdU="
}, {
    "num_cand": "U2FsdGVkX1+ufKnpP5O1LCtcUgq0KYt96B58ej6VoKc=",
    "cpf": "U2FsdGVkX19/1/YGuQpMcTsahnLY7x0yCPe/pgOs1xI="
}, {
    "num_cand": "U2FsdGVkX18SyEzJ+OCjh+7igqX/SxSAhjEO7lKsAvg=",
    "cpf": "U2FsdGVkX1+MtMeMrXZLJhHg+quIp+YgqdLm58MfsWM="
}, {
    "num_cand": "U2FsdGVkX18iJUw7PN+zzrLzlsEnlILj1EC1d2n+Cns=",
    "cpf": "U2FsdGVkX1+V43JzA1ie3YfQLNmC4rJi1CcGcSjE3rA="
}, {
    "num_cand": "U2FsdGVkX18DbAuBtspWKFxeJ0RYQ3HB3yOe8KuAxIA=",
    "cpf": "U2FsdGVkX1+lHYjly61QF+G4SWc3zXw8/y4FcVGzqic="
}, {
    "num_cand": "U2FsdGVkX1+n424JU8g50isVdobFbiPtjFBoEsBxhYY=",
    "cpf": "U2FsdGVkX1/b7QUbd7imtCmxEACXiwtQdidKk35ixSo="
}, {
    "num_cand": "U2FsdGVkX1+9qbiLpeSxpn8CwbqDWGfizCiyrUJbGWU=",
    "cpf": "U2FsdGVkX18ol9K6ZFc+MGZEKH4p3wCFurzduxRnp/E="
}, {
    "num_cand": "U2FsdGVkX1+6ufwVXTR/vMMYL9tvRpa0TECf27+czRA=",
    "cpf": "U2FsdGVkX18D7tsiK7nhab779ihiov8a5rKw3E7GIKs="
}, {
    "num_cand": "U2FsdGVkX18Kmy3WhE8DDp0WFE8Vr+i1YsyD+vVWru8=",
    "cpf": "U2FsdGVkX1+BEQod8NOzaRSUbRu/UQmdlWFBHq4VKMQ="
}, {
    "num_cand": "U2FsdGVkX18/kjKhkNze0TVN+Ge54MEoDcMejFCIsIM=",
    "cpf": "U2FsdGVkX18VQPgW0yQ5yhnMniBlDuptdnFcAfj8SZs="
}, {
    "num_cand": "U2FsdGVkX1+umjsTun57v3DFnhuWZ5FKlw89oq3QEjc=",
    "cpf": "U2FsdGVkX1+GTKel5LRtuNjMpW9eQUFwOq8LyXBpLVU="
}, {
    "num_cand": "U2FsdGVkX19HvJhsXazk4KOuFxaNEAI6Y+yLKK9Tj5k=",
    "cpf": "U2FsdGVkX180UlF71BYIhaeQYut+Wsa8hC1sqqeGD90="
}, {
    "num_cand": "U2FsdGVkX19eYLoaKc8jpBrTHbhNIz3SRCBA86Sj8OM=",
    "cpf": "U2FsdGVkX1/yB6dlU1fET3f3mcm/NSQh6rXCYTUdAck="
}, {
    "num_cand": "U2FsdGVkX1+/p73kSQkONO6XrpDAR4akbBudl0ILA1w=",
    "cpf": "U2FsdGVkX18mx5m1GHRsPvfuM6Gjflzi7f8Lxqs1vHk="
}, {
    "num_cand": "U2FsdGVkX1+7b4L2nO214x3Th/bliuiGiyzwrJ5QfaE=",
    "cpf": "U2FsdGVkX1/Mwd0E0D4ezlre6L9CqcCnpkA/1/e6pwU="
}, {
    "num_cand": "U2FsdGVkX1+97zPEnSYulu3uQCwu3ax0BRcbtaH9V3s=",
    "cpf": "U2FsdGVkX18U/TnFb/0l5rFppA7RIV0YnD6ruGnaUSw="
}, {
    "num_cand": "U2FsdGVkX1/z0u9XGk4uc/9KsVb7hxPcE0THYGdZOUQ=",
    "cpf": "U2FsdGVkX1/ORXVxPhI//WzGBFR9RLh3VGP1tC7+Mk4="
}, {
    "num_cand": "U2FsdGVkX1/oxkEkwgptBzxRjoi33n2gcXv1yNCgh4U=",
    "cpf": "U2FsdGVkX1/UI186GxysNZQYlQWT7KTtZP/0X3pg3ko="
}, {
    "num_cand": "U2FsdGVkX1//uSGZrUQGundX69SMnHye4DsjuIK97HE=",
    "cpf": "U2FsdGVkX1+pO7suNld/XFPF+XUJEnGtZFFxOElS0JY="
}, {
    "num_cand": "U2FsdGVkX1/sL7WPfVZnM4jx86p0Ys6Vi8BIiC6iHbc=",
    "cpf": "U2FsdGVkX1+b8YOHYkyJF7dMrIKqqPyzo3rDfdu9hzQ="
}, {
    "num_cand": "U2FsdGVkX19oDYw1i9PfTrG15h+uwIZ7O5rgWnN6Fc8=",
    "cpf": "U2FsdGVkX18MSYQIm8NnyEGGthrVFRGczkZat4yD5wY="
}, {
    "num_cand": "U2FsdGVkX18PJYrArXTTRnOUNFTr15Zhnyv421Ph9hg=",
    "cpf": "U2FsdGVkX1+TXZyQVLTxQ+oBceFAGb6bpW+JY+wsOX8="
}, {
    "num_cand": "U2FsdGVkX19UMkRGSqAUYHXX+c/OZ0MlIB77Z7ooH0E=",
    "cpf": "U2FsdGVkX1/51aKg01dDolr8GS5penO0p/jIJ2h1nJI="
}, {
    "num_cand": "U2FsdGVkX1+k5vpHmh93IgJSQ5vvDvJyq852wF5A1Qs=",
    "cpf": "U2FsdGVkX18luxouZ00lxY6z1Qo1t9r5IWh3cjdlb3s="
}, {
    "num_cand": "U2FsdGVkX1/6EyfnKiYVJOIS1+pkA3M90nOccWPQmfk=",
    "cpf": "U2FsdGVkX1+FtaWimLPpV9chRXQ9yKoSiFL25NWZZK4="
}, {
    "num_cand": "U2FsdGVkX1+one3X/ElniVH0SSUv2Rj6OfYyo6sFflw=",
    "cpf": "U2FsdGVkX185XHajcbd1piab89TK7rmjtmci/EtZsXg="
}, {
    "num_cand": "U2FsdGVkX18lR4H5tCqnjNJpZFklu4UbNJIl4rkSjSU=",
    "cpf": "U2FsdGVkX19FLba7n4h+2PFHeeoxRMCMwnPsrUvgKZA="
}, {
    "num_cand": "U2FsdGVkX1/r8/d43DdZRNRNejfusrERzqqJ/8pTugg=",
    "cpf": "U2FsdGVkX19HQT2UKiOh5Y8f9KM9QD4VlafEFUMV5uo="
}, {
    "num_cand": "U2FsdGVkX1+cRPBkr+axTyVHmnIR1n/jhVqF1HSakrg=",
    "cpf": "U2FsdGVkX18hY5gSjzNmsY3ivdPuoXe1UoN+MN5co3k="
}, {
    "num_cand": "U2FsdGVkX1/fCQ+GrOiu61+n58VSjgHItYzOqDNzw/U=",
    "cpf": "U2FsdGVkX19rS4cMlkpvf4PzwJ9qzQPyfadnqpwwU8o="
}, {
    "num_cand": "U2FsdGVkX1+GS13G5EOd1T1TllrQ0yjSNRyE6pD2Vxs=",
    "cpf": "U2FsdGVkX19Ffws5SpnSYXDKXNhjJRrIUNt9eO1Rz6Q="
}, {
    "num_cand": "U2FsdGVkX18VJmg15lSGxwmC3p/Gb+X6sTKtLdxlzIs=",
    "cpf": "U2FsdGVkX19a5g3RqYBVLXsT9LFYzdy2yYAZMlo+Jh8="
}, {
    "num_cand": "U2FsdGVkX187xwjFjDksjXZCZjmc7YGObQhD+TwL+CI=",
    "cpf": "U2FsdGVkX19+3CNYPWNTQVMNC5eE9HbHiTCDrGXgiPI="
}, {
    "num_cand": "U2FsdGVkX1/MhCYgd14ERTyKLbmBeagzIl2jFEvXkok=",
    "cpf": "U2FsdGVkX19Dm63rxmTC5N1lohY+nuh3RqTqTdfRH9I="
}, {
    "num_cand": "U2FsdGVkX19SPbrRzRT+gY2T1f4JOWC+znZ2kCfKboc=",
    "cpf": "U2FsdGVkX19HRuq7YZPVBHHvVkjKyl9bm3jNFgZ5Pec="
}, {
    "num_cand": "U2FsdGVkX198XSy1bVVpbjko/y4wCoGfWgLUo8YaVts=",
    "cpf": "U2FsdGVkX1+BNWs0EuFUC1pFyW8+qBJ8nIf/Ld0Cc/0="
}, {
    "num_cand": "U2FsdGVkX18ZNC2UV6X2dMXHPLOoTqTJ4CmjI8echpw=",
    "cpf": "U2FsdGVkX19X3oxOerzDNzLikf7pL0kupH/bJUz5/s8="
}, {
    "num_cand": "U2FsdGVkX18RKkatOsgayNCbRIEElkKHRufAKoJYTaY=",
    "cpf": "U2FsdGVkX197Gg9tBLqEIH47Gij9bOMqch3IrJYiwJY="
}, {
    "num_cand": "U2FsdGVkX1+HsSljBdggjVjJL4WM62rfaH0699MNE24=",
    "cpf": "U2FsdGVkX18BxHYU9YWrOtOtBK+cjvPjgm5arYJZe8k="
}, {
    "num_cand": "U2FsdGVkX18UbwrIZY6d2PodiT9/R+NBDbHWWWKgmLg=",
    "cpf": "U2FsdGVkX18LMlJJ4wQc6DNQUvck//JlzLC5VO9X8l8="
}, {
    "num_cand": "U2FsdGVkX1+vHRjQdgi30olTipvZA+uY3thXzMhBwyE=",
    "cpf": "U2FsdGVkX1+YYGEB62Qfxv8SJWluYE2D7MELkGApoB0="
}, {
    "num_cand": "U2FsdGVkX1+bvDmPIRqYzPj3zjjZYVja0CYlDktg5RE=",
    "cpf": "U2FsdGVkX1/6luDMFhY4vDCfCV3G7FWmbY5nPNpfqYc="
}, {
    "num_cand": "U2FsdGVkX18t3fAoFEtKuQiAbwQWke+42prMRsW8vlM=",
    "cpf": "U2FsdGVkX1+Bak8nnvVWHXedmrV1VBUU2s111SuMgYM="
}, {
    "num_cand": "U2FsdGVkX19aT93yePd0MvTU6FP2Fxn5u88D0qCphcw=",
    "cpf": "U2FsdGVkX19X1mvR8jE+2rmU5SYERFDMYVNU3wp5azc="
}, {
    "num_cand": "U2FsdGVkX1/Ypwv80FzyohbBrc+Rx7Rx2fN7leWpgz4=",
    "cpf": "U2FsdGVkX19lH31E2D4oTbYgmiUk6WecrPG0kADJfoY="
}, {
    "num_cand": "U2FsdGVkX1/Hf9G+cR03/7bUx3ZeN5GGr0mJPa1IUZ8=",
    "cpf": "U2FsdGVkX1+3AloyoUj0sN4MWqmrSu/k/1Ui7xCkYps="
}, {
    "num_cand": "U2FsdGVkX18zQTIdQZQEOy4wvK1NqXlXgEgFLErW6jw=",
    "cpf": "U2FsdGVkX180bVz2B++L+0ZgAImyrQ9bEUEe9HdJTKo="
}, {
    "num_cand": "U2FsdGVkX187uuDAOR/qf+sU6a7gTwL8qnz4kNozWlQ=",
    "cpf": "U2FsdGVkX18NCsPtimjuUiFAZ4vMiQvWN50GVtDAhYo="
}, {
    "num_cand": "U2FsdGVkX1/npxn3PMeNJCjgB455bTs5BA6iWwvtILI=",
    "cpf": "U2FsdGVkX19xuFh9zx6sClIENKXY+PExXGxV9R7ynSU="
}, {
    "num_cand": "U2FsdGVkX1+RVPLdUPMEbQ/jac1+O1rklGREjILjXpI=",
    "cpf": "U2FsdGVkX1/mIZH9UaY6mkgcftvoPgPh3jEKov0PGaw="
}, {
    "num_cand": "U2FsdGVkX18Lk+FDGsBy/6XBOgFmU5rjRYeMB0mtOiY=",
    "cpf": "U2FsdGVkX1+boyPKe7KgEveWa/RsPZ2I2PXlXjsM6O8="
}, {
    "num_cand": "U2FsdGVkX190bgQmZXIeHom+Y146svZN0uHz35iyRgs=",
    "cpf": "U2FsdGVkX1/hMZwWVEQdsbc4AA0QZ1FCMo6VMw2wuEY="
}, {
    "num_cand": "U2FsdGVkX1/sRtCr7Tc43M2IhlPSEVGr6BdscJ6XseE=",
    "cpf": "U2FsdGVkX1867XsQfqP50pVxt1dvEBYtpzSZZYLTUNw="
}, {
    "num_cand": "U2FsdGVkX1+bBQATW7gmkDNEXK1bYhlrpoN8r8Eunfc=",
    "cpf": "U2FsdGVkX1/+Fc9ep3CMYs5LbcUzITgz4XmqNuD3MHU="
}, {
    "num_cand": "U2FsdGVkX19tFaLYrEqcn7X+b40WM5ePRIQTws8KHrs=",
    "cpf": "U2FsdGVkX1849JWJ7dFEgyjSNmln5hNlXsg2rqkCVrY="
}, {
    "num_cand": "U2FsdGVkX19sXbKVF1mrdOK/czfP28NT7B3G67jxgLQ=",
    "cpf": "U2FsdGVkX19qliA8JlSqFcad0h1YpY9sv7MLjaEqt+8="
}, {
    "num_cand": "U2FsdGVkX1+rZbgbZbJoLKPrYHVbqbNnyDLzJ//eGq0=",
    "cpf": "U2FsdGVkX18s5JEabnYQ2tgUpuI8g22Pus2L1W6ognA="
}, {
    "num_cand": "U2FsdGVkX19lKy58htSghJ8PjPIFQCV58BewvnwaYvc=",
    "cpf": "U2FsdGVkX19jAVyNl2pg7Q/o815reHWRMKV03EvFJLQ="
}, {
    "num_cand": "U2FsdGVkX18aXhlbL9tPccFrBHcHwSdguY6zNQJfpY4=",
    "cpf": "U2FsdGVkX19U+NEikv69RMa/bNB7F7gce2J6wvyr4QA="
}, {
    "num_cand": "U2FsdGVkX1/HKryWpbMN3vRr5rWnX+X3OM9CDhyndDw=",
    "cpf": "U2FsdGVkX19tOuAmyEFpd9HECtTDNrCjc2UnW70FBDo="
}, {
    "num_cand": "U2FsdGVkX1+KZ+nZ0Zg6hmjm51IveZY9lhjLm2EA38o=",
    "cpf": "U2FsdGVkX1/rb1LDSsNociMweE0ci+SpunYTGqzr66E="
}, {
    "num_cand": "U2FsdGVkX18DhLGZOKVDCnCKBacg2btYB+HsQe5neuw=",
    "cpf": "U2FsdGVkX19c/gRKdY/Vxmt0tFC7rmovh6wWvJJI/9A="
}, {
    "num_cand": "U2FsdGVkX1+gcIagm7iikyX3oFk1C1jd395uGIaUEJw=",
    "cpf": "U2FsdGVkX1/0Q2lwegd1aXdRaMbv54Uw4Ep+dK0terQ="
}, {
    "num_cand": "U2FsdGVkX1/uhRzmGw590KELBAeGq+wn1qLlYobfzYg=",
    "cpf": "U2FsdGVkX1/J6jHmJo6MSyjqIHQzZKRssWZ07RRpfjQ="
}, {
    "num_cand": "U2FsdGVkX1+EcGeiV4gmYlBoRgBZr55vOd3HSOgYrmg=",
    "cpf": "U2FsdGVkX19y4UK7g7TPo0fvggEyozOIvU3JL46emzg="
}, {
    "num_cand": "U2FsdGVkX1/SHbN2OWeiv6jXab6z35O5lXioswlkyq4=",
    "cpf": "U2FsdGVkX193RYxWtWI8GBzn5TCcg4Oa6Bqv3Aqhzk0="
}, {
    "num_cand": "U2FsdGVkX1/nA8K3VwG0ZV1wVlWIf93NQfOPpeuQVGg=",
    "cpf": "U2FsdGVkX19agwThxHcT6w4qDuwfYsA/FjvBvErCsY8="
}, {
    "num_cand": "U2FsdGVkX1/468diCX7yoFR1Thkjln56Y21JKruhRLI=",
    "cpf": "U2FsdGVkX18jUBd8WDbA00/ZEv0/Lvj1pLGK5I7w0/I="
}, {
    "num_cand": "U2FsdGVkX1+1Zee72kg8ayMdFMW7S08KOjGR6BqJOCs=",
    "cpf": "U2FsdGVkX1/9iD7kA8K0l9UqYHlMQaM3Ba04t5RLeBs="
}, {
    "num_cand": "U2FsdGVkX19hnnTQNNKZqwlY+2PGnDVqRWT6Jil1KWE=",
    "cpf": "U2FsdGVkX19xvpjvx79JRo67haazdHKt3A1g2ssRnqg="
}, {
    "num_cand": "U2FsdGVkX19lqxBro8y/CRAkfI3e62djiRSy+DgngmI=",
    "cpf": "U2FsdGVkX1+v8YRlzrn5jbZcmJ2pFPgsJaPn8gPQorY="
}, {
    "num_cand": "U2FsdGVkX1+wiEzukBjXyhea05ewbeK5ZIfj27Q9438=",
    "cpf": "U2FsdGVkX18JEM3EsP82NBl4H0ePSOnJr4AQ/7rVJmY="
}, {
    "num_cand": "U2FsdGVkX18zU5Wj5HWxqmRs9CA4JrLN7i3GNZfNydQ=",
    "cpf": "U2FsdGVkX190/n/lcSBnniMDKS83Z72omUQldHhrZ0U="
}, {
    "num_cand": "U2FsdGVkX1/sPpoLnDllYdC6UxwQV9wif+qO0RIfcqs=",
    "cpf": "U2FsdGVkX1/+1/Vfj3+GAwKWCJ1AVDrZZbXh0RRMrcI="
}, {
    "num_cand": "U2FsdGVkX19G3s9gSdIBCndB5+yTqh6P8IY8WXA2+KI=",
    "cpf": "U2FsdGVkX18mJ3GNBg+vJwMGKgN3qTEAMbNkGOg8CkA="
}, {
    "num_cand": "U2FsdGVkX18D1MrvYz/AyB1UyhQkgnHGgmQUIzFqo0U=",
    "cpf": "U2FsdGVkX1/HuolAicYyYv2HvR3VVOII/E7w6q6yvLI="
}, {
    "num_cand": "U2FsdGVkX1+GlS851Syfg44alkYYobofF/nU7PEqBJ0=",
    "cpf": "U2FsdGVkX19MSWY6BB1SA5vsUp2tRV/rtlSf8BoWJIA="
}, {
    "num_cand": "U2FsdGVkX1/t2Lb2cpUiQl0wHFOqqmYmtjRXi2yAS7I=",
    "cpf": "U2FsdGVkX1/cDUA2LihgIEullnvYkEzxWrw7SQx5/O4="
}, {
    "num_cand": "U2FsdGVkX18vVXsuGeTU4nf4UIOGVGTpZcVU+ADGCoM=",
    "cpf": "U2FsdGVkX1/iWFHFZuimksDKuVkKZBlMGP3Fi1sdayo="
}, {
    "num_cand": "U2FsdGVkX18DdY8R41bA2TJzSGpoyrVbmNKGNM0dJL8=",
    "cpf": "U2FsdGVkX1+4WhlUfmFBoXnAUWUiP+n+hgAJet96NA4="
}, {
    "num_cand": "U2FsdGVkX1+ttcGm8Zq4L4+JSSxZBYLP3u9R36g3t80=",
    "cpf": "U2FsdGVkX1+YUNazsoZ2JEyOqONqchz3qAY3QOZo8Qw="
}, {
    "num_cand": "U2FsdGVkX19IWuDh/Y/MmATTJGBx5N0x+UKPdlolQ6M=",
    "cpf": "U2FsdGVkX19WceL35f3VDcQzW0pWMGBR92rhVOt7BDY="
}, {
    "num_cand": "U2FsdGVkX1+96z11CNxxviNhVgkKIprhy7mqjgXlEFg=",
    "cpf": "U2FsdGVkX19njZ2k7uKDiB09VV6UrmP1ZSQtVXKu4l8="
}, {
    "num_cand": "U2FsdGVkX19qrDxd08T42W12bqldpOnE0G1IAD3KdUo=",
    "cpf": "U2FsdGVkX1/I7HWwKCxZu44rFrBPl8caIF5NXwdHPk0="
}, {
    "num_cand": "U2FsdGVkX1+vQGFQhfLCOVi04D2ElQ9NGPhOkVN2eWY=",
    "cpf": "U2FsdGVkX1/dwPkJZ13k4VNQyQ2EtUVbLE34vwO42Rk="
}, {
    "num_cand": "U2FsdGVkX1/4RY0YdXO//rprWaCcIWchTAu72r2nRFM=",
    "cpf": "U2FsdGVkX19uEOL759tkfT3UdZYFAVMtjQFmIChySSQ="
}, {
    "num_cand": "U2FsdGVkX18VD45ooifm2mKlDRR+qVKDJjybutP+fjg=",
    "cpf": "U2FsdGVkX19Y5k1YykZnmmTKVhV0nk37zMF4xE7jPqk="
}, {
    "num_cand": "U2FsdGVkX1+jFXo1w8nsP5rSj+UTvKX9sfzyJRibpgU=",
    "cpf": "U2FsdGVkX1/B8JkB71OV6S+TuxrMPXuOSENSnxAiHvE="
}, {
    "num_cand": "U2FsdGVkX19DzFm9q8WybcFjmMVcO6LKs1UcHdMW9PA=",
    "cpf": "U2FsdGVkX187+s87kyvXrvu6vVN3EC2hZhhTxjlIIJ4="
}, {
    "num_cand": "U2FsdGVkX1/1xKe7+ri9gycqEhoeSTEEVWqCICjpzCw=",
    "cpf": "U2FsdGVkX19rbJFVBJ16AL7PhVH3lyNVpC+9kv5SllY="
}, {
    "num_cand": "U2FsdGVkX19SeYhGxy5yKvoeX991hZwefqeWuFZUJiA=",
    "cpf": "U2FsdGVkX19o0C8LI6R/DbFwXQ+TFv0wNkBlFkL+WeE="
}, {
    "num_cand": "U2FsdGVkX187dfMwjgkslFmC9Mmj0UdF0ioLQZsJHJo=",
    "cpf": "U2FsdGVkX1+y96tTKeK23Op3lJB5i4bTxYA1z1Zd4lI="
}, {
    "num_cand": "U2FsdGVkX19uiUZVYddvXzPxnskUVih1yLn0fVEMa1s=",
    "cpf": "U2FsdGVkX1/Ox1wHJU1ldNlJDk+wx8GuOufAP0W6fic="
}, {
    "num_cand": "U2FsdGVkX1/ZVux2ikz2I8ANCtG8BpvMMUKftgMfyHI=",
    "cpf": "U2FsdGVkX18to70sa6bWkRXNXCQkgbE4HHK9qepBGvk="
}, {
    "num_cand": "U2FsdGVkX1+T69ZXcHJUjgBH01Ph1sQxBwveA8mDkEg=",
    "cpf": "U2FsdGVkX1886XNQeOlOqH/GoU+yNxy4tDrATpxZDVk="
}, {
    "num_cand": "U2FsdGVkX188lHL58jNiMYBug8ls5O6aHy05AuTbZrc=",
    "cpf": "U2FsdGVkX19gOa/qKLjQJTzGy9cLOG2URnxAihwSTCg="
}, {
    "num_cand": "U2FsdGVkX1+ZWqHq4Zn65+fJQBbhKXIKUYp4afpix2E=",
    "cpf": "U2FsdGVkX19WxEKX/SwEFU2/xV6k5rx/PomN+HvsB84="
}, {
    "num_cand": "U2FsdGVkX1/any7SGwIrCBWV40we4SLR4WSATQaGENA=",
    "cpf": "U2FsdGVkX1+sxfV5LeQ21DBZr+iJ/lU0QbB5+VOkoUU="
}, {
    "num_cand": "U2FsdGVkX1/+TVS7n/Gtx89+vM/pSDUiW0JmKA9IikY=",
    "cpf": "U2FsdGVkX18EX+NzBr8KcVtGKPUB/6M+2lJUALCoXSc="
}, {
    "num_cand": "U2FsdGVkX18Ow2IE72D9/+wF+/vxNgZRnJYIWoNtsz4=",
    "cpf": "U2FsdGVkX1+ss//Ra0fYz/UFugiKPbS21AlpATkH478="
}, {
    "num_cand": "U2FsdGVkX18aeHucBDMeMytcDvM0ehV9HlnQm2k38g4=",
    "cpf": "U2FsdGVkX1/K0zHU3MMCUYy08w/UEHV26DEqn3n5g1M="
}, {
    "num_cand": "U2FsdGVkX19Mj9KjIiK1jeopiiLhrz1W17xBoB1ChDo=",
    "cpf": "U2FsdGVkX1/Xt4VgK8o+Hfk1wQe/CRq9uKPfO/BZ2kg="
}, {
    "num_cand": "U2FsdGVkX19aTX7d25GgWf8k2A07gkHvt0qrZW07n7s=",
    "cpf": "U2FsdGVkX188qf5T93+jrq3264+lajAmauavr1pFaMI="
}, {
    "num_cand": "U2FsdGVkX1+7W2cPgvfA+NHdA9jVnstbdq4s2hDSnfE=",
    "cpf": "U2FsdGVkX18BI/RgnpVXDLrkACmCFUXW+mi4Sfwo6c4="
}, {
    "num_cand": "U2FsdGVkX1+DtuHy5VyX10ydKP3YIYt6uOwuEo2P0fs=",
    "cpf": "U2FsdGVkX19V1u5FE3MXeyL9xusU2XD2Fr6Ltxvr+Ao="
}, {
    "num_cand": "U2FsdGVkX1+gG0R25Ho2ZxtjMZ/yT2H4sJSVGlcE+98=",
    "cpf": "U2FsdGVkX19K/wVkPhutY1DOV7dQLkdhgCUdn0VNtKQ="
}, {
    "num_cand": "U2FsdGVkX1+gCLeo5dElbpETR3oNSFEikLVlLFGBPaQ=",
    "cpf": "U2FsdGVkX1+WJsJ3dqc/kA/udXkHkpSB6plAjJwzoSc="
}, {
    "num_cand": "U2FsdGVkX19nXWdcauWaqfolgRqXarDfDzohOihHUVQ=",
    "cpf": "U2FsdGVkX19nJHUyMtNMFMpIADYLO+BL5TmLR02TX1o="
}, {
    "num_cand": "U2FsdGVkX1+Q8inPtDukurwYUYPZjDlFjTg3jDDT0s8=",
    "cpf": "U2FsdGVkX19rSRT7HOsd5/MVhLb0sHdX5a+/1qfAcKs="
}, {
    "num_cand": "U2FsdGVkX1/pL57LqvKmtkkGlUE+I/I970EDbUNBEa8=",
    "cpf": "U2FsdGVkX19tYygJdI6muNYEWQtba0fEigQfwNvm3p0="
}, {
    "num_cand": "U2FsdGVkX1/9mClnzQRJOyiKAiR3woPjsN0/HiHmNqU=",
    "cpf": "U2FsdGVkX19jeAdhrLL40xsn4cfqlCjl8++ILrq0tkE="
}, {
    "num_cand": "U2FsdGVkX18v4I3JnahPiN3lk94WgI/SBrFikg2Kyr4=",
    "cpf": "U2FsdGVkX1+F2VpMniwwziPzAeog0Hc/lMxP9Uj49rc="
}, {
    "num_cand": "U2FsdGVkX19h0HArf3mOBWKKtcbIemVMgjsB8MbZ3rI=",
    "cpf": "U2FsdGVkX19Z9RnesQJbkmqhqcNWnFtwg/Ip4ctB4eQ="
}, {
    "num_cand": "U2FsdGVkX1/9aZGCCSOcvxt7eHkg7ETPhTbxcj4hw4k=",
    "cpf": "U2FsdGVkX1871DB8FNLS/zfaIk5QoZIgzcNQeBfIPUs="
}, {
    "num_cand": "U2FsdGVkX1/ntLN7LFygXcC7bcsorbF7D3Waxu1g0JU=",
    "cpf": "U2FsdGVkX18eqdhWX01SEh3mw04GP5YiwZVZihMqlgg="
}, {
    "num_cand": "U2FsdGVkX1+J668QO9HnJEhNvVEt230wcg5R9Pw0v10=",
    "cpf": "U2FsdGVkX19kJDGcDC/Qrf3Sle4rYT38cBxkhLTHy+Q="
}, {
    "num_cand": "U2FsdGVkX1+bvDmyFlgBS3UyGbizHlFtedB+Htq7pC0=",
    "cpf": "U2FsdGVkX1+xcWj+JUFFpiGnH0pfKPMK1IeAiHa6NYk="
}, {
    "num_cand": "U2FsdGVkX1+9+qZB9/9mwWpnsv9nLFuGaEcHGoqktVA=",
    "cpf": "U2FsdGVkX1+mHCJ5P9HEI40mjogpfNL+W2bKdQtuszI="
}, {
    "num_cand": "U2FsdGVkX18vrbHZWzaO0plmH3s2kwUJAJQA76dRz0k=",
    "cpf": "U2FsdGVkX1/nXuvqEuybNjZtj7FAUPiaNcxmgI9aidM="
}, {
    "num_cand": "U2FsdGVkX1+tqhMUX+Hnq9k++OO4F8LumsBme+lUNIM=",
    "cpf": "U2FsdGVkX1/cwwAljdImtAuufArjDk+CqpcPEwtE7PI="
}, {
    "num_cand": "U2FsdGVkX1/hMk+kOSVoR4d84CpGSCpwjnMffFi6D8s=",
    "cpf": "U2FsdGVkX1+443Uoi3ThkAp6PXOB3w4v8zNqQu6gPc4="
}, {
    "num_cand": "U2FsdGVkX1/Aod0lTMDwFdoXZfPwRgM6v3Eg7SloO44=",
    "cpf": "U2FsdGVkX1+gjehWk99F8Ww8kWjMq83qzqy2IkVaDMk="
}, {
    "num_cand": "U2FsdGVkX197TwUqnmoRIbKFo6XvGkKvpwRd3OOn94w=",
    "cpf": "U2FsdGVkX1+E5MeROxpl7PhlXRkFy6hTz/8DT9hbPmY="
}, {
    "num_cand": "U2FsdGVkX18G4CGhGk+WffCLJCKs2z6sydZSi+88WWQ=",
    "cpf": "U2FsdGVkX18wMTqpyRWy7O5tT8vjPYQZdu4y/rmT5ns="
}, {
    "num_cand": "U2FsdGVkX1/LabSUH6gcjK5P5vKGi6f7rtT3dzIsY8Q=",
    "cpf": "U2FsdGVkX1+SBCbKcep+1cRyoAkT+BTk4UMeBkFpfRA="
}, {
    "num_cand": "U2FsdGVkX1/WaVdN6WyFeBE5iYBTDDp0Fo6UC2zLLPo=",
    "cpf": "U2FsdGVkX1/GqvNBABS3wm7pU+P1OYJUgokG1zCDwdI="
}, {
    "num_cand": "U2FsdGVkX1+dgTgOPvpQ3Z1sdnZOiTJERnd3w9D3T4k=",
    "cpf": "U2FsdGVkX19rBSxQh2u1VFInvIXFyKcwMPt+M1JD5us="
}, {
    "num_cand": "U2FsdGVkX18N7Zm5BtJeOo2DkBEh1X587ejAneZqoQs=",
    "cpf": "U2FsdGVkX18PCzNa9iXY0s5I76nAa/iAwCGcBjUCX3Y="
}, {
    "num_cand": "U2FsdGVkX19ywKZQc0NsBdDE8BHjViHzPqO400S2wcg=",
    "cpf": "U2FsdGVkX18gX+3YaOs4AR9xBcogHvHYdG43MD43OZg="
}, {
    "num_cand": "U2FsdGVkX1/IQ6Af+Nb5om82V9iH9Y1AFWtjxx0W1Q8=",
    "cpf": "U2FsdGVkX1/VKcP03QfBd/P8BJ9JO9MnBN/y+E7BHqk="
}, {
    "num_cand": "U2FsdGVkX1/fD/ureOrxBmisE+wBR+T4/l0tOinyJcs=",
    "cpf": "U2FsdGVkX1+XZJOiv4B4JmYLN+Gm2/La46MOgWWFCg4="
}, {
    "num_cand": "U2FsdGVkX18+Sw6CNQrykr4ZvlrxSNyh2+wqSBOy7Zc=",
    "cpf": "U2FsdGVkX1/KCXOeCm/dvAhLUOyVP053pCA607WiuIw="
}, {
    "num_cand": "U2FsdGVkX1/XXGkBFBFeDk9u1XghwzgssjExMr3XnRY=",
    "cpf": "U2FsdGVkX1/bsIto4gXqNpcvoORuy7R9ufHBrLM4a5U="
}, {
    "num_cand": "U2FsdGVkX1/S4+JSvtlcA8JsoTIoRhrNz9+hqQMlQNs=",
    "cpf": "U2FsdGVkX18e8F9Csy0kD/Zq4mQl2XEJuPET+VHXZNE="
}, {
    "num_cand": "U2FsdGVkX1/8VrbtuCi2Es93V7kl4kcmL6wN4yoWr08=",
    "cpf": "U2FsdGVkX18BZuj/B0fWm4caaq/Kfp8IZh/Og1tvx6U="
}, {
    "num_cand": "U2FsdGVkX1+ylBnINIdvohjwJ2LqeHH/TjouqQCjCBM=",
    "cpf": "U2FsdGVkX1+eivZrOa/stHIjdPdPA636LKZeQfZnUdM="
}, {
    "num_cand": "U2FsdGVkX1/2eEBE34rMp69HMNkV3e+1znirNW8L20w=",
    "cpf": "U2FsdGVkX1+VrVV/ER/EW9I2T7O/w3UvXmvX70pRL1Y="
}, {
    "num_cand": "U2FsdGVkX1+vV5+zN/hLC9x+Uuw+Tl1feJjmhAuk9vs=",
    "cpf": "U2FsdGVkX19AbQtD9HpZZMZ0Hi6/3yPonydFyPHW1Yo="
}, {
    "num_cand": "U2FsdGVkX1/6mlPNA0ltoI/FggMdC+Gh2TiLpFqfisk=",
    "cpf": "U2FsdGVkX1+5H6T0Ba9Iex11ZI1ALLxuXwIQvN9qROM="
}, {
    "num_cand": "U2FsdGVkX1/jiiARbwdmV1R2DJ4grlIhdvagQjdpxDc=",
    "cpf": "U2FsdGVkX1/Dr3K1x036VHZpBtgOZEU6YpV+4qTipyE="
}, {
    "num_cand": "U2FsdGVkX1+fRU2ZhXZ5OYUhzE/PnzGYMuOIb3PZUiw=",
    "cpf": "U2FsdGVkX18ugCSH5xq0rhZECAHUl2BHFpeTzoFISSw="
}, {
    "num_cand": "U2FsdGVkX1/5uDi1CT1nR9tlaAjVWIAiir8fbTyKemA=",
    "cpf": "U2FsdGVkX18GbAHq5qpveOuQTNinn+mopS7hT8S5ox0="
}, {
    "num_cand": "U2FsdGVkX1+1pYszb7Z8ZAm+0PBh9n0dr9FSfvhhk9Q=",
    "cpf": "U2FsdGVkX18NZdKCVoNqfUE0U+207BkA5yjGtM8WTHM="
}, {
    "num_cand": "U2FsdGVkX1+XeX4q9QgMp8v+BObFm4sqHEJa1Av2ODg=",
    "cpf": "U2FsdGVkX19Bm5gq+ip1Zizuth/sDTr58LfGQ4DWKqQ="
}, {
    "num_cand": "U2FsdGVkX1/vRDe9oixw5q1q4N5HcAggotprDpmmwEc=",
    "cpf": "U2FsdGVkX1/0oSdQ8U+eaIfKiFdH7MCKSgYrs2uIjcs="
}, {
    "num_cand": "U2FsdGVkX1/XP4BvnPelE02c0AsZjSF9eg52tfYJsW4=",
    "cpf": "U2FsdGVkX186iVgm3BRPr3PcuxFqwrzSM0CLcZysteI="
}, {
    "num_cand": "U2FsdGVkX1/Z5ptPBufVRpATPptE95DTkLvBqiCJD+I=",
    "cpf": "U2FsdGVkX18BTTs8rVXaWhJzUyKbpwP9VTnVKzx2iqA="
}, {
    "num_cand": "U2FsdGVkX1/IaPAOq1Rpcd6voQSWW4vqSc10jjOIqtI=",
    "cpf": "U2FsdGVkX1/0w8bClmkmSyGRd7nNuuORubTj9IHikVo="
}, {
    "num_cand": "U2FsdGVkX1+xkOYZRtqt72B1azMV/2vwwebMv2rWCvs=",
    "cpf": "U2FsdGVkX19MZfYPqQwXDRPJvObj1bwa3+xyB3toTjw="
}, {
    "num_cand": "U2FsdGVkX18XITcgDoKUgt32Vt2DhZm4NHQedwKHz3A=",
    "cpf": "U2FsdGVkX18/3RBsHOgHAPsddZeSR0EnklDaOfiL6/U="
}, {
    "num_cand": "U2FsdGVkX18U+qDjbpLzcjep1M+pV3Di3Q1g0vTJWe0=",
    "cpf": "U2FsdGVkX18eApLk7FbyNpLmou111CyxL50Jb+7VwIs="
}, {
    "num_cand": "U2FsdGVkX19tZVWh73E+zYRWCHFeexmsBqka8l9Tyx8=",
    "cpf": "U2FsdGVkX1/0qbjZ9BwXpaNtqKxyVQyV/1Q24CqUeeY="
}, {
    "num_cand": "U2FsdGVkX189ws/geiQvIBLxu35zVjFr6DM3kElbOHo=",
    "cpf": "U2FsdGVkX19cUApleYL0x3cJMBuW4T57OmOqM3ZggiE="
}, {
    "num_cand": "U2FsdGVkX18/xG97xUFqTAX7Av16eB4F3zVGehBpNLo=",
    "cpf": "U2FsdGVkX1+eypJFCga/t7p55ViKeUuzkCyGuGCMNQQ="
}, {
    "num_cand": "U2FsdGVkX1/nBPTlWzH97bpuB1MYJhbQU3rDZNHlkvg=",
    "cpf": "U2FsdGVkX19M22XHMcNhw5KTJdWvKFIIiZmLXBKMyng="
}, {
    "num_cand": "U2FsdGVkX19m/MBmL0tDHlINBTpZVv7DG7SQF9ew0c0=",
    "cpf": "U2FsdGVkX19e0yVpTe6tREPwCh4XOoTrKsrU2l3yD9Y="
}, {
    "num_cand": "U2FsdGVkX19OAaXQ6bwVrY2NOjkTeQKVeALhCQZyn1E=",
    "cpf": "U2FsdGVkX1/vUYPmVSN+c4pQ1fUoPAHwGApSMXdZDUQ="
}, {
    "num_cand": "U2FsdGVkX1+OPg7k7h/lcy9x8m+Uapg79iljz2mYlY4=",
    "cpf": "U2FsdGVkX18Jz1CJ7IEwrEoFWGrLXyqoZjWq/Sr5nGE="
}, {
    "num_cand": "U2FsdGVkX19S92Ca1gdSX7UHp6PWaWPGyTjMJei0w3k=",
    "cpf": "U2FsdGVkX1+1J1kCsTwNb6DISg7QN/7IDwuJt0FFNos="
}, {
    "num_cand": "U2FsdGVkX1+11es9zsvo3M16x5AkPu6jYprI9ncLY8Y=",
    "cpf": "U2FsdGVkX18yiAZJyZDG7DQl0DFWvmsCEeZtBZ4hs/g="
}, {
    "num_cand": "U2FsdGVkX18Brp2rAC2s3BlxkHechtY/UjBwmvgwbIU=",
    "cpf": "U2FsdGVkX1/+d94/D3ixDMz8hHKaSnGvqbgH8l2fU0E="
}, {
    "num_cand": "U2FsdGVkX19MlemAgMtv84DYGpf/qFLxJ2u1Ew5Vnss=",
    "cpf": "U2FsdGVkX1+Y2flVDSvdeyaUNv6V4PGxzPud9j9ooWk="
}, {
    "num_cand": "U2FsdGVkX1/WFqYTgdlVonvsHh7hYUc6rPSWtSFkIY4=",
    "cpf": "U2FsdGVkX1/Il65CWjPoAhEgVzSkE7KQRSHOs9nxQz0="
}, {
    "num_cand": "U2FsdGVkX18ITH1XMf3Z9lGvPVcF8DFfZAHqXFi2LCo=",
    "cpf": "U2FsdGVkX18ImE8S4ENI1WJ3lt/yqnq53fOYURifk8k="
}, {
    "num_cand": "U2FsdGVkX19n4M84S4PYVB/+GEcO6v5AndzOHhd4sq0=",
    "cpf": "U2FsdGVkX18895SresWFbeVqyTtDAnDcALsWIvHXrMs="
}, {
    "num_cand": "U2FsdGVkX19gRT9xRtwh3oTQXQCxRL1SHPgiwB3VcFk=",
    "cpf": "U2FsdGVkX18tt2FjAy1od/gP+636cw3aA9cdYQdWx3g="
}, {
    "num_cand": "U2FsdGVkX1/0Ds3N81phkvChYoX81pLjFVmT8eIztWM=",
    "cpf": "U2FsdGVkX185EfDwjCMlGL4hXiScjQ9cKgcO3s5rDB0="
}, {
    "num_cand": "U2FsdGVkX19d2vugHWt7btU+oJZJxIrO1fM0m97eHhc=",
    "cpf": "U2FsdGVkX1/7MIhoawdRhXbqV0XwEHAMoLKpBlm9EPY="
}, {
    "num_cand": "U2FsdGVkX1/Mos7Z3WEVppwo8tyMsgNRGQkEwPxBnAM=",
    "cpf": "U2FsdGVkX1/19GrVI+Q9cCwvpx9pLw+Wskp/ZPw5Th8="
}, {
    "num_cand": "U2FsdGVkX1+ybzxMfSNjcBaGDbHWqQiDtMk9XqDk9CQ=",
    "cpf": "U2FsdGVkX198AcFP+vKVmKsOA0Zvj3Y42Q1EeIJJpN0="
}, {
    "num_cand": "U2FsdGVkX1+E+1f/S2DBCCHNVZ8D+Vmpesgy/KM3LjA=",
    "cpf": "U2FsdGVkX1/+zLEDQhIgyxgnnQZ/0wsV7DhFG9UEIUU="
}, {
    "num_cand": "U2FsdGVkX19+nHV8uoupoFBGLi6OpDz4nhdSlCRH68M=",
    "cpf": "U2FsdGVkX18gw0QHd1AX8pEI99WzHmwYfDhO47P3gpo="
}, {
    "num_cand": "U2FsdGVkX18doWcUZZa0Hb2+iJL2SRcAjIYwQP98dNU=",
    "cpf": "U2FsdGVkX1/QKRL6aJJD9Dj8GP3eG89NiD4K9koQL4g="
}, {
    "num_cand": "U2FsdGVkX1+6IWXfvRcgS99CaLYNWtDnF2P8OLz2clk=",
    "cpf": "U2FsdGVkX18BNWjpU4jOveaUfBNQ16xk1psc+KW46/A="
}, {
    "num_cand": "U2FsdGVkX18q5A1sKwwFwU2Obw20xb4jE1P90xgpias=",
    "cpf": "U2FsdGVkX18ZUjlCPmTjT8ka5hEzDP4jbkUkR6Qy6io="
}, {
    "num_cand": "U2FsdGVkX1/Z5BWh5/94wc8JoAcHLTVxHLVthIOD8Ns=",
    "cpf": "U2FsdGVkX192d4jZs/SE0jV8l5WQNcXQ29g7/pDO5r8="
}, {
    "num_cand": "U2FsdGVkX1/gMg8KuYCPkUxqYBTkKRoNu/Q/9YIxJIA=",
    "cpf": "U2FsdGVkX19t0yjETMu50jj1JWOur0YAvYU//wVhgXY="
}, {
    "num_cand": "U2FsdGVkX19f7keiJNwAJfT9SYbqdvIhw9wLrtfrifc=",
    "cpf": "U2FsdGVkX18gEt90Uvuu4aY/dn+77zjZOae7FVXsPeU="
}, {
    "num_cand": "U2FsdGVkX1/zNCHku+FIzHLVEned9cgVUqPn8lfN3eo=",
    "cpf": "U2FsdGVkX18WPUzH8KUiK8CYHrEed+74WLKOQWR6rf4="
}, {
    "num_cand": "U2FsdGVkX1/iGVgernZNCA4ay7RYPWqkUMMD0iX+mt4=",
    "cpf": "U2FsdGVkX18b2H2EtxNz1fAnP2F+MycARoK9tgLSZGU="
}, {
    "num_cand": "U2FsdGVkX1+JAOQ4jl/BYIQslcqr9RZAUkEq1pz8ZZI=",
    "cpf": "U2FsdGVkX1+4miJguwgdBlX+tPntwx/+4m/Bh+474C8="
}, {
    "num_cand": "U2FsdGVkX1+DypF+MP8LzIPJLusPb0OjhBd41H1yoaw=",
    "cpf": "U2FsdGVkX19wUWton1SSHL3ehpa0W8kCD/EcD6EkSko="
}, {
    "num_cand": "U2FsdGVkX18f/+a/7ijDB3UEldpV7MF2vdIoc+JtUxk=",
    "cpf": "U2FsdGVkX1/nNb2w2l+VUShQ0w+eLUAIdnreUArp1fE="
}, {
    "num_cand": "U2FsdGVkX19nn0E0HhEJeyAmIlAOLfulntgZ9vObiJg=",
    "cpf": "U2FsdGVkX1+sJEvmkQnn2I/R28wZ2bM4AD5qoZYyGXE="
}, {
    "num_cand": "U2FsdGVkX19qFOMuvhLkW4sWrHXfjdxYzzvmBU45Z7A=",
    "cpf": "U2FsdGVkX1+2dX3HPnc9tVaEWXg7uBywyCUhzMyBL/s="
}, {
    "num_cand": "U2FsdGVkX18VdTZoTCMK88+Z2ywnv7OUkGvVrhQ3+Gc=",
    "cpf": "U2FsdGVkX1/FI+132nUPmam+moUf0nkW02NQhCzaOqw="
}, {
    "num_cand": "U2FsdGVkX18isHBNqfuXpbQCUcRQ/o3HATQU72u2eqo=",
    "cpf": "U2FsdGVkX1/YJGagIla8H/yMctWirV+O1SUq6qUjAdU="
}, {
    "num_cand": "U2FsdGVkX1+M6kpKG9tyE2J2o1L4VEqgXHrx44XfqP4=",
    "cpf": "U2FsdGVkX18Ub0N9Gnjg+qNHEW51A1LfTDelEmHyf4c="
}, {
    "num_cand": "U2FsdGVkX1/hkQLCO8nMZTXOymJAga5UZJ1XeNiKoKI=",
    "cpf": "U2FsdGVkX1/x/XtJSywtT3wQbSRJ0LKIBOGuvsodLkA="
}, {
    "num_cand": "U2FsdGVkX18O71UBpdX3AAZd+eXlMw/BQICoJPHIa2w=",
    "cpf": "U2FsdGVkX19VXhR/9wcCT0q1Gt+vn0c+GsLeMKrWCWQ="
}, {
    "num_cand": "U2FsdGVkX1+qtVYyi3J00VGMJODre+ETMQwbvhHnhQo=",
    "cpf": "U2FsdGVkX191N952rxHQWziqhRjr1wvj4OUX5ioi678="
}, {
    "num_cand": "U2FsdGVkX1/JkZHGMH76KryRntlwaIGBiSzLoFjliio=",
    "cpf": "U2FsdGVkX1810FDblSBnr03I5yeK8kRRsYJbAqwcITw="
}, {
    "num_cand": "U2FsdGVkX1+zDgjyE+P5Lo7Z9HxPY92Y0yffZsWt0IE=",
    "cpf": "U2FsdGVkX196E2buChHIsNfWh8ieFOGGLMpCKLztdxQ="
}, {
    "num_cand": "U2FsdGVkX18kN7nR/cAfbx4wHZTRqYt689pgS9y6KvU=",
    "cpf": "U2FsdGVkX1/wifYwHYlon/q0Gp0vlpyjmKAHTOfXT5o="
}, {
    "num_cand": "U2FsdGVkX1+X4BAyRvR71VojajRKx6ZHxNlJBGTTJvw=",
    "cpf": "U2FsdGVkX1/joaj2Eok/JPsZfvXBr0PYHUGHB7yTUo0="
}, {
    "num_cand": "U2FsdGVkX18ZvQIjUsznj2EMwB7pemrDK1Pa5Jb1LhE=",
    "cpf": "U2FsdGVkX1/sbjRikupod1fSyL0/rgFyBPtW7ewDEDY="
}, {
    "num_cand": "U2FsdGVkX18uCOmYrBD6W7rmaIzRFHZd1nLnokKZtRU=",
    "cpf": "U2FsdGVkX192xrLA7JvDOJdRxMM2+n7QahEQdQJQAjA="
}, {
    "num_cand": "U2FsdGVkX18TAAiClV0Bxk/nS36fbXA/ghxSiLMJH7Q=",
    "cpf": "U2FsdGVkX1+61/eTmzBHXS0Fk4d7u6+hJH3OUR0s0kw="
}, {
    "num_cand": "U2FsdGVkX1/mGbUz6EKDBbYy1jJ63TqwBnQ+rWIvP4k=",
    "cpf": "U2FsdGVkX1+Eh31AuIAygvnqLh9gPqpAFrdufDsybyA="
}, {
    "num_cand": "U2FsdGVkX1+FoNXvBvN9+S2SYt94rmpGwokzUbQzHOI=",
    "cpf": "U2FsdGVkX18yDJzK4sUaSB6oJi7iBgiu5CD5vxznBjE="
}, {
    "num_cand": "U2FsdGVkX19UvWn+XiWyN4hFiSeyxKbbuBUtQ/JBBkw=",
    "cpf": "U2FsdGVkX1+WWaCVK7dprFlK2twc7WcObuvEBlc/Z/c="
}, {
    "num_cand": "U2FsdGVkX19U+r0tRsJfchv7iQ51el15+8UKfCrNtgA=",
    "cpf": "U2FsdGVkX19Ik5VbwjnlqFSqFSMQmW+H66/7i4F4XPQ="
}, {
    "num_cand": "U2FsdGVkX18K0mLPgY84+f+dEgtQUmBxb33YTx6E3IM=",
    "cpf": "U2FsdGVkX18Ox/67ZO53i0QLH21wRCm8qNyBmDfUbWg="
}, {
    "num_cand": "U2FsdGVkX1/mY+TrureO9q2Y2wgwNDZrEKtr6CjqyD0=",
    "cpf": "U2FsdGVkX18SxYV5sLDdC8qVjWGr5QoXOpF4RzqAZAQ="
}, {
    "num_cand": "U2FsdGVkX19b6rCUn20k4ZcIlYUP0Ytc/RAckoHQ4i8=",
    "cpf": "U2FsdGVkX18yPkwJUasLcZF1IkmSEZamfVisP6oAizQ="
}, {
    "num_cand": "U2FsdGVkX19sQsDwInF/81O9A14XE69RYaxNn0K6dH8=",
    "cpf": "U2FsdGVkX18ncWhElt3TYrYtCacH9rnkpwRsB5Qy8mM="
}, {
    "num_cand": "U2FsdGVkX19kSd0QvUY68LP+O79TyeXhmUx5RIcKsAI=",
    "cpf": "U2FsdGVkX1/DA2WrMxBxDZIRCmlTOwVvszINwit8Rlk="
}, {
    "num_cand": "U2FsdGVkX1/dikgzz5lmPNV+IFCP8DFjF+qsaAZ7jJo=",
    "cpf": "U2FsdGVkX1/Q5rCvUwT+9UQAxG/p2CwZLTIrOwtl59U="
}, {
    "num_cand": "U2FsdGVkX1/qsce67C0AmCEgnhe1jx1mhE9dY2vittI=",
    "cpf": "U2FsdGVkX18OikwQT8RHHuaXqZgZMvqZ1Ehla4KR0uE="
}, {
    "num_cand": "U2FsdGVkX18XT7PJT5rWgg5vFDSAQdueS+wQc7it7ew=",
    "cpf": "U2FsdGVkX19JI5x6DSPCRIH2L5EQvCagNiGpJrDDWOE="
}, {
    "num_cand": "U2FsdGVkX19dAd1d5ZyObRb6Xo1ZSyp3nWRUdRpUuoQ=",
    "cpf": "U2FsdGVkX19xKsXAH8KqaG00OGVYoJTqO06C38Lr2Dc="
}, {
    "num_cand": "U2FsdGVkX1+0vQS7IxJUZThIBHxiawwzKOsTFsOFXi4=",
    "cpf": "U2FsdGVkX186mwlO/dQcUM2w9/CGu7GyZh4t5zuRBP8="
}, {
    "num_cand": "U2FsdGVkX18xZLg59jAos7dy+3zI++K4aEOJZ2dSBlk=",
    "cpf": "U2FsdGVkX1/3ypiLn5vSsiHNshIPoGsr38dVI4wKrdI="
}, {
    "num_cand": "U2FsdGVkX1/YW2oz9o9l/GCuSBMPISkc7d5JvjQ4KQI=",
    "cpf": "U2FsdGVkX1+VolGGVmRDlMmAZfysPM47IF37L2VwgXM="
}, {
    "num_cand": "U2FsdGVkX1/KRgUa0mJLquChKufPq9suo1+18e71248=",
    "cpf": "U2FsdGVkX1/eGx3jGFoNgDWIrb4iap7g45gx8abE/l4="
}, {
    "num_cand": "U2FsdGVkX19xXfBeyWUNfG0ivgG0bmgQgf/p0sA0dTQ=",
    "cpf": "U2FsdGVkX18YyqRP9rJeEn6rkMye079uDCs9sF810yQ="
}, {
    "num_cand": "U2FsdGVkX18yZiNl359fayO2AYgZ6rhT7Sbzy7anmJs=",
    "cpf": "U2FsdGVkX18oz1aaCSbPlHbaGHY3uU/d7JUTpCMtd68="
}, {
    "num_cand": "U2FsdGVkX1/D2EZpON7vA0trzrFYnCyOp26h/Pyy/q8=",
    "cpf": "U2FsdGVkX1/GAt8CgBCK0z5cILPq0QORjINxJGyEUiY="
}, {
    "num_cand": "U2FsdGVkX1+zm/pa8ScUmZa8ttfI/KKNNnZ5wTIlX/Y=",
    "cpf": "U2FsdGVkX1+n66zjQtJ8p402y398XU8RsMioI71gGQs="
}, {
    "num_cand": "U2FsdGVkX19Kq//48cGS9/ZZpvuG2atIm/R1PWwVvU0=",
    "cpf": "U2FsdGVkX19QG+ArvM69lpXP+XO5GRkph1EKZ1iiogo="
}, {
    "num_cand": "U2FsdGVkX18bEiTfX1xrXs5V9J5PhBzkbEJIrJlLiok=",
    "cpf": "U2FsdGVkX19IPmFdrnqwgaPOuUx/7X0Y1cNLrLRVZ9E="
}, {
    "num_cand": "U2FsdGVkX1+Hu0sn0iyQCJGc3gJtMT/tqFF+Npmm/CY=",
    "cpf": "U2FsdGVkX19SaO12GCnoEXnXxSE4vTQk6w3+kfzHIkQ="
}, {
    "num_cand": "U2FsdGVkX1/3e+cx1SD4Q6qhFuoIpH/BMnpQmT0cFYo=",
    "cpf": "U2FsdGVkX186AyCE5hScvuUGKlohLXj/6uqRBrTHEAs="
}, {
    "num_cand": "U2FsdGVkX19vjA8bWQxdKbjWCgeyyWKhQN+W2hujXwU=",
    "cpf": "U2FsdGVkX18dknjl7Co/QB6p7Z4qM5ET7/GDjcst3kw="
}, {
    "num_cand": "U2FsdGVkX1+gCwuVMra1E5p5vmO0HWxor6vpVniGLGo=",
    "cpf": "U2FsdGVkX1+vJ173KgwCi3LhFt6ChcKWoZhiaqRCGbk="
}, {
    "num_cand": "U2FsdGVkX19wv1Z1ZEBxiaYM5DxWOhS83SO/rRHoNQQ=",
    "cpf": "U2FsdGVkX1+C/ZCDGR3Xd9iNbEwiy0FlyBlpXwKlkZ4="
}, {
    "num_cand": "U2FsdGVkX1+FXlh8GhZUagC3/op5dhnvMeF6KN4LgXQ=",
    "cpf": "U2FsdGVkX19CIMA8JjDDJGt/O5p/jWjHTqlQY8S8zsA="
}, {
    "num_cand": "U2FsdGVkX1+tjCLqQPyZH7j9TN08WT8Q5Eb4c+kCFy0=",
    "cpf": "U2FsdGVkX19v18E7C/yEN9LYKuvqakE2cPwvpNLCUn4="
}, {
    "num_cand": "U2FsdGVkX1+l9pvPkDD7V1+pSDcFVJigwu/bFu/eNbA=",
    "cpf": "U2FsdGVkX18nRl9E7vj+CiUaazBnsRCylKsZ60HgHRY="
}, {
    "num_cand": "U2FsdGVkX18aL3tZw9Hz8zE8S9qYse4JInDpwqK+GXw=",
    "cpf": "U2FsdGVkX18e3rUXOczeFpkyAuwm2+xBiG1kCH9bnDU="
}, {
    "num_cand": "U2FsdGVkX18v27rkcb3frV1JBTrTxKesth6I7czGNRM=",
    "cpf": "U2FsdGVkX192HR+Q56hbqgpgkfWzm4PlwdNBndKTGOs="
}, {
    "num_cand": "U2FsdGVkX18FzS8CJfVQkWt1CFdHcyEDU8Tx6j9I8dc=",
    "cpf": "U2FsdGVkX19Mwv6FshiqcR2ltHrNyWoMNmXsW5ghKbI="
}, {
    "num_cand": "U2FsdGVkX18LcY8IbbpxRSZr8I6BGk6GLGTmk27Ammk=",
    "cpf": "U2FsdGVkX19DIgCUf0w/G8TOQqLyAosaHJICZI7hjOM="
}, {
    "num_cand": "U2FsdGVkX1+WMs+f9zRlRP0jTrbbm4jFCtYF8TT18EE=",
    "cpf": "U2FsdGVkX1/5KB5gYWJHPqd6iOND+pIt6x3B3Id89XQ="
}, {
    "num_cand": "U2FsdGVkX18UBrIWjnlJmDkku/W1BiHnyZWcVxUNODQ=",
    "cpf": "U2FsdGVkX1+Bu3kGtbePAi+q2gCENpYZ7S2pbzdn2Aw="
}, {
    "num_cand": "U2FsdGVkX1/yWsHx7pa4RM3FqULM5ikt46BiHLiS4ag=",
    "cpf": "U2FsdGVkX1/BNXwdowC+5S4p472K7QRkLFMav4+i0uE="
}, {
    "num_cand": "U2FsdGVkX18ay75MdC19FIMpYgqqD3jaSMV0HuXylnk=",
    "cpf": "U2FsdGVkX1+m0ovpcoHotp0DeHkqGjwWMFDKIdJ/3t4="
}, {
    "num_cand": "U2FsdGVkX18F5zseSTEHnNAONCLYit8+is0D3p1vUc4=",
    "cpf": "U2FsdGVkX19w44WGn7lR34WjoQJT6UIb8kNTLCPCWfY="
}, {
    "num_cand": "U2FsdGVkX1+jG8QCLh5WTBbqgU3oInYM1Td1TUnhK8c=",
    "cpf": "U2FsdGVkX19dJ1mqRRzcP5YZWzt/DI+tGr9UrC6AVr4="
}, {
    "num_cand": "U2FsdGVkX1/r7wo6jZCmhRMlh+nUkp2rpMTNZH60Rsg=",
    "cpf": "U2FsdGVkX1/3Rr4pAocVjTZRyqZiPBwd9s1Ub0kIMUA="
}, {
    "num_cand": "U2FsdGVkX19IfDLmLMoK27xtajKNkUyJzuQaYkkr6Qs=",
    "cpf": "U2FsdGVkX180OcZhYo70RcuFgflbxTc9BqLPAdKbTIc="
}, {
    "num_cand": "U2FsdGVkX183YRx7+XYLwZyTf00HJxuvJZ2zHZFiP3c=",
    "cpf": "U2FsdGVkX1+iVBd2fU4BJIdFr3SDIfjEkqIZrGUhJVo="
}, {
    "num_cand": "U2FsdGVkX1/s2P4JzpGMRxUopw1RPDT0eqTH4Dn/IvA=",
    "cpf": "U2FsdGVkX19MuH3Ld7jEfWLHLDDCtLgS8AcvgLYIQe0="
}, {
    "num_cand": "U2FsdGVkX1+pPpZ/X5uOOgAGX7slA80bJ8+hE+8CGu8=",
    "cpf": "U2FsdGVkX1+haKZE22PAY6BS9zOaKjCAF/fqELArJEU="
}, {
    "num_cand": "U2FsdGVkX18tLBX8lW3lmeGcigd1uGLJCI9qytJqifM=",
    "cpf": "U2FsdGVkX1/YHVKejan2CEvrvMPaSTE9mTHmDUPac44="
}, {
    "num_cand": "U2FsdGVkX18NVxlUe7l2qVvSHR7YAK6Djei7bNmf5Js=",
    "cpf": "U2FsdGVkX1/Mod+KqWB1nQqarXxmnw9VQYcMOg/AiBY="
}, {
    "num_cand": "U2FsdGVkX19Dbp1rP+41s6yBmLEOK7xXwmEHoN9C8UY=",
    "cpf": "U2FsdGVkX185QvexTRzglabjvug8NNW/BJ+J37tlmN8="
}, {
    "num_cand": "U2FsdGVkX1/khQp6cPlAPAuxTNC53giuNU5ZWqk2J5k=",
    "cpf": "U2FsdGVkX19ba4U/oo6R/4iEBGaU9BQg+E6i+muShTQ="
}, {
    "num_cand": "U2FsdGVkX1/Pq5xexxV8QmAUFMRD63FRj/y14Uk6RlU=",
    "cpf": "U2FsdGVkX19f7Doa7ioLsBp4ScPpgMkPVDi4iOFynE0="
}, {
    "num_cand": "U2FsdGVkX19oqPoR6y7kXGX+XSvULZ8Wk41Iww50pBM=",
    "cpf": "U2FsdGVkX1/d+m8fewhd0V76rQKBFV/XLGIRwIth4hE="
}, {
    "num_cand": "U2FsdGVkX1+D5BSeBqKyGUcC8nt45bOKJkNT/fwBPm0=",
    "cpf": "U2FsdGVkX19sAXCOIFxIbMgc985n/VJGKOOTbkjHbUA="
}, {
    "num_cand": "U2FsdGVkX19VgwDFSz5/cCZtNN0Zk4zzPga7iXF5zCg=",
    "cpf": "U2FsdGVkX1/8KecM/+dLBwNJWgWl3kF7ijRT0Ryy9V8="
}, {
    "num_cand": "U2FsdGVkX19xrxlV0Fbbp7piDhkAcNafRr2D48Kua9U=",
    "cpf": "U2FsdGVkX19/gNGfq4d6taJLDIjkXLCJuQkbj8mZQM0="
}, {
    "num_cand": "U2FsdGVkX1/FezTDk8ex8TBPJry/o6iNHHNqLVBBPJQ=",
    "cpf": "U2FsdGVkX18udt8N0PjfiKK7UB8Z6oKSwQcf+7lLgqc="
}, {
    "num_cand": "U2FsdGVkX1+whFo9PWtDgHA3vYfWY3IeyUuiN9MEDM4=",
    "cpf": "U2FsdGVkX19YwgvS8ETK614y8GjFr0WsLqIcmDMAOyg="
}, {
    "num_cand": "U2FsdGVkX1+7srqJG5K8ZbzhQ7b5dxC2ruxTp8e3Elw=",
    "cpf": "U2FsdGVkX1/6n7lr7cvh0dR01PtPXS34h4+Ho7kGL40="
}, {
    "num_cand": "U2FsdGVkX1/5wExYcmuf52oV3Vs3gmB8eeoPDIv6QkQ=",
    "cpf": "U2FsdGVkX19X2tWm72xey2Nuy1xC/B/UZTMkOaLR+B8="
}, {
    "num_cand": "U2FsdGVkX1+MQsKuirErgbg2ZXA6848TW39wjUiLFu0=",
    "cpf": "U2FsdGVkX1+jMo83g5U92565OXt8e4LeqSwOM/4v8VY="
}, {
    "num_cand": "U2FsdGVkX1+g08GFb5KPGDew1mFyVCjrHSlj2/pdH/o=",
    "cpf": "U2FsdGVkX1/acQzH7zJVoiGLywtGSI8lA7Reojclem0="
}, {
    "num_cand": "U2FsdGVkX1+Gmgq5t9MDZYu2Ru6ooLlpOnskL/U5L1g=",
    "cpf": "U2FsdGVkX1/JPTU/Om7JuGO92ZJqbJ6bD9pWjneYaWI="
}, {
    "num_cand": "U2FsdGVkX1+KsS2vM3/co52nK3SIp9Va+UIvNy1Cu1w=",
    "cpf": "U2FsdGVkX1+NoCu0BWW/lNmUUWhiXFKhOYMjLPr5DkE="
}, {
    "num_cand": "U2FsdGVkX19Q7aQhLt2Yx2k+IFtWXoblwH8qTzkfbwE=",
    "cpf": "U2FsdGVkX1/tTAIek4smy/1Oae2HKeIrKqv01YA0joA="
}, {
    "num_cand": "U2FsdGVkX1/l9ObUWGK2paoLH9K8kfYtDmuTV3N6hMs=",
    "cpf": "U2FsdGVkX18JtH6KtKPe6Zfdi9aYvGGnorEIN9ylq+M="
}, {
    "num_cand": "U2FsdGVkX185UqZf+Io0wLf7wzqHfiq/W1p9vimwa9Y=",
    "cpf": "U2FsdGVkX19YeLGWkauJA1s+6BgE8VHJqEjXDOij0rU="
}, {
    "num_cand": "U2FsdGVkX18oS9CqOiBmCnMAW7ruM5DzaBiIERnUYvo=",
    "cpf": "U2FsdGVkX1/TOVUFgXIR2MyFWSktwf0FxNw0tVTQ0XI="
}, {
    "num_cand": "U2FsdGVkX18lID9LsUoOsn76eGFrWZVQE4765jBrREU=",
    "cpf": "U2FsdGVkX1/um1UQCavQC0kXxtqaXSYvygtuNqZ8qbg="
}, {
    "num_cand": "U2FsdGVkX18tyjbVsL5f2Bpe5j/4iiMwmvYdQtMy2BY=",
    "cpf": "U2FsdGVkX1/CVZsPzjCIxSp8x1m8g1salfBx9fi0w3s="
}, {
    "num_cand": "U2FsdGVkX1/Uk59/WdFOdMK21+KAT5Ig4iiwsIpSjGA=",
    "cpf": "U2FsdGVkX1+zCITIhvUlg4TFgL4YD3zACdFShro/n4I="
}, {
    "num_cand": "U2FsdGVkX19Tp7kE3agB5mmTRXw6fBzK9NKIIUFW3xg=",
    "cpf": "U2FsdGVkX1/FRpuhkuQ6oMQFkp2MM89xp8Z8NlW7HRg="
}, {
    "num_cand": "U2FsdGVkX1+XndwsMaSk7XfK1TX+yN5IOz+1KXRUceo=",
    "cpf": "U2FsdGVkX1+5ztd/kdMTIOGVhahp3Hs/9+8XJ58MKy8="
}, {
    "num_cand": "U2FsdGVkX1/6toysEoo7ALvu/ytIUJKEr1qdvZlLAtw=",
    "cpf": "U2FsdGVkX1+Qj1CquVHYtW+3luV9E3fKmCJTY36QbXE="
}, {
    "num_cand": "U2FsdGVkX1/tx4EXFFHAX5kYcoovEu/M13/9HggZoS4=",
    "cpf": "U2FsdGVkX19+q6r0oo8mndiPT8mP3Z5sV9tTcC4c77U="
}, {
    "num_cand": "U2FsdGVkX18224OjpGEUhOW/fqi5TBMka6AlEcGCKxM=",
    "cpf": "U2FsdGVkX1+lhLX7dwjpr8sKkjF3E5sb53EvXbmSqn0="
}, {
    "num_cand": "U2FsdGVkX18E26F/I/zMh8D/8yJd7MZGZOEuXjrTph4=",
    "cpf": "U2FsdGVkX1+AybIyEnW+cQEt/EKmmpQ47v1ALIOB5xM="
}, {
    "num_cand": "U2FsdGVkX1/s4K51mA+CiS2FS+IcGLTEbuH0GTTc59o=",
    "cpf": "U2FsdGVkX18y3VLAcjdP+xxR5p0ARjELXK35mdq5T08="
}, {
    "num_cand": "U2FsdGVkX18VaNdvToaWdXwRWiGdhIfQTTQQL6lN494=",
    "cpf": "U2FsdGVkX1+2CSeAydOqYqMnywLVnjpylApD8TATOCg="
}, {
    "num_cand": "U2FsdGVkX19WCPdiggqnKoxQ486JcKqyXJkrYoibeJs=",
    "cpf": "U2FsdGVkX18sAMMpwIEobiBr8Sdwpl7zfK20TurMHDI="
}, {
    "num_cand": "U2FsdGVkX1+wdjosGwSz00KZb4xRS32ciXQ9DEKExHE=",
    "cpf": "U2FsdGVkX19TGY8A6tm3fm5D3IjWe/jqXYxXkmdWinc="
}, {
    "num_cand": "U2FsdGVkX19o67LM+9v88GL8Od8M6jwIcO9MWDyS1J4=",
    "cpf": "U2FsdGVkX1/MQU6rIlTmiytYNh3bJT+YRQq7qE5YZoQ="
}, {
    "num_cand": "U2FsdGVkX19m+pGn+bcHVRtdgf1tWLpUZfTAoQfT0GU=",
    "cpf": "U2FsdGVkX1/2nkfWggyXb0MXqezNa8jvqgWpVjIfq6U="
}, {
    "num_cand": "U2FsdGVkX1/1WIKtrQBwNyo93PziiWqvWbjfBByL8Ss=",
    "cpf": "U2FsdGVkX18Ghnew9NmIZ0tz0sIatSYmyRQWHkbNbzE="
}, {
    "num_cand": "U2FsdGVkX1/whv8s3Py91ToRsNzzJqupAAQquVw9h5Q=",
    "cpf": "U2FsdGVkX1/mmmfYmIxMYLvY9XRzcRCvdAfQA6o5yJo="
}, {
    "num_cand": "U2FsdGVkX194arbOiw1FuDVgsJhQl8xxJQBOZBJVnnw=",
    "cpf": "U2FsdGVkX19Ud9tFxs4HZuExkAGejUanEiAEhRofU4w="
}, {
    "num_cand": "U2FsdGVkX1+s2cTGCqYXGeBJPAbVY2R9t8Exg0nzSQs=",
    "cpf": "U2FsdGVkX1/bwVJfigMHJrSxRUVaUz1f5pzc4zCDLTk="
}, {
    "num_cand": "U2FsdGVkX18die5jentR8nJVvH5BnWcqOwZripQs9fI=",
    "cpf": "U2FsdGVkX1+iuQMfiFPXuxB3ic+iNrj2QQ4S5O8T6xE="
}, {
    "num_cand": "U2FsdGVkX18qJY0TKLOibBtzP71FG0ZKHqpbuJRV3+E=",
    "cpf": "U2FsdGVkX19rJkVikegFJJHxGFpWrq/4/ItZRV7G67k="
}, {
    "num_cand": "U2FsdGVkX18MwGuRoXgJ7ClkLjZ6QsL8/VGC314zI9E=",
    "cpf": "U2FsdGVkX187LXWOPVdEHOoAEzwFAQyJf+7+qGVF66M="
}, {
    "num_cand": "U2FsdGVkX1/aPzTcb2OsOwum4ftwq967xk3AN40ZOJQ=",
    "cpf": "U2FsdGVkX1+YOsPE6rlUjm/PoeGKL4OravwWYQoDQZQ="
}, {
    "num_cand": "U2FsdGVkX1+0lXrXZKLH0SD0Yb9eLc8inPsSBlJT6PM=",
    "cpf": "U2FsdGVkX1/vPIZ2LWbBmStwGQNiX3PBwJw1PtkBjfs="
}, {
    "num_cand": "U2FsdGVkX18lpz1ZPSCHdacFPU1B/lHBrHB/tnGgIKM=",
    "cpf": "U2FsdGVkX1+aBMHvJU05qghoCjDnWPJA46dQ9hpfOkk="
}, {
    "num_cand": "U2FsdGVkX19A/dnegNq99OxBOZItBul8g88mzA3D6kA=",
    "cpf": "U2FsdGVkX18g7PseIQalocTjm8N59AtZ1vfe8oaCwfg="
}, {
    "num_cand": "U2FsdGVkX18UctDsCEPeOJ4WyPcEkq+4fhXGhhdRwCQ=",
    "cpf": "U2FsdGVkX192lvhaSxWh46MQi+i1uH9zQ2yRFt5fXso="
}, {
    "num_cand": "U2FsdGVkX1/tOyHGlToyP5cz8qNVlwo+XelSkLMhG1s=",
    "cpf": "U2FsdGVkX18e8j0gVQv6EMRqUaA0eJRZVjjIhFY0ys4="
}, {
    "num_cand": "U2FsdGVkX18RFbmihyI6Vxed/AA56punO924HsRG0Qw=",
    "cpf": "U2FsdGVkX18HvyLOx3utTHt8bcaTvppDqt6avTf2RxE="
}, {
    "num_cand": "U2FsdGVkX19kQHp1TsqKUpY6Jv8RfG8l1ZtiZlMnzbM=",
    "cpf": "U2FsdGVkX1+A9HCIIRtJuuvcUHu23N2SNsvjj+1ycWs="
}, {
    "num_cand": "U2FsdGVkX1/ohhtDg7q6ZmnuquiGu0UDHWAJQjel+kQ=",
    "cpf": "U2FsdGVkX19QZ93kPI9sjG3LLDWRZ8BbsMuHkhWZTqU="
}, {
    "num_cand": "U2FsdGVkX19/Ozzzj+gIsdBpDExMEv9Zf5WvIN6hOmQ=",
    "cpf": "U2FsdGVkX1/kUBIeKNOp6DPpvSrWZ9gAW7MsZU/wMiM="
}, {
    "num_cand": "U2FsdGVkX1+4sPf3sCfse6BInrePBHzdZ5s0J5rjBww=",
    "cpf": "U2FsdGVkX19K0hhNOKxxZRgAoQZFLY/Yh4q+DnF7xX0="
}, {
    "num_cand": "U2FsdGVkX1/nV9h+Yz31sjvnaSKv6REKC2XiA//w8wA=",
    "cpf": "U2FsdGVkX19K7jlEJsFE+eis1gYDqSZfLSDXyy6clqk="
}, {
    "num_cand": "U2FsdGVkX1/WgHE/rV/A3AC78swTgT93Z3JC30FU2hs=",
    "cpf": "U2FsdGVkX1+KN6nPxXGbs0/5YOUlDQnbDv+6GCYb6nk="
}, {
    "num_cand": "U2FsdGVkX19taE3mKLIeiljh/3ejIv3ttyromkbITiY=",
    "cpf": "U2FsdGVkX1/SfxuWvmd7M81t8ZoUqyT9JIa4Nfqsy3c="
}, {
    "num_cand": "U2FsdGVkX1/9+L68ISNXolWDN4cs0gxcKnuKxrWYTaE=",
    "cpf": "U2FsdGVkX19Co5wlNfRIu7LnPWg3C+YIm4xpulvABz0="
}, {
    "num_cand": "U2FsdGVkX1/YbE0iBfBty1ToGaBhW/aKOW462UsNvUc=",
    "cpf": "U2FsdGVkX1+Rxl3DVS3rv5sEhCpOQLXmpMkGIWfFQdM="
}, {
    "num_cand": "U2FsdGVkX18CO2kuNUxFSofR2nN8bfji+nckPeriqjw=",
    "cpf": "U2FsdGVkX1+gBEPmBqn0P6NfuFhdG1r04N1NXPPRNG0="
}, {
    "num_cand": "U2FsdGVkX1+x6olP1Z8BMpdzg05CI/wX/cYDKZA/WSw=",
    "cpf": "U2FsdGVkX185gOCmGbFQib3tkXd9wFH+ai1pbOpJ+gU="
}, {
    "num_cand": "U2FsdGVkX1978Pfg5Tuf9OBq7JW5QTR5+5m9r6/1YNQ=",
    "cpf": "U2FsdGVkX18DbSWflk7pHPeReS62zA847rwDcE0orV4="
}, {
    "num_cand": "U2FsdGVkX18M6bXFQaLbOQucA+hcCY8Mb/CVKMkS0SU=",
    "cpf": "U2FsdGVkX18L2XhRwxpGGbK/UtAgd1pbVtwg8Z4qL/U="
}, {
    "num_cand": "U2FsdGVkX18Ufs4LciW6JNkOF2u3Sa2+CvMHyVk2uvY=",
    "cpf": "U2FsdGVkX19Jj+LyUF6PezQd42NBVNKD50ogpsXaTto="
}, {
    "num_cand": "U2FsdGVkX19N78/S2EZbKkqjMRvEClPIVlnpMrl++w8=",
    "cpf": "U2FsdGVkX182/9ofAmQnI0i+DRFkTSkG4+3ypL/IIsc="
}, {
    "num_cand": "U2FsdGVkX19mOPC6/6pn/Hk/LGzi7PKBgQNysYOcOnQ=",
    "cpf": "U2FsdGVkX1/00mGYHkgsuBU3t3AWobUPXCPVEcWpffM="
}, {
    "num_cand": "U2FsdGVkX19PtgtlbSVxX5xVivWWflPf/AIGt9aYlcQ=",
    "cpf": "U2FsdGVkX1978m1piXgjzWCpB0L+n35nqX9qcNhptb0="
}, {
    "num_cand": "U2FsdGVkX1+UK7aBJxHYUhfqJUnjESBf05KNC3SSI08=",
    "cpf": "U2FsdGVkX1+CqrENYSLnP7xy5SGplWk/RXngwd2Fnc4="
}, {
    "num_cand": "U2FsdGVkX1+OmtJ/1YdDl+47j6frHgXBQcHc3vwVvPs=",
    "cpf": "U2FsdGVkX18vVPwUpbC4hySPOKS8gpu1FKuu5XvsNoU="
}, {
    "num_cand": "U2FsdGVkX1//4rOIPoZh9mxNellnhkng3TqM9XNiTZI=",
    "cpf": "U2FsdGVkX18R76j/SONpWyW6CZLgzWqeEEZJ2AM2tEM="
}, {
    "num_cand": "U2FsdGVkX19M1HyCap8UWGs9rumqK20f6Pq4kRxfHOk=",
    "cpf": "U2FsdGVkX190Jn7alGz3K0HYFaExTo6/3THq2WNj2rg="
}, {
    "num_cand": "U2FsdGVkX18jp+gMJFHR1K08V1Wg4FzWUspyMVGaX0A=",
    "cpf": "U2FsdGVkX1/V07ftd57Nn4FPjJRODb4Tm2AXwlSa/Ro="
}, {
    "num_cand": "U2FsdGVkX18JIhInSViiBLYb8iWXh4u79egQfd2ZdNc=",
    "cpf": "U2FsdGVkX19MoW/n/Tj4xbVFMWHko3Ek/H1Y8s/V5fo="
}, {
    "num_cand": "U2FsdGVkX19iEAHui0XE2G/7nvUavjj9tBb9YnJ2lfQ=",
    "cpf": "U2FsdGVkX1+3D2h/hc41uEtjucYdGwWEGZ23XO0EK58="
}, {
    "num_cand": "U2FsdGVkX1/WwbAM9EPfdKsyPrNXQbEz5pZRO40sqAM=",
    "cpf": "U2FsdGVkX1+g2SB8VNvN+hDGLQCKClw1YU7rzz+h+xc="
}, {
    "num_cand": "U2FsdGVkX19YObzwXkYlpQnjOxryu2Z/je8bkLewIkU=",
    "cpf": "U2FsdGVkX19ybEiYWv19xxNcy0aXc5jobTwX7AonTdM="
}, {
    "num_cand": "U2FsdGVkX1/u6ZrRvC/5QkNfBgrtNYCXoLzrJp4KM08=",
    "cpf": "U2FsdGVkX1+4BbJynYvx0v9cAVsWhSob2G696b5sG/M="
}, {
    "num_cand": "U2FsdGVkX1/Alqh1xrqR+2ZAJEwesMvGuvDkBd4gz7o=",
    "cpf": "U2FsdGVkX1+A6Uj2fjjSC0Xhadt2EsxEq7GLJ/hDtJo="
}, {
    "num_cand": "U2FsdGVkX19kjvbmTvvylfpKRkB/rUU0fFy8WRHqoRw=",
    "cpf": "U2FsdGVkX1+KdPwvnuUTKX3MDbfYgMNmJ5AiCnh5Bzk="
}, {
    "num_cand": "U2FsdGVkX18nOFI29xOPwvrC+8MAo3C79agIvUzaMpk=",
    "cpf": "U2FsdGVkX1/osTGTM7dcU69wQvVnFrJ4TSgt7DyweT4="
}, {
    "num_cand": "U2FsdGVkX1/33ewIBhjW6qponcUA6ZvIesq8D4AKEog=",
    "cpf": "U2FsdGVkX19lrORlgzZAT3fMVVGb3dVCu/hTej3rswE="
}, {
    "num_cand": "U2FsdGVkX1/y3griGkA37og/FaM0GPXE7Y/Js7MTOjs=",
    "cpf": "U2FsdGVkX19LYCOu+5W+buWxZpyrGlynD+zybi2A6BU="
}, {
    "num_cand": "U2FsdGVkX18TyW7OilmUFkouma0S3PHghy2SAfbE8RQ=",
    "cpf": "U2FsdGVkX1+7o8CJEPYMyZoHrjEAaAu00yN0ruKYm9I="
}, {
    "num_cand": "U2FsdGVkX1+o5jqzPAhXuFEzwiYN6Vdr2y8LJMAbgx0=",
    "cpf": "U2FsdGVkX1/rIEHDxjUaEm/6d3TmgPe6coCkvfwnhFw="
}, {
    "num_cand": "U2FsdGVkX1+HVCqetK9XCbEZEE91r4V+1gnIC/L9Omw=",
    "cpf": "U2FsdGVkX1/Tnq1kIVYOQ22BLeWnbIxi5zCv/ifclFY="
}, {
    "num_cand": "U2FsdGVkX19k8gc8OzhN5Da3tbHeAZHG+mMI81ooHaQ=",
    "cpf": "U2FsdGVkX1+VvhG32BPsFzVa7Bp/N5bZrIke4/uzxgg="
}, {
    "num_cand": "U2FsdGVkX1+K7Mujew5tRWzOajyvz2oho90vc6tcqKM=",
    "cpf": "U2FsdGVkX19LFFrstQ3i3raWqxR9aKOtnF2yG5KPmiY="
}, {
    "num_cand": "U2FsdGVkX18NDQzf+3afez0EhhpFD2/58O3Tf6TwXg4=",
    "cpf": "U2FsdGVkX1/iF2A/IbZrU1DSXn/uybS9tAZx4OWhR4s="
}, {
    "num_cand": "U2FsdGVkX1+K8bHMKuWPkvIsAPr9sQXlb0MWtiEftME=",
    "cpf": "U2FsdGVkX1+qnFxVo0OrSFzXnx4Cqwm0lhsRAEHJbJw="
}, {
    "num_cand": "U2FsdGVkX18AMofbXMP3UrWeCV3DdPnkQtZ3Y8V4o+Y=",
    "cpf": "U2FsdGVkX1/Ii+0XQLvSi85UNTTQQjlzjdI+AhGnnl4="
}, {
    "num_cand": "U2FsdGVkX1+prUkXrHlJHN1qosX/wVhtcqXABf/lSxQ=",
    "cpf": "U2FsdGVkX1+pQOGieg1O6iydW1pZTvYHCRzpwIplPoA="
}, {
    "num_cand": "U2FsdGVkX1+mwHqhdi1Hu4fOhw2WR89t3W7Pg3/ap6Q=",
    "cpf": "U2FsdGVkX18gJb56uYfOGRy3eGdkcemmlagci9bDai0="
}, {
    "num_cand": "U2FsdGVkX19HScJuQh/D9pHRkqZco85zWnRflWV/u0U=",
    "cpf": "U2FsdGVkX1/hRhLhUmzmD/AtzXUZPvUqh/1TUR4ulYQ="
}, {
    "num_cand": "U2FsdGVkX1+S3/ezUA0z3696uX2QWbUIRp1etoSc6u8=",
    "cpf": "U2FsdGVkX1+CtOfZ4MFdn71Sr6fWsb3o2uW+NDi3WuQ="
}, {
    "num_cand": "U2FsdGVkX19HsxS/CsAxi+RuyCEu4dz73q2/saTw/HI=",
    "cpf": "U2FsdGVkX19ZZA5Ei6O33zseezUipgXGVvm6fJCdiAM="
}, {
    "num_cand": "U2FsdGVkX1/GJn1tiQulany9j8qQWWCyVU36xfDJqRE=",
    "cpf": "U2FsdGVkX1+BZzWAo3/SZrWJKA0BtrGRZIt0DMJuts4="
}, {
    "num_cand": "U2FsdGVkX1+3rTbcVPG6dPR8EwnnpIuImaXXPQ7N16o=",
    "cpf": "U2FsdGVkX1+j8bCYmxuzcT6GLlqSZyP9o3UIcIfLDkM="
}, {
    "num_cand": "U2FsdGVkX1/DJj/EwiCHQR2Ow6MQV2SPEKMQg0OXAok=",
    "cpf": "U2FsdGVkX1/qbVHZd+Mbs8Vct+1yzYfzlWJiyV8g1os="
}, {
    "num_cand": "U2FsdGVkX1+tSf4h+PuOwaDjOSokCjzacfNfB1+m8u0=",
    "cpf": "U2FsdGVkX19jypNQJIx7gADQ/iS4FnG1g/CfdvijFoM="
}, {
    "num_cand": "U2FsdGVkX18bU2q/Mkuw7oa52T5zlv6mnr1R5Ki8Ux4=",
    "cpf": "U2FsdGVkX19SUioY+T0DsN/rsNQBw6+l7ewygaGAmm0="
}, {
    "num_cand": "U2FsdGVkX1+3qi4DT8Ack9QVX4QE2gsCn8bxiIWVlfY=",
    "cpf": "U2FsdGVkX19KYjYh62Xy8mwkKpZMccaV8H7vytulJ30="
}, {
    "num_cand": "U2FsdGVkX1/Y61fEybSXLYqlvGT5qDFcqScwy84z4WA=",
    "cpf": "U2FsdGVkX19QZWyEzgdMeQ35AYUcW1mWTQLu5mQWNUE="
}, {
    "num_cand": "U2FsdGVkX1/DTvvIXpcjAVF/23ExZERJNBrLDnmmAHM=",
    "cpf": "U2FsdGVkX1+O5AR2QT27a8RXSwfDiW7GSZZ8xZJ7Ups="
}, {
    "num_cand": "U2FsdGVkX1/SNPtBE6iCj2ei7zplA+dQIqK/zhK0apI=",
    "cpf": "U2FsdGVkX1+m226BokTkLedOYaAVmzrk1vUXUkIRtGE="
}, {
    "num_cand": "U2FsdGVkX19o/CS1NseTbKplahpytJvSWD66fDmpANY=",
    "cpf": "U2FsdGVkX1/g0VaZ36ygVdxZXCH35Pu33T36TyhG3wo="
}, {
    "num_cand": "U2FsdGVkX18uZ+OzRcgRSiBgath69gWurRknNYPGHhk=",
    "cpf": "U2FsdGVkX18PB7pZm0OID81UxBGe3DrBNPZWlTUnBJQ="
}, {
    "num_cand": "U2FsdGVkX18GW0qlRitzm5LDYfR9XluXtB35WMeJJ7U=",
    "cpf": "U2FsdGVkX19OFgsRdpjWYE5eJsEz/3NxMLI46tt40YE="
}, {
    "num_cand": "U2FsdGVkX1/5y5+iHdm6XnU0TJOCV+pE55EpEKlLEwU=",
    "cpf": "U2FsdGVkX184tFEf7kcLOf2xy40Q5x+6s1JqkVKGfiA="
}, {
    "num_cand": "U2FsdGVkX18kk6U+RESqgyPeItIM9yAD4t+eXBRIZyI=",
    "cpf": "U2FsdGVkX19Gki9YbrvOx3NlHZB1jGz3Pi1HxYWZtaw="
}, {
    "num_cand": "U2FsdGVkX18q6eu7cl2o73doTN2+HgkKFgzffuD/l28=",
    "cpf": "U2FsdGVkX1/hr+uGxggU+ymFg01PZzpgJ5YkG+cYfS8="
}, {
    "num_cand": "U2FsdGVkX18Wx4T/aOaULi49dClCEuvFCpl2nwARqhE=",
    "cpf": "U2FsdGVkX19byMHX1VRqXSSqRqADtdJ9oa7knXZR/vU="
}, {
    "num_cand": "U2FsdGVkX18DI0ahxVejepl7C4Y329arfL4OFxJrBeI=",
    "cpf": "U2FsdGVkX18P8pr8XA65tLAejkq3PX0EBUeK5YioaVo="
}, {
    "num_cand": "U2FsdGVkX19v/nA1lbJs+VmXNOAF5H9RaCztM10vtPY=",
    "cpf": "U2FsdGVkX1+uYxqHW9a6Fxy+V+TfUOoRhcMv+Uer298="
}, {
    "num_cand": "U2FsdGVkX19x5Hm3RZlLcR3w2/ZiBDgfdNiF+9dJRvo=",
    "cpf": "U2FsdGVkX18cDfOQzfOrUGZSxa4bRvQoTLofMYBzLyM="
}, {
    "num_cand": "U2FsdGVkX1/zARHv3E1rLtUyncFcaMNuwAaAL8Yrpxw=",
    "cpf": "U2FsdGVkX189QFMyqXylR5anBVVt16YqshKXFGKMBNA="
}, {
    "num_cand": "U2FsdGVkX18LUDik3Mq86cRJiREPWybcUo3N7bwwnfg=",
    "cpf": "U2FsdGVkX1+wydHEmm8sS6q7k6fNrKI6OZG8zkAZbz0="
}, {
    "num_cand": "U2FsdGVkX1/fFml8/av8fZ1ngLv7YDtLPJMOnkzAdNo=",
    "cpf": "U2FsdGVkX1+l+gWznMCWll7Cx4QYkt/C/bxsy+affMU="
}, {
    "num_cand": "U2FsdGVkX1+rx9O/VzJt54hNb58raOgKmBL5TgGAxtY=",
    "cpf": "U2FsdGVkX18WFRECyPGRIEIpJBHp9a2zSnXaarIIHjE="
}, {
    "num_cand": "U2FsdGVkX18cHMfTdsN8VMx8XphGosKCOPYh5so5qxc=",
    "cpf": "U2FsdGVkX18PraBjk9LIfgsV0mNJ3a7EWY+oiUVSggc="
}, {
    "num_cand": "U2FsdGVkX1+ffPSFTNRUe0LLAFwDmCRKZTMZOSgKTRw=",
    "cpf": "U2FsdGVkX18bst2bEDG1BbkEMkSRSs/WWBIEWlmVKiE="
}, {
    "num_cand": "U2FsdGVkX1+oitP3/hLJ0jR5TQm5tk0JRErhr955+c4=",
    "cpf": "U2FsdGVkX1/hoycFSCXmpstb1pMEnDacrpMpsFQmRS4="
}, {
    "num_cand": "U2FsdGVkX19+w1P9NeMNIxdpXb937Olnru4Uj1iQhfA=",
    "cpf": "U2FsdGVkX1/uj/waLjA23CIJi+DmyPi3Vo96qVqgpto="
}, {
    "num_cand": "U2FsdGVkX18dTAmONUSy78XvHRym/+ufNNsxpTVQIaA=",
    "cpf": "U2FsdGVkX1+rqZjQqht1jm1rnXPNpr94PtCDCeANp3k="
}, {
    "num_cand": "U2FsdGVkX1+PF2fLPannd2zXdOzS/fndjNrW2qizXaU=",
    "cpf": "U2FsdGVkX19K7LgPGS9QWvLpn6vsHEEg61Ctv2Rx8GE="
}, {
    "num_cand": "U2FsdGVkX19fswgHOsl61X4pYoyvpNQGI3o/1O1/0Eo=",
    "cpf": "U2FsdGVkX19WDqDMld/1OUhD4bIDjlawargDIkfrNKE="
}, {
    "num_cand": "U2FsdGVkX1/0J08KJu0x1kcPvT0aDUe8vpAcRVOi70Q=",
    "cpf": "U2FsdGVkX18MlYg38IOhjwzeFglHvLZYh8tZv3kvb1E="
}, {
    "num_cand": "U2FsdGVkX1/x0MWN7bQ9b/i70k5uiK4I+b5mTcAUKaI=",
    "cpf": "U2FsdGVkX18Abee7Ll/cW6s1gxeZZoJkaXIf4JXMkMM="
}, {
    "num_cand": "U2FsdGVkX1+bloENfi3fFXYOCF5gG4Gx/i8tNEukXIU=",
    "cpf": "U2FsdGVkX1+L6L3gKDlqzO+a8o2U4zupjeD19cQZ9xc="
}, {
    "num_cand": "U2FsdGVkX1+87s2lSecrwp4qHW3IL+9Xi7v6hM5u3ZQ=",
    "cpf": "U2FsdGVkX18oVcozI6dia1WWTuGyHIo1eLLr84mquIo="
}, {
    "num_cand": "U2FsdGVkX1/YV+9zTuAI421L7PPpUENADvIxT2q3jeo=",
    "cpf": "U2FsdGVkX18FmcU3zPuL0/q2WDHpNeaGUg/EIEY3iHs="
}, {
    "num_cand": "U2FsdGVkX18BHBjXbax0YYFBMJbHy9ivLClaZzvvwwY=",
    "cpf": "U2FsdGVkX18p8f8GTHpLNCfd+3Z9GckozBzw2MaCU/o="
}, {
    "num_cand": "U2FsdGVkX1+eVKbynfg1KHOvrEH615/mR3PSxynsWRM=",
    "cpf": "U2FsdGVkX1/sjtcnUBnzJZkgpJSRgnjDnbDJb524hI4="
}, {
    "num_cand": "U2FsdGVkX1+1c3C+6MctejUO8nW/u9oYAyOdMfKY3FU=",
    "cpf": "U2FsdGVkX1+5PqMzv56qE1+bsRCecbSjc3D2EO4ctRU="
}, {
    "num_cand": "U2FsdGVkX1+1lcAc7MLhC3xqrsdgmr9ulYJDx7AGEh8=",
    "cpf": "U2FsdGVkX1+USOSPTT0Htj2EFX6MI39dzC/Tv16H6ZY="
}, {
    "num_cand": "U2FsdGVkX18FLOUgIy1hie+fAYLJb8QoMPvF949jLe4=",
    "cpf": "U2FsdGVkX1+8wBSYSLN05525W60cg3moOmJ90eLx19o="
}, {
    "num_cand": "U2FsdGVkX1/PmN7ywr2SdEaoQB+r56FIwVB8KZXIW0g=",
    "cpf": "U2FsdGVkX1/a7trfSJoxDAN2AYCcSCvmbxD6gAs92dY="
}, {
    "num_cand": "U2FsdGVkX1+XhLGtcur4jFgbFvs1RG8IQkH+kv6Ph8Q=",
    "cpf": "U2FsdGVkX18fwpEYzkbQ9ncbDE91ZcVIGGSU1EU/h9A="
},{
    "num_cand": "U2FsdGVkX1/+k4n0sZZhC79gNGLcW5fhl/vPSiIa1iM=",
    "cpf": "U2FsdGVkX1/fS2frqt7XeFGwKxT4A7dHT0yN4KIjZ74="
}, {
    "num_cand": "U2FsdGVkX18R6k4ROyiWJsnjDqOzw9zRHYjFNzXyVs8=",
    "cpf": "U2FsdGVkX1/kFfR2CrjG/LXB68DzP1KKdUAogFOQJGE="
}, {
    "num_cand": "U2FsdGVkX19ofPyWwXyyX9IdaB8nDiga9Xc1daF2bm0=",
    "cpf": "U2FsdGVkX19X8GB1laHNb0hXrB7PH+mjEW4ySuGW6NE="
}, {
    "num_cand": "U2FsdGVkX18iDg6i8Tyyzl7ledzb+NkuLVFLWgxSPWY=",
    "cpf": "U2FsdGVkX1/kcXSzgPo87GJfaJtnK9FxNmEq3vKpXiw="
}, {
    "num_cand": "U2FsdGVkX190/TXa/icHNTkfbKH+Frmvxg5/gX5Q6I8=",
    "cpf": "U2FsdGVkX1+CWlw7NEbGDpukD0pf5dAZ7PUAXojloy0="
}, {
    "num_cand": "U2FsdGVkX19Zv/wgGN1ZvE0hd+pZzJKDSNwtds2EeA8=",
    "cpf": "U2FsdGVkX18aDDyl1w33C1SwB5U8YJ3TGTY4Bm7bMnw="
}, {
    "num_cand": "U2FsdGVkX1/fJlVEQcN93PolPOf2dEU1F0ewIlpteDU=",
    "cpf": "U2FsdGVkX1/tef5DBHIBdhncwBBSo/BomJqsqGp3fgE="
}, {
    "num_cand": "U2FsdGVkX19fscB+3gxUaz1pMO3JFSsd5FRtcT1krVo=",
    "cpf": "U2FsdGVkX18tqSzv8k36/+d1oHtxuDHFlDgyYtaFBoU="
}, {
    "num_cand": "U2FsdGVkX1/sxS16tQGy7lCnzqeehS0fB0grocCXaP8=",
    "cpf": "U2FsdGVkX1/HI3mFZqZDCFjMkv+PUwQ2dk2+TA9TEIA="
}, {
    "num_cand": "U2FsdGVkX18WzNcsoLfHwOJ2gqi84XV61STzX7vBywE=",
    "cpf": "U2FsdGVkX1/XP4WvPLH03XCfUot+Ncqc05DJVO6M+iM="
}, {
    "num_cand": "U2FsdGVkX1+yLycE/bnaXm+aDnDDIygKOMjAzNtuNqM=",
    "cpf": "U2FsdGVkX1+x4TkG8o7eBwEpNVdtrbtiaWxaW1x32cw="
}, {
    "num_cand": "U2FsdGVkX19oaB1EpE+AIY+HviB0AeOKgnwcX6ERgFk=",
    "cpf": "U2FsdGVkX19v3+DFKE/SgplCEwW55C3R1tDaAaWyKl8="
}, {
    "num_cand": "U2FsdGVkX18IMFC+sVvtBcvyQGkGxLCnS5aI1UiUfG8=",
    "cpf": "U2FsdGVkX1+2vPgL0S0CKfqlcCLsVmR70LAODa3Rbck="
}, {
    "num_cand": "U2FsdGVkX19kp7iy1uEDakEKVGuNUEOMGrcxtAWZe0I=",
    "cpf": "U2FsdGVkX18lqi1zwstH9DD5oDE+P2h8Dzvprvhf1JU="
}, {
    "num_cand": "U2FsdGVkX1/sBtz5RBWr/RXCpOWPI6NuXaPFHX+p/Aw=",
    "cpf": "U2FsdGVkX18M6PI7d36JeWtNukJexfxKVOkdG2kY8OQ="
}, {
    "num_cand": "U2FsdGVkX19vhzYMeX71RKTyOnb2kAf/Zd+ncyxgQss=",
    "cpf": "U2FsdGVkX1+y4qMvbRcPco4NTQjZmshkiGRdcCWErzU="
}, {
    "num_cand": "U2FsdGVkX1+otCf5gdjt5gwAnD1QIDlaNzHdpislADg=",
    "cpf": "U2FsdGVkX1+4k7tWU39Eb+q5aWKx61TLynB5MfbvU24="
}, {
    "num_cand": "U2FsdGVkX1/3rlDbwjAHfrIBVFo8Zt+mJE4HKClBViY=",
    "cpf": "U2FsdGVkX1/s8Hkz7pwtRSW4bWkAnqdPiBLlVsKqW7o="
}, {
    "num_cand": "U2FsdGVkX1+Xs/+bSTdE2SAjCAd3V09WD8vx3u2tSAA=",
    "cpf": "U2FsdGVkX18CbgRsYZ/mHxoyorBajZsDGzvjxaKRAw0="
}, {
    "num_cand": "U2FsdGVkX1+iHodxX5gsTIAVQw9+waVjUPdBvXHydMY=",
    "cpf": "U2FsdGVkX19kexchSL/UO3OC9yZxJ53/q/G/8xPhYvM="
}, {
    "num_cand": "U2FsdGVkX18xQauSmaZx/SptIx49ph3ajDgmGnAYc+k=",
    "cpf": "U2FsdGVkX19+hef15wOGky9Dm8GC71meUGePK1Dm34o="
}, {
    "num_cand": "U2FsdGVkX19SlzN/HwVwmGEGj83K3VsPE4CQ2+wiruo=",
    "cpf": "U2FsdGVkX18xg12EcMBwTy7Z08zLWm9bjBUHJ1ykJ24="
}, {
    "num_cand": "U2FsdGVkX19+fgmhI209n60FKAdfeFV/G2iEFHyzzMU=",
    "cpf": "U2FsdGVkX19M+8hk20GAf8mNA2fHQI+zvXRSLkbOg9Y="
}, {
    "num_cand": "U2FsdGVkX19poipJpIK+BJbNoQfWD8Y3QaGQtt5Irug=",
    "cpf": "U2FsdGVkX19OBIEVmFM1Lzb6DMuYGarFNvcemYaQmQw="
}, {
    "num_cand": "U2FsdGVkX19WZ+aFTPlKuAG2hc0ugjGo3g1d2JbupiI=",
    "cpf": "U2FsdGVkX1+boVRogFk2p6e614i/yoVPLTWfGNSMy1s="
}, {
    "num_cand": "U2FsdGVkX1/r+4If/p8ib0SS3cbdq+LOGe6/+/7zN0s=",
    "cpf": "U2FsdGVkX18q0Be7SNMGW5esirpH8aoSmxVBp9DjASY="
}, {
    "num_cand": "U2FsdGVkX1/kLLaSLTmHAwWwBLB3NlEyMiveko+OI+k=",
    "cpf": "U2FsdGVkX19eg5LTAvT+mcwTAkScy8JWyoueBGDDY/8="
}, {
    "num_cand": "U2FsdGVkX19FVy92uVTuGmHtd1qixwVaEnY8lj7AMnI=",
    "cpf": "U2FsdGVkX18eVcQI7judFdJf3mPAwND+B3uSRN0J9iI="
}, {
    "num_cand": "U2FsdGVkX18GtdDwrfF3TVZu8VTxF5PIE7u3r2eM21Q=",
    "cpf": "U2FsdGVkX1+auXfiefPAUplSgs8eu2lIcxi8dACOFBM="
}, {
    "num_cand": "U2FsdGVkX19+pWotDM6pRKsouG9ROh1Va/Sz7d+Vfqw=",
    "cpf": "U2FsdGVkX1+bmR1bQuzfosmNCZyyMPhpzkWKu9jHx28="
}, {
    "num_cand": "U2FsdGVkX1+Mw1B/jSwE4xOuD4H68d5fLcdQxZ3qASo=",
    "cpf": "U2FsdGVkX1+3fHKD06DVnuu+KJa1XpCmGebbzhuMZ1k="
}, {
    "num_cand": "U2FsdGVkX19J7nOnAYDoIA1wsh3+FlLoAFg80UBjpEI=",
    "cpf": "U2FsdGVkX19h/4VJ/RTIPEsxWmvCR+A9SrSVAOiChXs="
}, {
    "num_cand": "U2FsdGVkX1+WovxSVD5vAs/nAhBEVRPkWyjw/a3eTP0=",
    "cpf": "U2FsdGVkX18gNa2gDdkOpMGyNqJaCzeENzwK7YHpvfQ="
}, {
    "num_cand": "U2FsdGVkX1+3tN6FeLbp2ze6Bxqk4mraQo9xFayw16I=",
    "cpf": "U2FsdGVkX1/W5HITJiUAEDC0BuZWwK0OfNurCIJO1l0="
}, {
    "num_cand": "U2FsdGVkX19AGDFzwLy5Oq4Jq9OwN1jsufzn5Tprjko=",
    "cpf": "U2FsdGVkX1/dIpbo++kdjBDyPbkHL6yJYWNE0M0jk+8="
}, {
    "num_cand": "U2FsdGVkX1+43gsMWLBD0P1pm8lih1Zhs/mYNQeH3XA=",
    "cpf": "U2FsdGVkX18tTGRGNB+BzIU289dVORk9zUWUrWSXtEs="
}, {
    "num_cand": "U2FsdGVkX1+5qRPfM1mOHx1O3xBzw9NSHAIa/wM37x8=",
    "cpf": "U2FsdGVkX1/sbArpTvyANp4bepCs/mODLyypeQ5uhX4="
}, {
    "num_cand": "U2FsdGVkX18Ti3p3xZKEs4rmitKg9YA0ZvyZrmW29EU=",
    "cpf": "U2FsdGVkX19KpAaCmQ5U+iwyEi7ybfFevNIc7SXEYaI="
}, {
    "num_cand": "U2FsdGVkX1/B7U51YR4O6M2xonByY6EhY1Lfu8KHaRQ=",
    "cpf": "U2FsdGVkX1/fuCrBKxaBMXKFwbiG9G3wDblzhT6+4Ug="
}, {
    "num_cand": "U2FsdGVkX18FbRbmmSrgDTBp1qGpLo2Xwa6ebR0lEiA=",
    "cpf": "U2FsdGVkX1/1+zmm7in0Wx7tQArvJNKjLknkKAboOw0="
}, {
    "num_cand": "U2FsdGVkX18EjiJRi+wkqx+e7ewtUwS5caH3U9dRM0s=",
    "cpf": "U2FsdGVkX18jTYBQhKzLUS1cz5ICKCzer7e5rtrleRI="
}, {
    "num_cand": "U2FsdGVkX1+K9vAhy+Y9D2xlHE6ZY2M1eYqj6lxCKpY=",
    "cpf": "U2FsdGVkX18Uj6Jf/7QHKLYhoMVV4pJWB5HIHsLBgZQ="
}, {
    "num_cand": "U2FsdGVkX1/YZPVCLXVu3SIyGbmxQXEpEkVR9jsEtJo=",
    "cpf": "U2FsdGVkX1/th2rpUBT3JlSriFCzYYEdjUdudQJFSlA="
}, {
    "num_cand": "U2FsdGVkX199lNN5DmYikrz0qNYCqmkx+yF+BRViq6g=",
    "cpf": "U2FsdGVkX19B4biQlcuZ50ZoXw6DsvtXPjYo1KfducU="
}, {
    "num_cand": "U2FsdGVkX1/bNfkBmQ8MQeekhmQbKbIno67Zbhd0vgo=",
    "cpf": "U2FsdGVkX1+Pn1/rrlcULCyxs9hQoASw7xV4edhNko8="
}, {
    "num_cand": "U2FsdGVkX196ZJv0/n2xiWTg8w90TmtqAtM3m3SydeU=",
    "cpf": "U2FsdGVkX1/YN1iWqwEHQl7YTuTroG9LtjCbh6pnItE="
}, {
    "num_cand": "U2FsdGVkX19i2PWXdAKTvl5wEZcMd+2cP8OVbAj24oU=",
    "cpf": "U2FsdGVkX1/cFfq8/KaPdpupO94nm0fOFbyxZPspFLE="
}, {
    "num_cand": "U2FsdGVkX19TcUw0mhc66rOq3cWdLt3RbjU4qIoCY6E=",
    "cpf": "U2FsdGVkX1/FFFqs6qbig1gi8MZxnVrG1VK0z49tEp4="
}, {
    "num_cand": "U2FsdGVkX18vf4U+tzeLOwW+SRYU5XPUoKN2KJ0xG+A=",
    "cpf": "U2FsdGVkX19E6g+5AKMpzhYj4P+yKMz4Ucs7cBhHypE="
}, {
    "num_cand": "U2FsdGVkX1+SsNx4YfWMg6GOLjGxZKH+uFp3RoUMGKc=",
    "cpf": "U2FsdGVkX1/kaoKUA4QBFd/HBc3DiZSZlnkuZdq6AW4="
}, {
    "num_cand": "U2FsdGVkX1816gLkNcNqfqOJJMUjViJN8Yj+ZlM8s0U=",
    "cpf": "U2FsdGVkX1+OOd7Uhta9rUM7E5LhhaaCSWHJ7mhSVSo="
}, {
    "num_cand": "U2FsdGVkX1/ocua4aa8IdIWUZ+qLHTKgAwNg5+Nuq/4=",
    "cpf": "U2FsdGVkX18t0HifHIyybX+teeeT9ii6XAg7WbyBJeQ="
}, {
    "num_cand": "U2FsdGVkX19sy260gajlJ8LULzMIpwiHOKM3uplcPV8=",
    "cpf": "U2FsdGVkX1+FKx1G4PCB0K87RdU/xelVQshQmigLLuQ="
}, {
    "num_cand": "U2FsdGVkX19CuwRAhPzum6itCkHvoW8y4HTRJjL6yEw=",
    "cpf": "U2FsdGVkX19gdNZA2cTTfi1jHowfbP7bEYWwDXxHbHg="
}, {
    "num_cand": "U2FsdGVkX19Ol4b5fCdD3RmTaNe6g5DnhQxG62ebH1M=",
    "cpf": "U2FsdGVkX1/7ncrA2CnDSQOsjhr5UoocYHFfdpK5Yhk="
}, {
    "num_cand": "U2FsdGVkX1/J3YBsBQe/Xf+THNEwByZMSyvrAtgC4Fg=",
    "cpf": "U2FsdGVkX19pQVxBvsVw/z9tiwMMimIEQswB11BNQAQ="
}, {
    "num_cand": "U2FsdGVkX19PAniahlpZFzp6M609xwn79v6ikuSaWhs=",
    "cpf": "U2FsdGVkX18yKUKJjROlQ4T63/rGo+qNq/UaupVEDOI="
}, {
    "num_cand": "U2FsdGVkX19PzgtWPKtqmXk3FBr4KS6lLkxa7kIhFYs=",
    "cpf": "U2FsdGVkX18NR5YBAtnaTtBauNZhv5KA+resE50/0JI="
}, {
    "num_cand": "U2FsdGVkX182BEnpudcnfYFFPdfBflbpprDSpIW7vpk=",
    "cpf": "U2FsdGVkX1/GAhm7c8e4Xj5P+rmiqLRT3YqPGRQKmVY="
}, {
    "num_cand": "U2FsdGVkX18etZnjrNEtCjd1MbWYiVKST5IQpW//eik=",
    "cpf": "U2FsdGVkX18pXGxI7l5NdqaHccWgaJQfhsGMjDald4g="
}, {
    "num_cand": "U2FsdGVkX18d8tOb6mW5lov70XhaG+opfHrFtlUqoZM=",
    "cpf": "U2FsdGVkX1/6habC6xWeXO+XxyxFUTTWq819a5qATHY="
}, {
    "num_cand": "U2FsdGVkX1+gsK29eXl2fDbg4YG80j6jY+Gv7j1L97Y=",
    "cpf": "U2FsdGVkX19cH4QphsNl+YwLR5tHlx2Aao6LuTPT5WA="
}, {
    "num_cand": "U2FsdGVkX18+7D0ZWp411nPRx4NC6mfpoVXLbmcDlKE=",
    "cpf": "U2FsdGVkX1/yrG7MdDN9Dq/uWUAVmr+dafZ9lE3BS1E="
}, {
    "num_cand": "U2FsdGVkX18FbfT9VSTOxWOPECN2cw2Zg5lwyiBPryU=",
    "cpf": "U2FsdGVkX1+/ev8KXNjkr6ZpTZteJlYSvGRb59IUgJ4="
}, {
    "num_cand": "U2FsdGVkX1+P9BkY3HT2DhUSrs6CqmRIetB889oILqA=",
    "cpf": "U2FsdGVkX19ksZF0JYG55Dx8ALKB6sJNsD63jlDOR8k="
}, {
    "num_cand": "U2FsdGVkX1/EyBuQQlDR6cIEWUn16w5bKLBG+cmoVDk=",
    "cpf": "U2FsdGVkX19iHHD+etNxu1k5+Uv43GbJ/MDqTCajS28="
}, {
    "num_cand": "U2FsdGVkX19Kdi7Yp6Admn7yi9Kz5JKEpM1slvBiIxo=",
    "cpf": "U2FsdGVkX19pp+B5K+mQGZVapOEYy54ap826zWZuO4g="
}, {
    "num_cand": "U2FsdGVkX185HraB82coOb1YaHsZu68LIVT7sGudVdI=",
    "cpf": "U2FsdGVkX1/6t3OIua3i3WseJvbm8GYq2N1WIT7p/H0="
}, {
    "num_cand": "U2FsdGVkX19pXpMcpkMvAM0I7ZwHzWUBR1p8cPJqJIE=",
    "cpf": "U2FsdGVkX18mor0YWNbdV8w6r7PgTsZDDxaFyNNpWaE="
}, {
    "num_cand": "U2FsdGVkX184+2mlGfAINLyGYSTjUWjGRbSTB2mis98=",
    "cpf": "U2FsdGVkX19ak8TYWubhaeKOqHpd4rWhiqTOIFeqnuU="
}, {
    "num_cand": "U2FsdGVkX1/2HUoLzwWqJZjpDnnB5nXlLTaO0rM0hTk=",
    "cpf": "U2FsdGVkX1/YopUUfSacfquQT3qwl+YQA3ro2UxHx20="
}, {
    "num_cand": "U2FsdGVkX1/GMLKlMShKKGhMFn9siJAktUUn3iE3DEw=",
    "cpf": "U2FsdGVkX1/C1pWh9GlAKHb1o64Zed9cPZoMx9iMYtg="
}, {
    "num_cand": "U2FsdGVkX19f7IQXT3m1+jiHKP/2pncUQODwfeB3YrQ=",
    "cpf": "U2FsdGVkX19QXZMU2YFBt46KaeMRqB/VJ2pCO9du4n0="
}, {
    "num_cand": "U2FsdGVkX1+AZyaURCUAgwXtpI2GE8wHZ2SF27aWD1k=",
    "cpf": "U2FsdGVkX18TDzAgqBzsln3uF431i5h4Hus1fdrFcC4="
}, {
    "num_cand": "U2FsdGVkX18ivA9dRTzVfRAp/bzrWZHcG+S9d8b10BU=",
    "cpf": "U2FsdGVkX1901QEGYjL69MQHSGhookx5eeeaPlP+G4Q="
}, {
    "num_cand": "U2FsdGVkX1/02b18QKsaJEVnDKVawHMdGnKIt29llGE=",
    "cpf": "U2FsdGVkX1/VTVgbMwLZLmpIKyk2CWhzuP9D7f9hW+s="
}, {
    "num_cand": "U2FsdGVkX1+tMQ/vUjtuJeH8AD/+dNL7fyWWIY3PvQQ=",
    "cpf": "U2FsdGVkX1/zpVZJusaOZh+rK3nMF6xCxeFHiTN8hHI="
}, {
    "num_cand": "U2FsdGVkX19r0mkS+OjNQrlWLVNp/IF0tkIWJA85Deo=",
    "cpf": "U2FsdGVkX18u4kK+47fCbkGlzp4IvPstNH8NG/noY4Y="
}, {
    "num_cand": "U2FsdGVkX1/CuL+o6EaTkfc9xqYO+LK8e/14/izuoeY=",
    "cpf": "U2FsdGVkX1+CYGvlbW/wS0WaLEHIj0vC9864cTECTxk="
}, {
    "num_cand": "U2FsdGVkX18jeKdYqaGPNhrI4EydVzDOYMc/5JmkdIk=",
    "cpf": "U2FsdGVkX19Cisw9gsFgefpmUW4nuYEODBD5xkkKQ9I="
}, {
    "num_cand": "U2FsdGVkX18qCcz7NFqNEe0ZjwljyZe63pth97vn3BA=",
    "cpf": "U2FsdGVkX1+m9NvTRaEcQmPTFNLZSk6P5SvbdvMWK18="
}, {
    "num_cand": "U2FsdGVkX18sWhw+QY5uC6MFl8ROtJOisd1q3Q2IxcA=",
    "cpf": "U2FsdGVkX1/HiBZVt3ijYT5dXHFXDrrkSTalvwSAshw="
}, {
    "num_cand": "U2FsdGVkX18ySR3o0/iwsnT7pSs8zDOM+sfznQWn6Aw=",
    "cpf": "U2FsdGVkX1/0m2PaM4y4S9GBzeCvCM82i77trem3E0c="
}, {
    "num_cand": "U2FsdGVkX1+tYzgzDRxQLHG2zXqxNlgW3FWtUUfqu6U=",
    "cpf": "U2FsdGVkX1+ZWXEBxqgu92D9LlGx0I//o62iOtZ0ItM="
}, {
    "num_cand": "U2FsdGVkX1+6kqRzjExDg6Bw8z54I/i+WntcZkb8wBY=",
    "cpf": "U2FsdGVkX1++EzmJmjyr1UY62Twf2ZTBHkTRswiCWzc="
}, {
    "num_cand": "U2FsdGVkX19ARBei7QyHTfZE2GhlkD8KaoOChuGn6E0=",
    "cpf": "U2FsdGVkX18230kzRHbqGFAs5zC6Zq2krv+hfb8nnms="
}, {
    "num_cand": "U2FsdGVkX18k+D1D44J9lc46bNF/gHvdSve/wP1eXO8=",
    "cpf": "U2FsdGVkX1+ff8eWba0YgvYnEjXARUy3p8xY4+jUFyA="
}, {
    "num_cand": "U2FsdGVkX1/v+w37dFnT50RgReOQft96wdBPg3dOtKE=",
    "cpf": "U2FsdGVkX1/LN4t0vyQKjjGV2PI85NK0fY8ooW7K+UQ="
}, {
    "num_cand": "U2FsdGVkX1+2UL8+4h3raR76ZwfsFmcK2KYCWzLWvtY=",
    "cpf": "U2FsdGVkX181Z/c78UvY1N1YIJg+g6ZDVdu+U6K2cds="
}, {
    "num_cand": "U2FsdGVkX1/bicrXrYHZ6LCbnEKk3s7wwZuwPrsLqIY=",
    "cpf": "U2FsdGVkX1+gn1x17+lVOL4FIFgb2EA+WAYm0kgD8I4="
}, {
    "num_cand": "U2FsdGVkX1/6gr72c8edI/XjWmvFGqAqApVFRLKL86U=",
    "cpf": "U2FsdGVkX18Zaqpf97Bg8rp8Suvz2jp5C+GVa6/rLKc="
}, {
    "num_cand": "U2FsdGVkX19kS+u+61OquRi1Gr1WwgPqlQbjoAqKKms=",
    "cpf": "U2FsdGVkX1+7IiiZ9PZtVgBbZIbrk3sUZwqHnL0+wf4="
}, {
    "num_cand": "U2FsdGVkX19kl1P4yyUuAk1LEmTmP0yTXrm4VVz9xXw=",
    "cpf": "U2FsdGVkX1/iJO8E3trHXTDJMBzUhoFmjm7raFG+4hE="
}, {
    "num_cand": "U2FsdGVkX19PQkW5Us6zKIJGa8AXF+riTqEguRqSVHA=",
    "cpf": "U2FsdGVkX1/3HlZ1eAX9thAmHX5zLg2hEG7vq6FUgDo="
}, {
    "num_cand": "U2FsdGVkX19ykNMHjkwVYN/NqeoB1d04GFOGFmGu/ws=",
    "cpf": "U2FsdGVkX1/+lb8xoZfNXAUgJdd1SkbAo8d1b3IUSLI="
}, {
    "num_cand": "U2FsdGVkX1+WhRhnE1f/v40KFayNnteAHcTlSQkbvEg=",
    "cpf": "U2FsdGVkX198vCEQ5+lDC2qrF/9+dvDKIj1u9xvgjyI="
}, {
    "num_cand": "U2FsdGVkX1+F26NFPWEn2j5+iyi84EdMsTMzZts/Un4=",
    "cpf": "U2FsdGVkX1/pyVf7YqutRMvc6aR79L5UBVqI/uGj/gE="
}, {
    "num_cand": "U2FsdGVkX18pV2lAIrutQNQmanPqOahQ1j4ZMBX29ZI=",
    "cpf": "U2FsdGVkX1/LLPWURYBvQ37BhCS2UDDxUwAHUDs2glU="
}, {
    "num_cand": "U2FsdGVkX1/yxo3mkh9FsAhKHa73LvTKzC1obae9Rgo=",
    "cpf": "U2FsdGVkX1/UWdhr3/griPOf+beVLzeY/xtF9RP2eo8="
}, {
    "num_cand": "U2FsdGVkX198dToXdSqJM8eTnAF4S3MhEVqK2wS6CH4=",
    "cpf": "U2FsdGVkX1/A+LctLRpljWgpcRf/vkpDVdSuC8mwX98="
}, {
    "num_cand": "U2FsdGVkX19f4YdTifG8gOEvUAFTOkSD4mmq/7MV6xY=",
    "cpf": "U2FsdGVkX18wnEExYfGNZUP0ZhGNs3ffPvLu9+Wa8KA="
}, {
    "num_cand": "U2FsdGVkX1/fSxX8f2GsM1Ur039X5lY72DQyHhNdYlo=",
    "cpf": "U2FsdGVkX19fy9q/XyF5Alil2dGixkek4WTiQW6m7ug="
}, {
    "num_cand": "U2FsdGVkX195mA8/lg0xZ+FJS+2RWX8FFPfFIrnmOQY=",
    "cpf": "U2FsdGVkX1/2qmiZpyZ73bSkv89RejJ51ZuZxgfKRCU="
}, {
    "num_cand": "U2FsdGVkX18X1DcgoTj4xHCnorLhMowIvBgH1V/fJeE=",
    "cpf": "U2FsdGVkX19HtXWkAkyMzTgORgIXcBSvy65XwnmODLY="
}, {
    "num_cand": "U2FsdGVkX18Io6ZmcGaL0rsmXYcNSyn0jjeL79fCJZY=",
    "cpf": "U2FsdGVkX1/qpL4nz2DuwxvILgQYApUtUfyOn/bfTWw="
}, {
    "num_cand": "U2FsdGVkX18ifOBIXg2RkpA1d2UyvFMHeSqnNtqriPE=",
    "cpf": "U2FsdGVkX1+UY3S++b8AkN8akYnhIg87CEtHqbKiILs="
}, {
    "num_cand": "U2FsdGVkX18Gyv7SmkSwSp4gZ2rcyBsjkAM7tswK6Xg=",
    "cpf": "U2FsdGVkX1/1d8u+TEthSFqVAyYJTmVVAZ8widgJXLw="
}, {
    "num_cand": "U2FsdGVkX19d0psVUg2Hivmil9DPvYooYw3vdPT0ePk=",
    "cpf": "U2FsdGVkX18VVJWJKqIYxYP54sCrYSq4OxntjcgTB8s="
}, {
    "num_cand": "U2FsdGVkX18k4rsKpww7djG1aLcFjT+iu40lCXjoxMo=",
    "cpf": "U2FsdGVkX1+f1MIYrFIlt2wBWTgTWKp6MLOBLBIE0Cc="
}, {
    "num_cand": "U2FsdGVkX1/G4UysNQGjLgo2D5AEFucumVgNKbADeAg=",
    "cpf": "U2FsdGVkX1/QYCEQ7ZWj1he8tWs9hA3vhYL8M7tSUlQ="
}, {
    "num_cand": "U2FsdGVkX18cIwp/Il37TqV9sprMNDZUFkvZ0tWHsSw=",
    "cpf": "U2FsdGVkX19vdfdIwNFSrtdcEvZ5vhDLKd2kHHaGkzw="
}, {
    "num_cand": "U2FsdGVkX18UtVrJpt/cwNkT7tkPmN1f0OUbWuybo88=",
    "cpf": "U2FsdGVkX19G4JWTLLnIyiI4UDijymJfcRTmXY9T0Zs="
}, {
    "num_cand": "U2FsdGVkX18u6CNqmjQCa40egZlXBaCoR1dc/nseniw=",
    "cpf": "U2FsdGVkX1/Uxs+AZ4ebhPQAenDqlZHrgiiprlHS2S8="
}, {
    "num_cand": "U2FsdGVkX18TGmyyWZUJEcvlJmB+3oxGfTGjibV2+uk=",
    "cpf": "U2FsdGVkX18xqk9WAYPjMNVp0Js1ZFGDIvk/+7mWTsQ="
}, {
    "num_cand": "U2FsdGVkX18IDxgvdlR2Z5u1Jd1FhDGrV9I0Ibxlu2U=",
    "cpf": "U2FsdGVkX1/y+CpJcQtnLInSZreZm0uylIKgs4nh1bU="
}, {
    "num_cand": "U2FsdGVkX19d9LmjWAOs7rcdNcluJIP77Q6Mm9XNUYk=",
    "cpf": "U2FsdGVkX1+WIOMtRWE5n201pZ/gn97DYDbG34cUwqg="
}, {
    "num_cand": "U2FsdGVkX18vgsnUL/Lgwj7y3qtRnhX43haEukYR2Ok=",
    "cpf": "U2FsdGVkX1+rtRUdDAUWjj3IW2inqRnfS/s86/CCW4A="
}, {
    "num_cand": "U2FsdGVkX1/BpKw9R8rAUVM1/0G/NHWj56u0PNSqW1M=",
    "cpf": "U2FsdGVkX19OkxFaPedzSlf9rzS4IvYgGO/saDWD8FI="
}, {
    "num_cand": "U2FsdGVkX1/NTvZZ1tc71BLO047qYjnrAMFXgVUsQMI=",
    "cpf": "U2FsdGVkX18SbM4yL3h7X+JqUN5mTaRscep47BliIas="
}, {
    "num_cand": "U2FsdGVkX19LEMt67r8iAvJKXbT4WDpqICXiygO/FU4=",
    "cpf": "U2FsdGVkX19yaGIRoXE2VmCA/zc2MZacVsYHD5abmEs="
}, {
    "num_cand": "U2FsdGVkX19zVD7AlzvR6Lv1vJbrCqcS/Cd7y1tY0T4=",
    "cpf": "U2FsdGVkX1/2dLuzqVPdvQJrQ3BHZgb1roOXc7lnB5Q="
}, {
    "num_cand": "U2FsdGVkX18V5+BbzskIQbh0SM/vZZ3K106mlfs8vB4=",
    "cpf": "U2FsdGVkX1/5mZ/ai2X3jQXn/jhGEO+XUItfMlsQ7rc="
}, {
    "num_cand": "U2FsdGVkX1/wsqH1ikjUZ7FBerpjzfNgRmRO+jyUk1U=",
    "cpf": "U2FsdGVkX18vxVTUHV+ebPXFNQJdhpM5vLPrgMNN1qM="
}, {
    "num_cand": "U2FsdGVkX1/k5kR9nwnrJNUjVUTjQ/rqQ1B/A5ZNwrQ=",
    "cpf": "U2FsdGVkX1973Ym/JEq+MwkZrqj/Als33FqE5YF1bos="
}, {
    "num_cand": "U2FsdGVkX1/h8tWjUf0dOWFhC6IfenQKk9PIAJk9I8E=",
    "cpf": "U2FsdGVkX18OBYb67yvcRryljbbQ0o6kJ5mqQRETzsE="
}, {
    "num_cand": "U2FsdGVkX189Kh05z5VWwLgVNBhqpkjE8VrtzYTZLbM=",
    "cpf": "U2FsdGVkX19CA+6qZXNLMYR45gjNTH08Moh42GxmSmk="
}, {
    "num_cand": "U2FsdGVkX19aAQs4HEZp9nsuNKbJK315vyirhckYqX0=",
    "cpf": "U2FsdGVkX1/9PXmA9PEIQ+s+OuhzsGwo392Nczgx5ZI="
}, {
    "num_cand": "U2FsdGVkX1+fAycmUwymDt5a8KUSGTaikLiffO15Dvw=",
    "cpf": "U2FsdGVkX1/y8tglwJRgK1jR+0nq77tU/q7mzQKkh+s="
}, {
    "num_cand": "U2FsdGVkX19yygu7p3LjMAzoWB/1JXos/0lCo/X5m04=",
    "cpf": "U2FsdGVkX18IVZ4cxb0qUNZIl3J1qmRm75mz6ADOviM="
}, {
    "num_cand": "U2FsdGVkX1+jXqbtjhMDjmmJn/+S2X2Xow3BSierBMs=",
    "cpf": "U2FsdGVkX19DZlFuZForm2oyep72Q1GU241+5J0B/pw="
}, {
    "num_cand": "U2FsdGVkX1++L4+Uf4XbtAlKHB13xuDxZQ1XcMgvbik=",
    "cpf": "U2FsdGVkX1/4ioXCUiT4EkRKCHZi8RhLKLbSrrDZi0c="
}, {
    "num_cand": "U2FsdGVkX19OKSHo1mbr48Yf2Y3xES0awJ7TPnTQBnQ=",
    "cpf": "U2FsdGVkX18CoPXrZ42EI0tB7XGl/+DI7WnqttctsQo="
}, {
    "num_cand": "U2FsdGVkX18Vq29JiEtoIaDSg1L3VOoLp0AxjeG5Hsk=",
    "cpf": "U2FsdGVkX19RNZFf9aelYgyhcDLNhyPEFB+BaAAu+ps="
}, {
    "num_cand": "U2FsdGVkX18oYsi+21TYsjyvzUxt0h5nYqls/3IhYpE=",
    "cpf": "U2FsdGVkX1/00Hb+7N7WWGpEKV061reOcjmtNlzWOgo="
}, {
    "num_cand": "U2FsdGVkX1+AfWN3/W5zrBdB0mnMdnG4nibucwz0Sa8=",
    "cpf": "U2FsdGVkX1/H/dYuBTSCuMaIrf0K4t0Ic0cdPmCmL8Q="
}, {
    "num_cand": "U2FsdGVkX1/7qB0oUh1FKo+3O6JC3CgQJZCMUK4xDP0=",
    "cpf": "U2FsdGVkX19kW/OMSOSYhJVQBnHCDIPSi5FaQwPSuQw="
}, {
    "num_cand": "U2FsdGVkX19IZji9cXYEC9pcDirSkhUh8Sr/yLrxbcU=",
    "cpf": "U2FsdGVkX1+XOs9euHxlh5In36W5IDX89+Q5Sd9EvBo="
}, {
    "num_cand": "U2FsdGVkX19UUEyBO3ID3Ee38I5PHNgTt1vcvCnUzeY=",
    "cpf": "U2FsdGVkX18ayyBoan2xPobT/97ft+qKMrq6QWKXJR4="
}, {
    "num_cand": "U2FsdGVkX1/JuR8Z+yihlfnR5EYx2pdBjCjv1byJXxM=",
    "cpf": "U2FsdGVkX1+GCdlC3yAXucbLm9rN2zUrUz//S10IKm4="
}, {
    "num_cand": "U2FsdGVkX1/61qV72jSbFG9oSzkeQZFNsa6QGvPHXM0=",
    "cpf": "U2FsdGVkX1+PUSR5PN/1CeWkESFLNSaRC0SySEfkht4="
}, {
    "num_cand": "U2FsdGVkX1+qEBJc3C45x6W5qRoZgXwFQVzhY/KfvZE=",
    "cpf": "U2FsdGVkX18ScqRgQ0HJ6KMdR7cO8uIkSO0vTChxSTA="
}, {
    "num_cand": "U2FsdGVkX1+AdkVYtoUc5o1lVL1C0kvvosrvMVvZp/k=",
    "cpf": "U2FsdGVkX18SRuadbpCkAc2xKjJ3j8IDUsUHxnUc4Z8="
}, {
    "num_cand": "U2FsdGVkX18+OhbDsqxYG9BM5HCm5JxbsK4KVRfzQTI=",
    "cpf": "U2FsdGVkX18swc5sRtzLt5YH9Fwkjsy2Y6c5P2wP+Rw="
}, {
    "num_cand": "U2FsdGVkX1/HEMHmbC/0yGsXuIeATL7GQAohMqDZ2to=",
    "cpf": "U2FsdGVkX1/+lfAa3zwMUwPADqNlbWyGjD0Sl5yhW6A="
}, {
    "num_cand": "U2FsdGVkX1/EnKY5XTEguDY2wl5hC96AXk3Ort001Mo=",
    "cpf": "U2FsdGVkX1/0XKEL8opTokjipHRLiU1qZdQYK9fmNjk="
}, {
    "num_cand": "U2FsdGVkX18hIwt7PP+mHOPhIPkVcpZiMdFKZ1eNNCI=",
    "cpf": "U2FsdGVkX18f8xIRrzrRQUorslGmZ4lftGq07wzoSN4="
}, {
    "num_cand": "U2FsdGVkX1/8Z2aBtvy5UtHYLXl/cJ5ImZGf3MTtBJI=",
    "cpf": "U2FsdGVkX18OPrrZAr0U745ULWTY0eLABY4jONF18MY="
}, {
    "num_cand": "U2FsdGVkX1+9XM7v1n0XXDpSzlkLMwJXeb5QOG3FTPs=",
    "cpf": "U2FsdGVkX1/I0Qg2O26p2uA6ak76xhScH8GjpXVB0XU="
}, {
    "num_cand": "U2FsdGVkX1+zKYxBN9NkI/501tjJRFueHFfIQg23RX8=",
    "cpf": "U2FsdGVkX194GaNNo5NX+N5XlOrjwlHK4dE8cqpetxw="
}, {
    "num_cand": "U2FsdGVkX1+p/ER0+B9ccwM/h2IxtNCwQzqNElISrG0=",
    "cpf": "U2FsdGVkX1/+a+dqiogluB7b4RYDbAi6E8V0J9OhfYw="
}, {
    "num_cand": "U2FsdGVkX1/+07aqe7RNr/cNPWifRuZZPHr02a1lZsI=",
    "cpf": "U2FsdGVkX18/jZbJ3xMpm9Zs/wjZHWIzkGC/0CzJuRE="
}, {
    "num_cand": "U2FsdGVkX1+NUJPB+SvmK8mwZdLLiLNeC5u1yCWSnvE=",
    "cpf": "U2FsdGVkX194bqPIWyBBIenwOIVjV37+mzOW6NJ89TA="
}, {
    "num_cand": "U2FsdGVkX1/2VjkLuizsKPlXNC/FI4iATUROj3Y2NWE=",
    "cpf": "U2FsdGVkX1/w5ILB6kRJAStTz+MxP0iBsXKVtheoiYA="
}, {
    "num_cand": "U2FsdGVkX1+RJ6bZB7h+LUTbI3pHcg7bFpA+W7fPnsQ=",
    "cpf": "U2FsdGVkX18WOSg+AzaB96tOBtaVPyN0NevZv4d6GHA="
}, {
    "num_cand": "U2FsdGVkX18iW+GaTknfcr1xucMa5EjZO2/fJpJ1pQc=",
    "cpf": "U2FsdGVkX18eKAmPilqLuL/oseiblRb7Ph3C38gO/Xw="
}, {
    "num_cand": "U2FsdGVkX1/oqvBlbYIufIFyzbtnacXcJuPiCrtUYQA=",
    "cpf": "U2FsdGVkX1/UhhEj40gJ33W7Bg+HdzjRzhmpdM+C04c="
}, {
    "num_cand": "U2FsdGVkX18MTinl3Mi3S7slx5SvIWaYDefwZ4524O0=",
    "cpf": "U2FsdGVkX18lIkG9vfDdEo8yqGAMLbOMbuzW9M2a6os="
}, {
    "num_cand": "U2FsdGVkX18KhCah0fTVEbsbJ4I56TKmGAanTz5zXB8=",
    "cpf": "U2FsdGVkX1+gBVDaLzqKtSQrHHm0b2Zw5+Qr9sIgwZA="
}, {
    "num_cand": "U2FsdGVkX1+9jpgHhNjuoGLrH7zVk5u7Nc2xNBmxCy8=",
    "cpf": "U2FsdGVkX1+bXCWbf49q63FNMJ+s/OCbmtEBlTZnZ+E="
}, {
    "num_cand": "U2FsdGVkX1/M9kSDVNF8TUwnaUVPXX6JwIP1wejtri8=",
    "cpf": "U2FsdGVkX18Oy6mcx+dxexl/5r3NWpHDw8UEYp29+CQ="
}, {
    "num_cand": "U2FsdGVkX1+iv+l/d08raw3c4ecBzGzJyHWYbaSxWeo=",
    "cpf": "U2FsdGVkX1/mZ4FKHV/E0aSESCYeFSVB00B1mNYakgs="
}, {
    "num_cand": "U2FsdGVkX18EoLQCdsExw1RiJ4KvB6OaXDkYd9uIXaI=",
    "cpf": "U2FsdGVkX19ppeHb9gXV5hk/vxb1mYzC7q2HJ84pmRM="
}, {
    "num_cand": "U2FsdGVkX1/ktN3H/OwHG3N76pt1dAgAxr2qOVc/YCc=",
    "cpf": "U2FsdGVkX19ulHDAMM+80RieTlLEYVGm7O9lJXo+Sbk="
}, {
    "num_cand": "U2FsdGVkX18ZlkmI6vPJnvxylT0EMrihxT3M69AJZnc=",
    "cpf": "U2FsdGVkX18p7+tK6H+TuVyTsgHVrN0jEV1ODqT3MXg="
}, {
    "num_cand": "U2FsdGVkX1/i/fm5xs2oGEpMYmOE9dUOO9otoJcvD0o=",
    "cpf": "U2FsdGVkX1+HorLNea/ksgyDAZvaSQKY8ulk5fzUons="
}, {
    "num_cand": "U2FsdGVkX18xuKxUEUOWz5rIVoqxIvjrtpB3BOTgIC0=",
    "cpf": "U2FsdGVkX18L74HGDbAJSuxaTp+/tYM6By4H5WZE2M8="
}, {
    "num_cand": "U2FsdGVkX19O0IP1gJqK+tcIB77crQ/wBoxgisOYhPE=",
    "cpf": "U2FsdGVkX18n1Yw5ZEo4hoGmtxhQtBHO9lkHk7RWNSU="
}, {
    "num_cand": "U2FsdGVkX1+5voKkFPkB0D5eR/up5nBjh48My8Pv9k0=",
    "cpf": "U2FsdGVkX1/zreYFJGwNEoXX65Gwjjg6lBHNCdVZeBw="
}, {
    "num_cand": "U2FsdGVkX1/IU3fKhVcC+VPFQMkegw/pmFilW/sgyX4=",
    "cpf": "U2FsdGVkX18/OPyyy7DhSaU18IhJcu+JfhqXOO+bOjA="
}, {
    "num_cand": "U2FsdGVkX1+Jz6kGqfg88bE1d4SMFBVrJgd4NS+a+kU=",
    "cpf": "U2FsdGVkX1+5FLdTlXqd4ZRV9A8wKrz1/fsBqlMYAmU="
}, {
    "num_cand": "U2FsdGVkX1+7n0jtEctQMqBdcnAsxqbM954z9IYSskI=",
    "cpf": "U2FsdGVkX190vdY5l9TIhYsJSBYQfw9gBfn/A2l0tRg="
}, {
    "num_cand": "U2FsdGVkX1/KzQoSw+m/dGDDP55GoTeNX1S5TPw87CI=",
    "cpf": "U2FsdGVkX1/401RfdK1s0d+xGVMRgCGE9ZWj/Tm/WLs="
}, {
    "num_cand": "U2FsdGVkX1/7zHTlWOgfKS6DWzX3zPnPuP0ukDE3naA=",
    "cpf": "U2FsdGVkX19B0s7eD49oyrDRqynfs9sV1P5asCpsQaQ="
}, {
    "num_cand": "U2FsdGVkX18ApmnJeCwSYy+83Smx3iRld4fQ4xMZUKU=",
    "cpf": "U2FsdGVkX1+K7gvXn4kRz6mFkIc21HO7cIVE4Nz/5+4="
}, {
    "num_cand": "U2FsdGVkX18A3IjSmrn2bPWJ9Ku3WwA+uVvjWM1lrvk=",
    "cpf": "U2FsdGVkX1+l+Bp677zjKiUsgRQh5/vE3zQyL82L5Vo="
}, {
    "num_cand": "U2FsdGVkX19d3JO/wfwibWHqbll6mf5kEvJuz7yXFuk=",
    "cpf": "U2FsdGVkX1+ndRKGlJcvwPsV34oEK1+T4l1MPuw+k+s="
}, {
    "num_cand": "U2FsdGVkX18bIK5LOw4xQfXTbeOeADd4F1kg+sTflSk=",
    "cpf": "U2FsdGVkX1980KyU+aZl66fPEkjvv3AUaN8GGGYK9d0="
}, {
    "num_cand": "U2FsdGVkX18+nuPZUOe7B1HA/kZ9bKbhyFDSZSw6k98=",
    "cpf": "U2FsdGVkX18y4bCff2g0ryO/eBeUFgsw28y23VafyNg="
}, {
    "num_cand": "U2FsdGVkX18Hdz7UPgtRpTJMsLt8m89ihySJ8pwbTQk=",
    "cpf": "U2FsdGVkX1+NTqZFJbvExYvebKsqJJxEdGFFr/ngPKY="
}, {
    "num_cand": "U2FsdGVkX19ElXQyLl0luClcuxSYCZQyO8KDIh53TUQ=",
    "cpf": "U2FsdGVkX1+/nqhZXDSDb21iD2R+Dmlto7xmb6P6nfs="
}, {
    "num_cand": "U2FsdGVkX1/olU7QrIrWlw+GhcCbxJwBrEpuRBqxVg4=",
    "cpf": "U2FsdGVkX1/swQwktkWRhuuhFDyVuMkIwGIofzyfY04="
}, {
    "num_cand": "U2FsdGVkX18/KHMvfSkYhlKLLTbsWqYy+MfcGpwyx/g=",
    "cpf": "U2FsdGVkX19Wt7r3uVOkdETyMufN6FSCoC/yuE3DLpI="
}, {
    "num_cand": "U2FsdGVkX1/bsh2v6w5j6iowNJWozXRuXEbCYdZiaWo=",
    "cpf": "U2FsdGVkX18DcWtHHnyJCvQkaVMR9vC+D+jxo5KEDfM="
}, {
    "num_cand": "U2FsdGVkX19oGjpvVIIYqCY/2D8jrM/YgLSvOWJfv+8=",
    "cpf": "U2FsdGVkX1+8XDHBE+3lZA85f+wn2r2G3+EYD9VjS90="
}, {
    "num_cand": "U2FsdGVkX1/dyfgGlCF5AXE9AvVKedk+fBDLx7zAq94=",
    "cpf": "U2FsdGVkX1+AcVpCplgUlifH/KrOFgD+QwXXg11dq6s="
}, {
    "num_cand": "U2FsdGVkX18M5RQ67eh9ijjJ/t33fHyFBQ3AaxzpcTI=",
    "cpf": "U2FsdGVkX1+THdW+hFI68tazQnxmf4ANyYBa1Ecg8yk="
}, {
    "num_cand": "U2FsdGVkX1/7KoD3LNO8zVOo7eFMEiiDComrgrZHlHY=",
    "cpf": "U2FsdGVkX1/GlxWDU2kkH6/U3t7/W/uOxM/AMljtnIc="
}, {
    "num_cand": "U2FsdGVkX19jaIKzSytDKFInNXku7WjVQrot6IBP7Mg=",
    "cpf": "U2FsdGVkX1//glei7HaamojE714aMSk35j55hlkrsxs="
}, {
    "num_cand": "U2FsdGVkX1+jyRJtXEJoztTIHBZ7nZE9xXM3FIN9RlE=",
    "cpf": "U2FsdGVkX19u1s0h1POWU9o/+i0JZ8s18V0DOlVORE0="
}, {
    "num_cand": "U2FsdGVkX18uJkP/FKxfMPwOEkeg9ZjjN9l3ESBUfpQ=",
    "cpf": "U2FsdGVkX1/MHydpCeaCFX8Lag7lnLR2uyABYFPMeqo="
}, {
    "num_cand": "U2FsdGVkX18Jh8jDOhoaTrJKHftM8V3f/mYrMt27DpM=",
    "cpf": "U2FsdGVkX1+aOxfTdqjfuteBPoiz03YO7DJawWFkqWo="
}, {
    "num_cand": "U2FsdGVkX1/8SZxAvkPQqYB2r3oK2q4KkG3M0iRfalg=",
    "cpf": "U2FsdGVkX1+fxXAcRuhhZIRuWNlBX5j0dSnDOR/9SA8="
}, {
    "num_cand": "U2FsdGVkX19lQvuHdn5/dYWDVRjbIF4YSp58RlNN8NI=",
    "cpf": "U2FsdGVkX19G6fkc7tVuvtAhvW1hy1w9iw+rMgXGuIo="
}, {
    "num_cand": "U2FsdGVkX1/NH7Gg7m62S/TujosJJx7f0uGrHlwEA3A=",
    "cpf": "U2FsdGVkX1/h+trlRKUI6E94roIxYp7ZYZhgzi2EqTk="
}, {
    "num_cand": "U2FsdGVkX1+r1/aru/uIJ1JozfzbxubhgmXPBg2e6ok=",
    "cpf": "U2FsdGVkX19JbDQnqpGm9AVxysc6yt7ROaskMZ8/dGg="
}, {
    "num_cand": "U2FsdGVkX1+L4jwnJYORaZdiARux2Yqc6RWMUr8Hvio=",
    "cpf": "U2FsdGVkX19qxuyIpRZWUJjcIuVVPeGvoOhz3AmUmRk="
}, {
    "num_cand": "U2FsdGVkX19ux0N9/TFqzzgtkECYjjOsDaLpBjFcVNo=",
    "cpf": "U2FsdGVkX1+Z4e0EAPgj6wakgo6AZfGBa96WIYx4YA8="
}, {
    "num_cand": "U2FsdGVkX18/7xxIovwUjT4g3eEUnFqPPSvGqXe5jxk=",
    "cpf": "U2FsdGVkX18MWLBoN4McKxWFYjii2gSmKr2LYxfTTlg="
}, {
    "num_cand": "U2FsdGVkX18awGp481xOGhsb+92Zh58Sr0Gje8prBH0=",
    "cpf": "U2FsdGVkX18J0kOTx46WRufUC6LlpJPsoPlET4Y81hQ="
}, {
    "num_cand": "U2FsdGVkX1/HGeCz95sup5zBoEHTe6LxRnU86LFGyfY=",
    "cpf": "U2FsdGVkX180raU95Gt9z06aw2T9bo2eZYCG47154Sk="
}, {
    "num_cand": "U2FsdGVkX1+v5reImSBxLuFcJL6ZWoHAfqQAbuVt3tY=",
    "cpf": "U2FsdGVkX198btdf7cGAbWUzCxTtef+v1LNKWTMNquM="
}, {
    "num_cand": "U2FsdGVkX1+Pd6CIse8rXXt3NPcKTayVgEI+gRpPKss=",
    "cpf": "U2FsdGVkX1/5vmvEpAMvlwhLczp8XgZ59hHto7y9uyA="
}, {
    "num_cand": "U2FsdGVkX1/O+1hE6VDHGYicoipvYJhbwfubHD/vjco=",
    "cpf": "U2FsdGVkX19lOARmsjTToBHP3fHEtAHxJtcsuJHJq5I="
}, {
    "num_cand": "U2FsdGVkX19Gqd7hk3Z5jCOpgXiT4NQU/h5uRHNrj5U=",
    "cpf": "U2FsdGVkX18bD3XgARmUpZWsS923krDbQ84jCdhr5qY="
}, {
    "num_cand": "U2FsdGVkX19sROzTbvQsB0Mh0cU1Z70+FdCt2g+UqtU=",
    "cpf": "U2FsdGVkX19ZI485l+CnENP9udquPfo/o05ybiT4lqk="
}, {
    "num_cand": "U2FsdGVkX19nUgCxWuJRrCmHMgc0YMnqhqiSCNLykKo=",
    "cpf": "U2FsdGVkX199J8kEdizdHoUu4J+zFNUekOZKbCfHWvY="
}, {
    "num_cand": "U2FsdGVkX18K3CdClRqUsqkfy1ot+ENNjcS1Qr3qT0g=",
    "cpf": "U2FsdGVkX18aVobSlkZjeBbFRHfLU/0QTTm/4JmDAec="
}, {
    "num_cand": "U2FsdGVkX1/lG76Dl5yNOqO54Vg6XQMhDHdbXUTyZeU=",
    "cpf": "U2FsdGVkX1942a5/yVd8bRGaEJBzoNOvqgCjfZnPsZA="
}, {
    "num_cand": "U2FsdGVkX1+cPJD/397m9Ut+cp0LpJ1zbMSgk1bcPGM=",
    "cpf": "U2FsdGVkX19JkCsDhed76U+MFAu7NK4KB0NdFwoWfK4="
}, {
    "num_cand": "U2FsdGVkX1+7slllaxXKhiiPkNF6mxHvKxavXUgIfIA=",
    "cpf": "U2FsdGVkX18pkzs2GnkHeHvNclWQZchGVX/ZZTMNqi4="
}, {
    "num_cand": "U2FsdGVkX1/KgEIlICh9jpkk3rq8uDjJzdAqKmI1ibc=",
    "cpf": "U2FsdGVkX19xiYDpHwzXyI21quIXAynMfhX1zJ2MrbM="
}, {
    "num_cand": "U2FsdGVkX18n7fYJUICbn0RX1k1tFzzF1cr2MgRy1fA=",
    "cpf": "U2FsdGVkX19NOx74zmyzvPyZVPhwQfxIL5qd64SUVTo="
}, {
    "num_cand": "U2FsdGVkX18C+DY+OW81McNGaHBWtze6IWeKSkHjd80=",
    "cpf": "U2FsdGVkX18GSZGyRAjR8MmwUpbmdGnaj6HQ2nWTJ9k="
}, {
    "num_cand": "U2FsdGVkX1+9e/OozadeYCSCfP4ezEOgzH4rZSNRN8Y=",
    "cpf": "U2FsdGVkX1+hCCj0ibPLPLBbN22F75TrkD9Dvge+l9c="
}, {
    "num_cand": "U2FsdGVkX1/aDWsrRznODKtrAWswomhnftgNta0EWb8=",
    "cpf": "U2FsdGVkX1+v+p+HpR88g+SHguTAXFh39L25QoG4+hQ="
}, {
    "num_cand": "U2FsdGVkX195Dc6/5XaFxFHUL+zOkmBPiGPLN77zvc0=",
    "cpf": "U2FsdGVkX1+jJsqeirBMy/291ulrLuNW6Gt/LejjM/8="
}, {
    "num_cand": "U2FsdGVkX19mm0OUvxXxXTyyJ8fO57lCjmRjfsNuKCQ=",
    "cpf": "U2FsdGVkX19uX9eeEnrAwWAfnFibz7QbakryKrWPaNY="
}, {
    "num_cand": "U2FsdGVkX19Y8abmkXrH4wx9ZiOm1TCIRkGlwb/nTkY=",
    "cpf": "U2FsdGVkX1+0pl8yRWnitjaDK7GZv03a52nHdiKvJAw="
}, {
    "num_cand": "U2FsdGVkX1+kYdpT9CV3NtoQ963HsjJO/49mq+Lg6VQ=",
    "cpf": "U2FsdGVkX1+58J/g0yRVVmznPa7V+wU1SGX1UZ7D3E4="
}, {
    "num_cand": "U2FsdGVkX1+Ma5Q3ES6O/kzZuD9V+nT5W3aLLdQs9O8=",
    "cpf": "U2FsdGVkX19UfwDK8PjQzKHhSw6I4BQGk3BkeWf+xTY="
}, {
    "num_cand": "U2FsdGVkX1+v084wnpL77VjjUK9zRNgEVOEtfXgZHnc=",
    "cpf": "U2FsdGVkX1/ylwQLo97V8Rj8YMHCwYit0j5olmyNSQI="
}, {
    "num_cand": "U2FsdGVkX1+LQlMjCg+rOuQ2mg544aLEDSI+fyTWHyE=",
    "cpf": "U2FsdGVkX1/r/QtMx8uayEP0cZjTyUz+LaWdnkraHtU="
}, {
    "num_cand": "U2FsdGVkX1/CtOvXWgau+Qt4MFs6mmxaebdAKWOHL5U=",
    "cpf": "U2FsdGVkX19DBecADadpqg3iMUJdxtWb+wUZEwkj5uQ="
}, {
    "num_cand": "U2FsdGVkX1+EfLHIln7utwiyYplF75yW3ef2GjJ3dkg=",
    "cpf": "U2FsdGVkX18o31/EpYrxJsXur4LQEUWXVkyk0FeLZx4="
}, {
    "num_cand": "U2FsdGVkX1/Tac1UxHvOuLAzUcs0m9gfOjNY5WlmlXk=",
    "cpf": "U2FsdGVkX1+VSRJ+aK3W7DnvxoAxTWjOYGDlqUgbcYk="
}, {
    "num_cand": "U2FsdGVkX18MOlbkIr0nHEyb8ZZZuxJJy2/gZE6W74s=",
    "cpf": "U2FsdGVkX1+IQty4IhRmYDvuyfmsTUDEd/hvO0ksHUs="
}, {
    "num_cand": "U2FsdGVkX1/NfISEMSeqCBXSH0YYPkkgsK0uSbrRSEY=",
    "cpf": "U2FsdGVkX1/KAQLGy7/kHCkSGpRMo/aVc6llDRyIOrk="
}, {
    "num_cand": "U2FsdGVkX1+UxkuX322CJUHGCCozVVnFdGmGhMjq5g0=",
    "cpf": "U2FsdGVkX1/3HsG8nBhO2/GBpwsONsZKsLrh/spuiqU="
}, {
    "num_cand": "U2FsdGVkX1/hIex2vVG90ZhuIUQ4QJhQHWwRlf7Jr/8=",
    "cpf": "U2FsdGVkX1+jHMmstYYWdHrnpm5GsmSK3K747UD1cBE="
}, {
    "num_cand": "U2FsdGVkX1/RHBhS9frWlfXvOOp9+qDjTlkz9ZbBEkQ=",
    "cpf": "U2FsdGVkX18dvsiDOSFS4s5o6cFTPCD052ahQrtG3tg="
}, {
    "num_cand": "U2FsdGVkX1/ezXNCE5tKXqYkzp+n7o52jHa4rInU4bQ=",
    "cpf": "U2FsdGVkX18exZdTgWlWdFhYGT+T8eiuYK6z1QORG6I="
}, {
    "num_cand": "U2FsdGVkX1+nrUvDdP6exMT4+H3LuM1SCryRzVH8Faw=",
    "cpf": "U2FsdGVkX1/qagd23QSoe2cymTUDWWN02M5lDjbvcPY="
}, {
    "num_cand": "U2FsdGVkX1+cFIxK2zPsoRdhrirWJopK7sEtaIdRVrU=",
    "cpf": "U2FsdGVkX1+USH6+/DvqBdzd7qmWrwUBYVGeCN0wTKM="
}, {
    "num_cand": "U2FsdGVkX1+Mv6AcHUS2d1zJEOfQ3YTU9K/teGu1Rfk=",
    "cpf": "U2FsdGVkX18ytbLw9LNCWzwcHIXZGKSrzA1T23eodgI="
}, {
    "num_cand": "U2FsdGVkX18G4RoDDQi2qyd499+nInMxv3LOwVdvr5o=",
    "cpf": "U2FsdGVkX19FFnV+3eOorTCYkw/hB2z9bWtPv2+wmGA="
}, {
    "num_cand": "U2FsdGVkX1+hUsRnWyfjNeIW7l6JetpnUmia10OeJB0=",
    "cpf": "U2FsdGVkX19Tkq8GyiZMcUIAr2Pbqvn9QgwnYuOP+ac="
}, {
    "num_cand": "U2FsdGVkX18l5ckN2+bl6PXWoQqpKVgN30A2rChdT9M=",
    "cpf": "U2FsdGVkX18zOjAmfBva7YBVYBIB4q9SzU/Uz/I7l0k="
}, {
    "num_cand": "U2FsdGVkX18X16LDktXHvG3MdG7hDnibfgc+ajbvFfw=",
    "cpf": "U2FsdGVkX1+iaYELD5r8FfcZy0CZbvwVG9mMuBYXpjQ="
}, {
    "num_cand": "U2FsdGVkX1+SIgsa669gSnf83sOPwj2K/FQDlpcNef0=",
    "cpf": "U2FsdGVkX1+NToSy3ZMBq69OBAyly1zWgVBWE5U9KHU="
}, {
    "num_cand": "U2FsdGVkX19PdbngbHLdGtDfzAopnskh/IjNE5eybGE=",
    "cpf": "U2FsdGVkX18VGsvVmBwqj3gcrsM7WYFJtpcO2uf5jXc="
}, {
    "num_cand": "U2FsdGVkX1+dqGYwlYAJOxreWOH7PHddSR6tytWDXQ8=",
    "cpf": "U2FsdGVkX18U+vLj8hzZNbPaWJGij784faX3/l/etsU="
}, {
    "num_cand": "U2FsdGVkX18VpIXylsABIk8+VC5waEveGwD0ipRfQyE=",
    "cpf": "U2FsdGVkX19xtEGyWRKjGMo18/2VNLpBC65vG/tnfi0="
}, {
    "num_cand": "U2FsdGVkX1/iCsMO9GS+r+ib1ElrfVU0ZGWe5/A0rHU=",
    "cpf": "U2FsdGVkX19ES06+tirhBNK57s+DB9LzGGUiWGT6TlY="
}, {
    "num_cand": "U2FsdGVkX19//WVJUGutERzq7htSI0BKW6o/PFn7OWc=",
    "cpf": "U2FsdGVkX1+BvTSv222reRpGy2VZqykE/wPmTRSKLlc="
}, {
    "num_cand": "U2FsdGVkX188oL0ZtJu1PvJAj21qhu/lYOGXFYg1O8M=",
    "cpf": "U2FsdGVkX18XzmtzziRQXNv40T+MnlnPVuVYGAlOAqU="
}, {
    "num_cand": "U2FsdGVkX18rIHGRVvrO6RIZMivXZcuQFJgPNbmVwtY=",
    "cpf": "U2FsdGVkX18Rzo9OsFEyjdC4Ndy2U0Qyu/61t9Jd3Ms="
}, {
    "num_cand": "U2FsdGVkX18HsRrANkLBDZ/TRNluZUjJ9KN2qmzoyxY=",
    "cpf": "U2FsdGVkX1+iuwWE5fs/7yHt7qNLQwQEQgWaORFgOpc="
}, {
    "num_cand": "U2FsdGVkX19HYqDKOfXvdPDFFBvyvZ0gGSDuz5nojK4=",
    "cpf": "U2FsdGVkX18sC1yMx+n5W6GXobsIArHA0PcbtbX8xWQ="
}, {
    "num_cand": "U2FsdGVkX191mJdEwxL+BV1RMhcOTWELTOVORT8r7X8=",
    "cpf": "U2FsdGVkX1/uUZIAp57u9h7bzpuSI7l7XeoL2qH8zQE="
}, {
    "num_cand": "U2FsdGVkX182Z9rmPtkG5sa9B1uDmaNhJeIbXERS4JI=",
    "cpf": "U2FsdGVkX1+BfE4JziuRlWJ8oaCWLwEg79f10wEYmD8="
}, {
    "num_cand": "U2FsdGVkX19sYBj7KT5gN9z9O0pjUnR7wlmHvklo0Vc=",
    "cpf": "U2FsdGVkX18pmTKLZOmqNmCbSYfurbSZn/cKF0oIVuA="
}, {
    "num_cand": "U2FsdGVkX1+wqqxG37OKHKtUXyC/hDeTFlORInOY/fk=",
    "cpf": "U2FsdGVkX1+EMMXeItwbb69lP9VuPlw6DtqQawrQ+LY="
}, {
    "num_cand": "U2FsdGVkX19/V+r4MFkrtxy11cfQyGpTsrRfs6XiG+0=",
    "cpf": "U2FsdGVkX1+jmToJpNIxxchQDIQCjYTa0oISPJirrTQ="
}, {
    "num_cand": "U2FsdGVkX1+QaaIXwiIyOYQ9peNHRE8yicm8PpZeq3Q=",
    "cpf": "U2FsdGVkX186syiUqGmD4w5Rq1dKglDsP3RJTHBtM0M="
}, {
    "num_cand": "U2FsdGVkX1/k6pOwrwhZCbYP/FMIgzLrMGgQSZHQ7L8=",
    "cpf": "U2FsdGVkX1+W7HFSVkxyvcl+9P1BNRKQ0himQ948194="
}, {
    "num_cand": "U2FsdGVkX1/C1+HwTBdx4FhULOPch0vEfZk4jXp2LA0=",
    "cpf": "U2FsdGVkX18CIQ3wy5ciH7/rYynr8j8cDK7IOw8T/ok="
}, {
    "num_cand": "U2FsdGVkX19/RI3tqhTqNz29CX/+8OcLz2HoGbibPY4=",
    "cpf": "U2FsdGVkX193lAHOit/XR67oEB489qvhQsj9QXLiutw="
}, {
    "num_cand": "U2FsdGVkX1+qaAhhKmSpeN/7ga7DY5KgJLwW/XxSai4=",
    "cpf": "U2FsdGVkX1+Z3w5XoTmTRfBGXo3DTtcrgzaExiI3Sng="
}, {
    "num_cand": "U2FsdGVkX1/0SBIJPx5NdicSbpnFqvLxgeYUzMtpx1s=",
    "cpf": "U2FsdGVkX18cgggGXzOl5OwoForO11m9NGjtNB1FAo8="
}, {
    "num_cand": "U2FsdGVkX1+gUKl3x/Fxp9nQmsI/uUtmTNDRBRlHT6E=",
    "cpf": "U2FsdGVkX18/WhTzMQ/rMUHL7QIkEJsvt0KNzD1h2cA="
}, {
    "num_cand": "U2FsdGVkX19oYRD+E0rgblGpScQJR4NRNyZ1k2xpIRE=",
    "cpf": "U2FsdGVkX18ioR6SvWACXRHJjxQrvgTlCf32Qfvi4Dw="
}, {
    "num_cand": "U2FsdGVkX1+oi491nCW4OelImzYsG12Dhl0hT9uL4ig=",
    "cpf": "U2FsdGVkX18lAPG3i82IW8/f79GNmt3gS3NxX/yMtkg="
}, {
    "num_cand": "U2FsdGVkX19uesMA7LGSCpIImDDMDqvpW4BGQDukfyM=",
    "cpf": "U2FsdGVkX1/gZxlzJni+I9hUkOMMDGLAK5Yk0mbWuQg="
}, {
    "num_cand": "U2FsdGVkX18TpiNwS//vqGdxHG8/qWkNmmBNCVto1X0=",
    "cpf": "U2FsdGVkX1+xIX6vZKKsFFxdH12RwsSiLLYCp+lGD/c="
}, {
    "num_cand": "U2FsdGVkX1/s2FLZTQ/ZvFlt3yBVeZWKJRORAd7wjec=",
    "cpf": "U2FsdGVkX19J3EZCoL3ShGF2S9UPDautP/Im89b9QVI="
}, {
    "num_cand": "U2FsdGVkX19IA2tLkyn1sARzqFC0/segVzSxUVNyiwY=",
    "cpf": "U2FsdGVkX18QFMMDaUvhoWZ3KazLaVJw9s3fAjzBr6o="
}, {
    "num_cand": "U2FsdGVkX1//AiD+onDQPprA6z1ULa0lo4j8nXUJL8U=",
    "cpf": "U2FsdGVkX1/+uEg2LWFO991CbN5W7dBiVzesEiMgQVg="
}, {
    "num_cand": "U2FsdGVkX18jwic2DT22Ag7usVKRmn+iocO9wou32LU=",
    "cpf": "U2FsdGVkX1+BE46T3vk9CnzgWE8w0hzOU1JgghFzDEw="
}, {
    "num_cand": "U2FsdGVkX1/nKyOduIGnbuY1lLw/UEwsB5KSf0LkwJk=",
    "cpf": "U2FsdGVkX191k9jWYx3uYTbkOH4TSj6xKQsGdxPIEUY="
}, {
    "num_cand": "U2FsdGVkX187SlJ83QdlHtgfFV3vFeYuZkBFYzjLcH0=",
    "cpf": "U2FsdGVkX19HYXy2HIxIkw/m5dhHJCTdu6xFLg2mnXY="
}, {
    "num_cand": "U2FsdGVkX1/4oAmiLN6DFt29BvtFipcb53cYXU+uU9I=",
    "cpf": "U2FsdGVkX1/YpRn16czKUObjr913jP23ZjPU5vNufU8="
}, {
    "num_cand": "U2FsdGVkX1/gwSbBYbmBHqZ5isnrstQ49vzJSfo0m8I=",
    "cpf": "U2FsdGVkX1/mZpLVWVJXCtGuQFC7AVlzZ5RvITIfO0g="
}, {
    "num_cand": "U2FsdGVkX18nuJxe+PDIJioIyCWB33LvFr3Zd7/IFEQ=",
    "cpf": "U2FsdGVkX1/wcI3unxo3ZzsLnULAsvM7kPxUAuOtX0M="
}, {
    "num_cand": "U2FsdGVkX1851y4Mlp0Ry9lt298H2sLhq1qYwX3RgXE=",
    "cpf": "U2FsdGVkX1+rnDkY67KZHtVe3QptqV6g8YRKszPHzTs="
}, {
    "num_cand": "U2FsdGVkX19X6KK8wWfgol6Xv9Jo5/TLhRHGOvgKsig=",
    "cpf": "U2FsdGVkX1+BMs+3yjgtRNXU22HffN0SFhhfNK++J/Y="
}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2204/disc/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
